
function dogBreedData(){
    return([
        {
          "Pet Breed": "Aidi"
        },
        {
          "Pet Breed": "Alano Español"
        },
        {
          "Pet Breed": "Alapaha Blue Blood Bulldog"
        },
        {
          "Pet Breed": "Alpine Dachsbracke"
        },
        {
          "Pet Breed": "American Bully"
        },
        {
          "Pet Breed": "Anglo-Français de Petite Vénerie"
        },
        {
          "Pet Breed": "Appenzeller Sennenhund"
        },
        {
          "Pet Breed": "Ariege Pointer"
        },
        {
          "Pet Breed": "Ariegeois"
        },
        {
          "Pet Breed": "Armant"
        },
        {
          "Pet Breed": "Armenian Gampr Dog"
        },
        {
          "Pet Breed": "Artois Hound"
        },
        {
          "Pet Breed": "Australian Kelpie"
        },
        {
          "Pet Breed": "Australian Stumpy Tail Cattle Dog"
        },
        {
          "Pet Breed": "Austrian Black and Tan Hound"
        },
        {
          "Pet Breed": "Austrian Pinscher"
        },
        {
          "Pet Breed": "Bakharwal Dog"
        },
        {
          "Pet Breed": "Banjara Hound"
        },
        {
          "Pet Breed": "Basset Artésien Normand"
        },
        {
          "Pet Breed": "Basset Bleu de Gascogne"
        },
        {
          "Pet Breed": "Basset Fauve de Bretagne"
        },
        {
          "Pet Breed": "Bavarian Mountain Hound"
        },
        {
          "Pet Breed": "Beagle-Harrier"
        },
        {
          "Pet Breed": "Belgian Shepherd Dog (Laekenois)"
        },
        {
          "Pet Breed": "Bergamasco Shepherd"
        },
        {
          "Pet Breed": "Berger Picard"
        },
        {
          "Pet Breed": "Billy"
        },
        {
          "Pet Breed": "Black Norwegian Elkhound"
        },
        {
          "Pet Breed": "Blue Picardy Spaniel"
        },
        {
          "Pet Breed": "Boerboel"
        },
        {
          "Pet Breed": "Bohemian Shepherd"
        },
        {
          "Pet Breed": "Bolognese"
        },
        {
          "Pet Breed": "Briquet Griffon Vendéen"
        },
        {
          "Pet Breed": "Broholmer"
        },
        {
          "Pet Breed": "Bruno Jura Hound"
        },
        {
          "Pet Breed": "Bucovina Shepherd Dog"
        },
        {
          "Pet Breed": "Bully Kutta"
        },
        {
          "Pet Breed": "Cão da Serra de Aires"
        },
        {
          "Pet Breed": "Cão de Castro Laboreiro"
        },
        {
          "Pet Breed": "Cão Fila de São Miguel"
        },
        {
          "Pet Breed": "Carpathian Shepherd Dog"
        },
        {
          "Pet Breed": "Catalburun"
        },
        {
          "Pet Breed": "Caucasian Shepherd Dog"
        },
        {
          "Pet Breed": "Central Asian Shepherd Dog"
        },
        {
          "Pet Breed": "Cesky Fousek"
        },
        {
          "Pet Breed": "Chien Français Blanc et Noir"
        },
        {
          "Pet Breed": "Chien Français Blanc et Orange"
        },
        {
          "Pet Breed": "Chien Français Tricolore"
        },
        {
          "Pet Breed": "Chinook"
        },
        {
          "Pet Breed": "Cimarrón Uruguayo"
        },
        {
          "Pet Breed": "Combai"
        },
        {
          "Pet Breed": "Cretan Hound"
        },
        {
          "Pet Breed": "Cumberland Sheepdog"
        },
        {
          "Pet Breed": "Cursinu"
        },
        {
          "Pet Breed": "Czechoslovakian Wolfdog"
        },
        {
          "Pet Breed": "Danish-Swedish Farmdog"
        },
        {
          "Pet Breed": "Dogo Canario"
        },
        {
          "Pet Breed": "Dogo Guatemalteco"
        },
        {
          "Pet Breed": "Drentse Patrijshond"
        },
        {
          "Pet Breed": "Drever"
        },
        {
          "Pet Breed": "East Siberian Laika"
        },
        {
          "Pet Breed": "Estonian Hound"
        },
        {
          "Pet Breed": "Estrela Mountain Dog"
        },
        {
          "Pet Breed": "Eurasier"
        },
        {
          "Pet Breed": "Finnish Hound"
        },
        {
          "Pet Breed": "Finnish Lapphund"
        },
        {
          "Pet Breed": "French Spaniel"
        },
        {
          "Pet Breed": "Gascon Saintongeois"
        },
        {
          "Pet Breed": "German Hound"
        },
        {
          "Pet Breed": "German Longhaired Pointer"
        },
        {
          "Pet Breed": "German Spaniel"
        },
        {
          "Pet Breed": "Grand Anglo-Français Blanc et Noir"
        },
        {
          "Pet Breed": "Grand Anglo-Français Blanc et Orange"
        },
        {
          "Pet Breed": "Grand Anglo-Français Tricolore"
        },
        {
          "Pet Breed": "Grand Basset Griffon Vendéen"
        },
        {
          "Pet Breed": "Grand Bleu de Gascogne"
        },
        {
          "Pet Breed": "Grand Gascon Saintongeois"
        },
        {
          "Pet Breed": "German Hound (Deutsche Bracke)"
        },
        {
          "Pet Breed": "German Spaniel (Deutscher Wachtelhund)"
        },
        {
          "Pet Breed": "Greek Harehound"
        },
        {
          "Pet Breed": "Griffon Bleu de Gascogne"
        },
        {
          "Pet Breed": "Griffon Fauve de Bretagne"
        },
        {
          "Pet Breed": "Griffon Nivernais"
        },
        {
          "Pet Breed": "Halden Hound"
        },
        {
          "Pet Breed": "Hamiltonstövare"
        },
        {
          "Pet Breed": "Hanoverian Scenthound"
        },
        {
          "Pet Breed": "Harrier"
        },
        {
          "Pet Breed": "Hokkaido"
        },
        {
          "Pet Breed": "Hovawart"
        },
        {
          "Pet Breed": "Hygen Hound"
        },
        {
          "Pet Breed": "Icelandic Sheepdog"
        },
        {
          "Pet Breed": "Irish Red and White Setter"
        },
        {
          "Pet Breed": "Istrian Coarse-haired Hound"
        },
        {
          "Pet Breed": "Istrian Short-haired Hound"
        },
        {
          "Pet Breed": "Italian Greyhound"
        },
        {
          "Pet Breed": "Jagdterrier"
        },
        {
          "Pet Breed": "Japanese Chin"
        },
        {
          "Pet Breed": "Japanese Spitz"
        },
        {
          "Pet Breed": "Jindo"
        },
        {
          "Pet Breed": "Kai Ken"
        },
        {
          "Pet Breed": "Kangal Shepherd Dog"
        },
        {
          "Pet Breed": "Karelian Bear Dog"
        },
        {
          "Pet Breed": "Kishu Ken"
        },
        {
          "Pet Breed": "Kromfohrländer"
        },
        {
          "Pet Breed": "Kuchi (Afghan Shepherd)"
        },
        {
          "Pet Breed": "Lagotto Romagnolo"
        },
        {
          "Pet Breed": "Lakeland Terrier"
        },
        {
          "Pet Breed": "Lancashire Heeler"
        },
        {
          "Pet Breed": "Lapponian Herder"
        },
        {
          "Pet Breed": "Leonberger"
        },
        {
          "Pet Breed": "Löwchen"
        },
        {
          "Pet Breed": "Lundehund"
        },
        {
          "Pet Breed": "Magyar Agár"
        },
        {
          "Pet Breed": "Majorca Shepherd Dog"
        },
        {
          "Pet Breed": "Maltese"
        },
        {
          "Pet Breed": "Manchester Terrier"
        },
        {
          "Pet Breed": "Maremma Sheepdog"
        },
        {
          "Pet Breed": "Mudi"
        },
        {
          "Pet Breed": "Neapolitan Mastiff"
        },
        {
          "Pet Breed": "Norrbottenspets"
        },
        {
          "Pet Breed": "Norwegian Buhund"
        },
        {
          "Pet Breed": "Norwegian Elkhound Black"
        },
        {
          "Pet Breed": "Norwegian Lundehund"
        },
        {
          "Pet Breed": "Old Danish Pointer"
        },
        {
          "Pet Breed": "Otterhound"
        },
        {
          "Pet Breed": "Papillon"
        },
        {
          "Pet Breed": "Parson Russell Terrier"
        },
        {
          "Pet Breed": "Perro de Presa Canario"
        },
        {
          "Pet Breed": "Perro de Presa Mallorquin"
        },
        {
          "Pet Breed": "Peruvian Hairless Dog"
        },
        {
          "Pet Breed": "Pharaoh Hound"
        },
        {
          "Pet Breed": "Picardy Spaniel"
        },
        {
          "Pet Breed": "Plott Hound"
        },
        {
          "Pet Breed": "Podenco Canario"
        },
        {
          "Pet Breed": "Podenco Ibicenco"
        },
        {
          "Pet Breed": "Polish Greyhound"
        },
        {
          "Pet Breed": "Polish Hound"
        },
        {
          "Pet Breed": "Polish Lowland Sheepdog"
        },
        {
          "Pet Breed": "Polish Tatra Sheepdog"
        },
        {
          "Pet Breed": "Porcelaine"
        },
        {
          "Pet Breed": "Portuguese Podengo"
        },
        {
          "Pet Breed": "Portuguese Pointer"
        },
        {
          "Pet Breed": "Portuguese Sheepdog"
        },
        {
          "Pet Breed": "Portuguese Water Dog"
        },
        {
          "Pet Breed": "Pudelpointer"
        },
        {
          "Pet Breed": "Pumi"
        },
        {
          "Pet Breed": "Pyrenean Mastiff"
        },
        {
          "Pet Breed": "Pyrenean Shepherd"
        },
        {
          "Pet Breed": "Rafeiro do Alentejo"
        },
        {
          "Pet Breed": "Rajapalayam"
        },
        {
          "Pet Breed": "Rampur Greyhound"
        },
        {
          "Pet Breed": "Rastreador Brasileiro"
        },
        {
          "Pet Breed": "Ratonero Bodeguero"
        },
        {
          "Pet Breed": "Montenegrin Mountain Hound"
        },
        {
          "Pet Breed": "Moscow Watchdog"
        },
        {
          "Pet Breed": "Moscow Water Dog"
        },
        {
          "Pet Breed": "Mudhol Hound"
        },
        {
          "Pet Breed": "Old Croatian Sighthound"
        },
        {
          "Pet Breed": "Perdigueiro Português (Portuguese Pointer)"
        },
        {
          "Pet Breed": "Peruvian Inca Orchid"
        },
        {
          "Pet Breed": "Petit Bleu de Gascogne"
        },
        {
          "Pet Breed": "Petit Gascon Saintongeois"
        },
        {
          "Pet Breed": "Phalène"
        },
        {
          "Pet Breed": "Poitevin"
        },
        {
          "Pet Breed": "Portuguese Sheepdog (Cão da Serra de Aires)"
        },
        {
          "Pet Breed": "Ratonero Bodeguero Andaluz"
        },
        {
          "Pet Breed": "Russian Spaniel"
        },
        {
          "Pet Breed": "Russian Toy"
        },
        {
          "Pet Breed": "Saarloos Wolfdog"
        },
        {
          "Pet Breed": "Sabueso Español"
        },
        {
          "Pet Breed": "Saint-Usuge Spaniel"
        },
        {
          "Pet Breed": "Sakhalin Husky"
        },
        {
          "Pet Breed": "Schapendoes"
        },
        {
          "Pet Breed": "Schillerstövare"
        },
        {
          "Pet Breed": "Segugio Italiano"
        },
        {
          "Pet Breed": "Serbian Hound"
        },
        {
          "Pet Breed": "Serbian Tricolour Hound"
        },
        {
          "Pet Breed": "Shikoku"
        },
        {
          "Pet Breed": "Silken Windhound"
        },
        {
          "Pet Breed": "Slovak Cuvac"
        },
        {
          "Pet Breed": "Slovakian Hound"
        },
        {
          "Pet Breed": "Sloughi"
        },
        {
          "Pet Breed": "Smålandsstövare"
        },
        {
          "Pet Breed": "South Russian Ovcharka"
        },
        {
          "Pet Breed": "Spanish Mastiff"
        },
        {
          "Pet Breed": "Spanish Water Dog"
        },
        {
          "Pet Breed": "Stabyhoun"
        },
        {
          "Pet Breed": "Styrian Coarse-haired Hound"
        },
        {
          "Pet Breed": "Swedish Elkhound"
        },
        {
          "Pet Breed": "Swedish Lapphund"
        },
        {
          "Pet Breed": "Swedish Vallhund"
        },
        {
          "Pet Breed": "Tamaskan Dog"
        },
        {
          "Pet Breed": "Teddy Roosevelt Terrier"
        },
        {
          "Pet Breed": "Tervuren (Belgian Shepherd - not separate in AKC)"
        },
        {
          "Pet Breed": "Tibetan Mastiff"
        },
        {
          "Pet Breed": "Tornjak"
        },
        {
          "Pet Breed": "Tosa Inu"
        },
        {
          "Pet Breed": "Transylvanian Hound"
        },
        {
          "Pet Breed": "Treeing Tennessee Brindle"
        },
        {
          "Pet Breed": "Tyrolean Hound"
        },
        {
          "Pet Breed": "Villano de Las Encartaciones"
        },
        {
          "Pet Breed": "Weisshaariger Ungarischer Vorstehhund"
        },
        {
          "Pet Breed": "Westphalian Dachsbracke"
        },
        {
          "Pet Breed": "Yakutian Laika"
        },
        {
          "Pet Breed": "Affenpinscher"
        },
        {
          "Pet Breed": "Afghan Hound"
        },
        {
          "Pet Breed": "Airedale Terrier"
        },
        {
          "Pet Breed": "Akita"
        },
        {
          "Pet Breed": "Alaskan Malamute"
        },
        {
          "Pet Breed": "Anatolian Shepherd Dog"
        },
        {
          "Pet Breed": "Australian Cattle Dog"
        },
        {
          "Pet Breed": "Australian Shepherd"
        },
        {
          "Pet Breed": "Australian Silky Terrier"
        },
        {
          "Pet Breed": "Australian Terrier"
        },
        {
          "Pet Breed": "Azawakh (Imp)"
        },
        {
          "Pet Breed": "Barbet (Imp)"
        },
        {
          "Pet Breed": "Basenji"
        },
        {
          "Pet Breed": "Basset Bleu De Gascogne (Imp)"
        },
        {
          "Pet Breed": "Basset Griffon Vendeen (Grand)"
        },
        {
          "Pet Breed": "Basset Griffon Vendeen (Petit)"
        },
        {
          "Pet Breed": "Basset Hound"
        },
        {
          "Pet Breed": "Beagle"
        },
        {
          "Pet Breed": "Bearded Collie"
        },
        {
          "Pet Breed": "Beauceron"
        },
        {
          "Pet Breed": "Bedlington Terrier"
        },
        {
          "Pet Breed": "Belgian Shepherd Dog (Groenendael)"
        },
        {
          "Pet Breed": "Belgian Shepherd Dog (Malinois)"
        },
        {
          "Pet Breed": "Belgian Shepherd Dog (Tervueren)"
        },
        {
          "Pet Breed": "Bergamasco (Imp)"
        },
        {
          "Pet Breed": "Bernese Mountain Dog"
        },
        {
          "Pet Breed": "Bichon Frise"
        },
        {
          "Pet Breed": "Black & Tan Coonhound (Imp)"
        },
        {
          "Pet Breed": "Bloodhound"
        },
        {
          "Pet Breed": "Border Collie"
        },
        {
          "Pet Breed": "Border Terrier"
        },
        {
          "Pet Breed": "Borzoi"
        },
        {
          "Pet Breed": "Boston Terrier"
        },
        {
          "Pet Breed": "Bouvier Des Flandres"
        },
        {
          "Pet Breed": "Boxer"
        },
        {
          "Pet Breed": "Bracco Italiano"
        },
        {
          "Pet Breed": "Braque D’Auvergne (Imp)"
        },
        {
          "Pet Breed": "Briard"
        },
        {
          "Pet Breed": "Brittany"
        },
        {
          "Pet Breed": "Bull Terrier"
        },
        {
          "Pet Breed": "Bull Terrier (Miniature)"
        },
        {
          "Pet Breed": "Bulldog"
        },
        {
          "Pet Breed": "Bullmastiff"
        },
        {
          "Pet Breed": "Cairn Terrier"
        },
        {
          "Pet Breed": "Canaan Dog"
        },
        {
          "Pet Breed": "Canadian Eskimo Dog"
        },
        {
          "Pet Breed": "Catalan Sheepdog"
        },
        {
          "Pet Breed": "Cavalier King Charles Spaniel"
        },
        {
          "Pet Breed": "Cesky Terrier"
        },
        {
          "Pet Breed": "Chihuahua (Long Coat)"
        },
        {
          "Pet Breed": "Chihuahua (Smooth Coat)"
        },
        {
          "Pet Breed": "Chinese Crested"
        },
        {
          "Pet Breed": "Chow Chow"
        },
        {
          "Pet Breed": "Cirneco Dell'Etna"
        },
        {
          "Pet Breed": "Collie (Rough)"
        },
        {
          "Pet Breed": "Collie (Smooth)"
        },
        {
          "Pet Breed": "Coton De Tulear"
        },
        {
          "Pet Breed": "Dachshund (Long Haired)"
        },
        {
          "Pet Breed": "Dachshund (Miniature Long Haired)"
        },
        {
          "Pet Breed": "Dachshund (Miniature Smooth Haired)"
        },
        {
          "Pet Breed": "Dachshund (Miniature Wire Haired)"
        },
        {
          "Pet Breed": "Dachshund (Smooth Haired)"
        },
        {
          "Pet Breed": "Dachshund (Wire Haired)"
        },
        {
          "Pet Breed": "Dalmatian"
        },
        {
          "Pet Breed": "Dandie Dinmont Terrier"
        },
        {
          "Pet Breed": "Deerhound"
        },
        {
          "Pet Breed": "Dobermann"
        },
        {
          "Pet Breed": "Dogue de Bordeaux"
        },
        {
          "Pet Breed": "English Setter"
        },
        {
          "Pet Breed": "English Toy Terrier (Black & Tan)"
        },
        {
          "Pet Breed": "Entlebucher Mountain Dog (Imp)"
        },
        {
          "Pet Breed": "Finnish Spitz"
        },
        {
          "Pet Breed": "Fox Terrier (Smooth)"
        },
        {
          "Pet Breed": "Fox Terrier (Wire)"
        },
        {
          "Pet Breed": "Foxhound"
        },
        {
          "Pet Breed": "French Bulldog"
        },
        {
          "Pet Breed": "German Pinscher"
        },
        {
          "Pet Breed": "German Shepherd Dog"
        },
        {
          "Pet Breed": "German Shorthaired Pointer"
        },
        {
          "Pet Breed": "German Spitz (Klein)"
        },
        {
          "Pet Breed": "German Spitz (Mittel)"
        },
        {
          "Pet Breed": "German Wirehaired Pointer"
        },
        {
          "Pet Breed": "Giant Schnauzer"
        },
        {
          "Pet Breed": "Glen Of Imaal Terrier"
        },
        {
          "Pet Breed": "Gordon Setter"
        },
        {
          "Pet Breed": "Grand Bleu De Gascogne (Imp)"
        },
        {
          "Pet Breed": "Great Dane"
        },
        {
          "Pet Breed": "Great Swiss Mountain Dog"
        },
        {
          "Pet Breed": "Greenland Dog"
        },
        {
          "Pet Breed": "Greyhound"
        },
        {
          "Pet Breed": "Griffon Bruxellois"
        },
        {
          "Pet Breed": "Griffon Fauve De Bretagne (Imp)"
        },
        {
          "Pet Breed": "Hamiltonstovare"
        },
        {
          "Pet Breed": "Havanese"
        },
        {
          "Pet Breed": "Hungarian Kuvasz (Imp)"
        },
        {
          "Pet Breed": "Hungarian Puli"
        },
        {
          "Pet Breed": "Hungarian Pumi"
        },
        {
          "Pet Breed": "Hungarian Vizsla"
        },
        {
          "Pet Breed": "Hungarian Wirehaired Vizsla"
        },
        {
          "Pet Breed": "Ibizan Hound"
        },
        {
          "Pet Breed": "Irish Red & White Setter"
        },
        {
          "Pet Breed": "Irish Setter"
        },
        {
          "Pet Breed": "Irish Terrier"
        },
        {
          "Pet Breed": "Irish Wolfhound"
        },
        {
          "Pet Breed": "Italian Spinone"
        },
        {
          "Pet Breed": "Jack Russell Terrier"
        },
        {
          "Pet Breed": "Japanese Akita Inu"
        },
        {
          "Pet Breed": "Japanese Shiba Inu"
        },
        {
          "Pet Breed": "Keeshond"
        },
        {
          "Pet Breed": "Kerry Blue Terrier"
        },
        {
          "Pet Breed": "King Charles Spaniel"
        },
        {
          "Pet Breed": "Komondor"
        },
        {
          "Pet Breed": "Kooikerhondje"
        },
        {
          "Pet Breed": "Korean Jindo (Imp)"
        },
        {
          "Pet Breed": "Korthals Griffon (Imp)"
        },
        {
          "Pet Breed": "Large Munsterlander"
        },
        {
          "Pet Breed": "Lhasa Apso"
        },
        {
          "Pet Breed": "Lowchen (Little Lion Dog)"
        },
        {
          "Pet Breed": "Mastiff"
        },
        {
          "Pet Breed": "Miniature Pinscher"
        },
        {
          "Pet Breed": "Miniature Schnauzer"
        },
        {
          "Pet Breed": "Newfoundland"
        },
        {
          "Pet Breed": "Norfolk Terrier"
        },
        {
          "Pet Breed": "Norwegian Elkhound"
        },
        {
          "Pet Breed": "Norwich Terrier"
        },
        {
          "Pet Breed": "Old English Sheepdog"
        },
        {
          "Pet Breed": "Pekingese"
        },
        {
          "Pet Breed": "Picardy Sheepdog (Imp)"
        },
        {
          "Pet Breed": "Pointer"
        },
        {
          "Pet Breed": "Polish Hunting Dog (Imp)"
        },
        {
          "Pet Breed": "Pomeranian"
        },
        {
          "Pet Breed": "Poodle (Miniature)"
        },
        {
          "Pet Breed": "Poodle (Standard)"
        },
        {
          "Pet Breed": "Poodle (Toy)"
        },
        {
          "Pet Breed": "Portuguese Pointer (Imp)"
        },
        {
          "Pet Breed": "Pug"
        },
        {
          "Pet Breed": "Pyrenean Mastiff (Imp)"
        },
        {
          "Pet Breed": "Pyrenean Mountain Dog"
        },
        {
          "Pet Breed": "Pyrenean Sheepdog (Long Haired)"
        },
        {
          "Pet Breed": "Pyrenean Sheepdog (Smooth Faced) (Imp)"
        },
        {
          "Pet Breed": "Retriever (Chesapeake Bay)"
        },
        {
          "Pet Breed": "Retriever (Curly Coated)"
        },
        {
          "Pet Breed": "Retriever (Flat Coated)"
        },
        {
          "Pet Breed": "Retriever (Golden)"
        },
        {
          "Pet Breed": "Retriever (Labrador)"
        },
        {
          "Pet Breed": "Retriever (Nova Scotia Duck Tolling)"
        },
        {
          "Pet Breed": "Rhodesian Ridgeback"
        },
        {
          "Pet Breed": "Rottweiler"
        },
        {
          "Pet Breed": "Russian Black Terrier"
        },
        {
          "Pet Breed": "Russian Toy (Imp)"
        },
        {
          "Pet Breed": "Saluki"
        },
        {
          "Pet Breed": "Samoyed"
        },
        {
          "Pet Breed": "Schipperke"
        },
        {
          "Pet Breed": "Schnauzer"
        },
        {
          "Pet Breed": "Scottish Terrier"
        },
        {
          "Pet Breed": "Sealyham Terrier"
        },
        {
          "Pet Breed": "Shar Pei"
        },
        {
          "Pet Breed": "Shetland Sheepdog"
        },
        {
          "Pet Breed": "Shih Tzu"
        },
        {
          "Pet Breed": "Siberian Husky"
        },
        {
          "Pet Breed": "Skye Terrier"
        },
        {
          "Pet Breed": "Slovakian Rough Haired Pointer (Imp)"
        },
        {
          "Pet Breed": "Small Munsterlander (Imp)"
        },
        {
          "Pet Breed": "Soft Coated Wheaten Terrier"
        },
        {
          "Pet Breed": "Spaniel (American Cocker)"
        },
        {
          "Pet Breed": "Spaniel (American Water) (Imp)"
        },
        {
          "Pet Breed": "Spaniel (Clumber)"
        },
        {
          "Pet Breed": "Spaniel (Cocker)"
        },
        {
          "Pet Breed": "Spaniel (English Springer)"
        },
        {
          "Pet Breed": "Spaniel (Field)"
        },
        {
          "Pet Breed": "Spaniel (Irish Water)"
        },
        {
          "Pet Breed": "Spaniel (Sussex)"
        },
        {
          "Pet Breed": "Spaniel (Welsh Springer)"
        },
        {
          "Pet Breed": "St. Bernard"
        },
        {
          "Pet Breed": "Staffordshire Bull Terrier"
        },
        {
          "Pet Breed": "Swedish Lapphund (Imp)"
        },
        {
          "Pet Breed": "Tibetan Spaniel"
        },
        {
          "Pet Breed": "Tibetan Terrier"
        },
        {
          "Pet Breed": "Turkish Kangal Dog"
        },
        {
          "Pet Breed": "Weimaraner"
        },
        {
          "Pet Breed": "Welsh Corgi (Cardigan)"
        },
        {
          "Pet Breed": "Welsh Corgi (Pembroke)"
        },
        {
          "Pet Breed": "Welsh Terrier"
        },
        {
          "Pet Breed": "West Highland White Terrier"
        },
        {
          "Pet Breed": "Whippet"
        },
        {
          "Pet Breed": "White Swiss Shepherd Dog (Imp)"
        },
        {
          "Pet Breed": "Xoloitzcuintle (Mex Hairless) Int (Imp)"
        },
        {
          "Pet Breed": "Xoloitzcuintle (Mex Hairless) Min (Imp)"
        },
        {
          "Pet Breed": "Xoloitzcuintle (Mex Hairless) Std (Imp)"
        },
        {
          "Pet Breed": "Yorkshire Terrier"
        }
      ])
}

function catBreedData(){
    return([
        {
          "Pet Breed": "Abyssinian"
        },
        {
          "Pet Breed": "Aegean"
        },
        {
          "Pet Breed": "American Bobtail"
        },
        {
          "Pet Breed": "American Curl"
        },
        {
          "Pet Breed": "American Keuda (rare/experimental)"
        },
        {
          "Pet Breed": "American Polydactyl (extra-toed)"
        },
        {
          "Pet Breed": "American Ringtail (rare/experimental)"
        },
        {
          "Pet Breed": "American Shorthair"
        },
        {
          "Pet Breed": "American Wirehair"
        },
        {
          "Pet Breed": "Aphrodite Giant"
        },
        {
          "Pet Breed": "Arabian Mau"
        },
        {
          "Pet Breed": "Asian (UK/GCCF category; includes Burmilla, Tiffanie, etc.)"
        },
        {
          "Pet Breed": "Asian Semi-longhair (a.k.a. Tiffanie)"
        },
        {
          "Pet Breed": "Australian Mist"
        },
        {
          "Pet Breed": "Australian Tiffanie (distinct in Australia/NZ)"
        },
        {
          "Pet Breed": "Balinese (longhaired Siamese-type)"
        },
        {
          "Pet Breed": "Bambino (short-legged Sphynx variant)"
        },
        {
          "Pet Breed": "Bengal"
        },
        {
          "Pet Breed": "Birman"
        },
        {
          "Pet Breed": "Bombay"
        },
        {
          "Pet Breed": "Brazilian Shorthair"
        },
        {
          "Pet Breed": "British Longhair"
        },
        {
          "Pet Breed": "British Shorthair"
        },
        {
          "Pet Breed": "Burmese"
        },
        {
          "Pet Breed": "Burmilla"
        },
        {
          "Pet Breed": "California Spangled (rare)"
        },
        {
          "Pet Breed": "Chantilly-Tiffany (rare, possibly extinct)"
        },
        {
          "Pet Breed": "Chartreux"
        },
        {
          "Pet Breed": "Chausie"
        },
        {
          "Pet Breed": "Chinese Li Hua (Dragon Li)"
        },
        {
          "Pet Breed": "Colorpoint Shorthair (Siamese-type in some registries)"
        },
        {
          "Pet Breed": "Cornish Rex"
        },
        {
          "Pet Breed": "Cymric (longhaired Manx)"
        },
        {
          "Pet Breed": "Cyprus (natural breed)"
        },
        {
          "Pet Breed": "Desert Lynx / American Lynx (rare bobtail)"
        },
        {
          "Pet Breed": "Devon Rex"
        },
        {
          "Pet Breed": "Donskoy (Don Sphynx)"
        },
        {
          "Pet Breed": "Dwelf (Munchkin+Sphynx+Curl mix)"
        },
        {
          "Pet Breed": "Egyptian Mau"
        },
        {
          "Pet Breed": "European Burmese"
        },
        {
          "Pet Breed": "European Shorthair"
        },
        {
          "Pet Breed": "Exotic Shorthair"
        },
        {
          "Pet Breed": "Foldex (Scottish Fold + Exotic mix)"
        },
        {
          "Pet Breed": "German Longhair (WCF recognized)"
        },
        {
          "Pet Breed": "German Rex"
        },
        {
          "Pet Breed": "Havana Brown"
        },
        {
          "Pet Breed": "Highlander (TICA Preliminary New Breed)"
        },
        {
          "Pet Breed": "Himalayan (Colorpoint Persian)"
        },
        {
          "Pet Breed": "Japanese Bobtail"
        },
        {
          "Pet Breed": "Javanese (or Colorpoint Longhair)"
        },
        {
          "Pet Breed": "Kanaani (TICA Advanced New Breed)"
        },
        {
          "Pet Breed": "Karelian Bobtail (WCF)"
        },
        {
          "Pet Breed": "Khao Manee"
        },
        {
          "Pet Breed": "Kinkalow (Munchkin + American Curl)"
        },
        {
          "Pet Breed": "Korat"
        },
        {
          "Pet Breed": "Korean Bobtail (rare)"
        },
        {
          "Pet Breed": "Korn Ja (Thai black cat)"
        },
        {
          "Pet Breed": "Kurilian Bobtail"
        },
        {
          "Pet Breed": "Lambkin (Selkirk Rex + Munchkin)"
        },
        {
          "Pet Breed": "LaPerm"
        },
        {
          "Pet Breed": "Lykoi"
        },
        {
          "Pet Breed": "Maine Coon"
        },
        {
          "Pet Breed": "Manx"
        },
        {
          "Pet Breed": "Mandalay (recognized in NZ; Burmese-type)"
        },
        {
          "Pet Breed": "Mekong Bobtail (WCF recognized)"
        },
        {
          "Pet Breed": "Minskin (Bambino-type dwarf breed)"
        },
        {
          "Pet Breed": "Minuet (Napoleon Cat)"
        },
        {
          "Pet Breed": "Munchkin"
        },
        {
          "Pet Breed": "Nebelung"
        },
        {
          "Pet Breed": "Neva Masquerade (colorpoint Siberian)"
        },
        {
          "Pet Breed": "Norwegian Forest Cat"
        },
        {
          "Pet Breed": "Ocicat"
        },
        {
          "Pet Breed": "Ojos Azules (extinct or nearly so)"
        },
        {
          "Pet Breed": "Oriental Bicolor"
        },
        {
          "Pet Breed": "Oriental Longhair"
        },
        {
          "Pet Breed": "Oriental Shorthair"
        },
        {
          "Pet Breed": "Persian (modern)"
        },
        {
          "Pet Breed": "Persian (traditional) (a.k.a. Doll Face)"
        },
        {
          "Pet Breed": "Peterbald"
        },
        {
          "Pet Breed": "Pixiebob"
        },
        {
          "Pet Breed": "RagaMuffin"
        },
        {
          "Pet Breed": "Ragdoll"
        },
        {
          "Pet Breed": "Raas (Indonesian breed)"
        },
        {
          "Pet Breed": "Russian Blue"
        },
        {
          "Pet Breed": "Russian White / Black / Tabby"
        },
        {
          "Pet Breed": "Sam Sawet (native Thai breed)"
        },
        {
          "Pet Breed": "Savannah"
        },
        {
          "Pet Breed": "Scottish Fold"
        },
        {
          "Pet Breed": "Selkirk Rex"
        },
        {
          "Pet Breed": "Serengeti"
        },
        {
          "Pet Breed": "Serrade Petit (rare French breed)"
        },
        {
          "Pet Breed": "Siamese (modern)"
        },
        {
          "Pet Breed": "Siberian (Siberian Forest Cat)"
        },
        {
          "Pet Breed": "Singapura"
        },
        {
          "Pet Breed": "Snowshoe"
        },
        {
          "Pet Breed": "Sokoke"
        },
        {
          "Pet Breed": "Somali"
        },
        {
          "Pet Breed": "Sphynx"
        },
        {
          "Pet Breed": "Suphalak (copper Thai breed)"
        },
        {
          "Pet Breed": "Tennessee Rex (experimental curly breed)"
        },
        {
          "Pet Breed": "Thai (Traditional/Old-style Siamese, Wichien Maat)"
        },
        {
          "Pet Breed": "Thai Blue Point / Thai Lilac / Thai Lilac Point"
        },
        {
          "Pet Breed": "Tonkinese"
        },
        {
          "Pet Breed": "Toybob (tiny bobtail)"
        },
        {
          "Pet Breed": "Toyger"
        },
        {
          "Pet Breed": "Turkish Angora"
        },
        {
          "Pet Breed": "Turkish Van"
        },
        {
          "Pet Breed": "Turkish Vankedisi (white Turkish Van)"
        },
        {
          "Pet Breed": "Ukrainian Levkoy"
        },
        {
          "Pet Breed": "Ural Rex (WCF recognized)"
        },
        {
          "Pet Breed": "York Chocolate (rare, possibly extinct)"
        },
        {
          "Pet Breed": "Indian Desi Cat"
        }
      ])
}


function dogMedicalConditionData(){
    return([
        {
          "Conditions": "Epilepsy (Seizures)",
          "Potential Medicine Categories": "neural care, anxiety care, wound and pain relief",
          "Potential Supplement Categories": "multi vitamin, immunity supplements, anxiety supplements",
          "Potential Supplies Categories": "crates/carriers/penns,  beds,  training and behaviour",
          "Potential Food Categories": "premium food, recovery food",
          
        },
        {
          "Conditions": "Meningitis",
          "Potential Medicine Categories": "anti biotic, neural care, wound and pain relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "crates/carriers/penns,  hygiene product, cleaning product",
          "Potential Food Categories": "veterinary diets, recovery food",
          
        },
        {
          "Conditions": "Vestibular Syndrome",
          "Potential Medicine Categories": "neural care, eye and ear care, wound and pain relief, anxiety care",
          "Potential Supplement Categories": "multi vitamin, immunity supplements",
          "Potential Supplies Categories": "beds,  cleaning product,  training and behaviour",
          "Potential Food Categories": "veterinary diets, recovery food",
          
        },
        {
          "Conditions": "Hydrocephalus \n (fluid buildup in the brain)",
          "Potential Medicine Categories": "neural care, wound and pain relief, anti biotic, anxiety care",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "crates/carriers/penns,  beds,  training and behaviour",
          "Potential Food Categories": "premium food,  veterinary diets, recovery food",
          
        },
        {
          "Conditions": "Wobbler Syndrome \n (cervical vertebral instability)",
          "Potential Medicine Categories": "neural care, hip and joint care, wound and pain relief",
          "Potential Supplement Categories": "hip & joint supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "leash/collars & harnesses,  beds,  surgical accessory, medical belts",
          "Potential Food Categories": "veterinary diets, obesity food",
          
        },
        {
          "Conditions": "Narcolepsy",
          "Potential Medicine Categories": "neural care, wound and pain relief, anxiety care",
          "Potential Supplement Categories": "multi vitamin, immunity supplements",
          "Potential Supplies Categories": "beds,  crates/carriers/penns,  training and behaviour",
          "Potential Food Categories": "veterinary diets, diabetic food",
          
        },
        {
          "Conditions": "Stroke \n (cerebrovascular accident)",
          "Potential Medicine Categories": "neural care, cardiac care, wound and pain relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "crates/carriers/penns,  beds",
          "Potential Food Categories": "veterinary diets, cardiac food",
          
        },
        {
          "Conditions": "Degenerative Brain Diseases \n (Cognitive Dysfunction)",
          "Potential Medicine Categories": "neural care, anxiety care",
          "Potential Supplement Categories": "anxiety supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "beds,  training and behaviour",
          "Potential Food Categories": "senior food, wet food, gastro food",
          
        },
        {
          "Conditions": "Tetanus \n (bacterial infection)",
          "Potential Medicine Categories": "anti biotic, neural care, wound and pain relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "cleaning product,  crates/carriers/penns",
          "Potential Food Categories": "wet food,  premium food, recovery food",
          
        },
        {
          "Conditions": "Spinal Cord Injuries \n (trauma, disc herniation)",
          "Potential Medicine Categories": "neural care, wound and pain relief, injectable",
          "Potential Supplement Categories": "hip & joint supplements, immunity supplements",
          "Potential Supplies Categories": "crates/carriers/penns,  surgical accessory,  beds",
          "Potential Food Categories": "veterinary diets, obesity food",
          
        },
        {
          "Conditions": "Encephalitis \n (inflammation of the brain)",
          "Potential Medicine Categories": "anti biotic or antiviral, neural care, wound and pain relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "crates/carriers/penns,  hygiene product",
          "Potential Food Categories": "wet food",
          
        },
        {
          "Conditions": "Fibrocartilaginous Embolism (FCE) \n (spinal cord infarction)",
          "Potential Medicine Categories": "neural care, wound and pain relief, hip and joint care",
          "Potential Supplement Categories": "hip & joint supplements, multi vitamin",
          "Potential Supplies Categories": "crates/carriers/penns,  training and behaviour,  beds",
          "Potential Food Categories": "veterinary diets, mobility food, obesity food",
          
        },
        {
          "Conditions": "Some Neurological Issue",
          "Potential Medicine Categories": "anxiety care, cardiac care, hip & joint care, anti biotic, anxiety care, eye and ear care, neural care, wound and pain relief",
          "Potential Supplement Categories": "multi vitamin, immunity supplements, anxiety supplements, hip & joint supplements",
          "Potential Supplies Categories": "beds,cleaning product,crates/carriers/penns,hygiene product,leash/collars & harnesses,medical belts,surgical accessory,training and behaviour",
          "Potential Food Categories": "cardiac food, diabetic food, mobility food, obesity food, premium food, recovery food, senior food,  veterinary diets, wet food",
          
        },
        {
          "Conditions": "",
          "Potential Medicine Categories": "",
          "Potential Supplement Categories": "",
          "Potential Supplies Categories": "",
          "Potential Food Categories": "",
          
        },
        {
          "Conditions": "Rabies",
          "Potential Medicine Categories": "vaccine, wound and pain relief",
          "Potential Supplement Categories": "multi vitamin",
          "Potential Supplies Categories": "cleaning product,  crates/carriers/penns, hygiene product",
          "Potential Food Categories": "recovery food",
          
        },
        {
          "Conditions": "Canine Distemper",
          "Potential Medicine Categories": "vaccine, respiratory care, anti biotic, wound and pain relief, canglob d",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "cleaning product,  crates/carriers/penns, hygiene product",
          "Potential Food Categories": "wet food, premium wet food, recovery food",
          
        },
        {
          "Conditions": "Canine Hepatitis (Adenovirus)",
          "Potential Medicine Categories": "vaccine, liver care, anti biotic, wound and pain relief",
          "Potential Supplement Categories": "liver supplement, immunity supplements",
          "Potential Supplies Categories": "cleaning product,  crates/carriers/penns, hygiene product",
          "Potential Food Categories": "veterinary diets,  wet food, hepatic food",
          
        },
        {
          "Conditions": "Parvovirus",
          "Potential Medicine Categories": "vaccine, gastro intestinal & digestive care, anti biotic, injectable, canglob p",
          "Potential Supplement Categories": "intestinal & digestive supplements, immunity supplements",
          "Potential Supplies Categories": "cleaning product,  crates/carriers/penns, hygiene product",
          "Potential Food Categories": "veterinary diets,  wet food, gastro food, recovery food",
          
        },
        {
          "Conditions": "Kennel Cough (Bordetella)",
          "Potential Medicine Categories": "vaccine, respiratory care, anti biotic",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "cleaning product,  crates/carriers/penns, hygiene product",
          "Potential Food Categories": "wet food, recovery food",
          
        },
        {
          "Conditions": "Leptospirosis",
          "Potential Medicine Categories": "vaccine, anti biotic, urinary tract & renal care",
          "Potential Supplement Categories": "renal & urinary supplements, immunity supplements",
          "Potential Supplies Categories": "cleaning product,  bowls and feeders",
          "Potential Food Categories": "wet food,  veterinary diets, renal food",
          
        },
        {
          "Conditions": "Lyme Disease (Borrelia)",
          "Potential Medicine Categories": "vaccine, anti biotic, fleas and ticks",
          "Potential Supplement Categories": "hip & joint supplements, immunity supplements",
          "Potential Supplies Categories": "leash/collars & harnesses,  cleaning product",
          "Potential Food Categories": "premium food, recovery food, wet food",
          
        },
        {
          "Conditions": "Ehrlichiosis (Ehrlichia canis)",
          "Potential Medicine Categories": "anti biotic, fleas and ticks, wound and pain relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "cleaning product,  leash/collars & harnesses",
          "Potential Food Categories": "wet food, recovery food",
          
        },
        {
          "Conditions": "Anaplasmosis (Anaplasma)",
          "Potential Medicine Categories": "anti biotic, fleas and ticks, wound and pain relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "cleaning product,  leash/collars & harnesses",
          "Potential Food Categories": "premium food, recovery food, wet food",
          
        },
        {
          "Conditions": "Babesiosis (Babesia)",
          "Potential Medicine Categories": "anti biotic / antiprotozoal, fleas and ticks, wound and pain relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "cleaning product,  crates/carriers/penns",
          "Potential Food Categories": "premium food, recovery food, wet food",
          
        },
        {
          "Conditions": "Rocky Mountain Spotted Fever (RMSF)",
          "Potential Medicine Categories": "anti biotic, fleas and ticks, wound and pain relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "cleaning product,  crates/carriers/penns",
          "Potential Food Categories": "premium food, recovery food, wet food",
          
        },
        {
          "Conditions": "Brucellosis",
          "Potential Medicine Categories": "anti biotic, wound and pain relief, post natal care / pre natal care",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "cleaning product,  crates/carriers/penns",
          "Potential Food Categories": "premium food, recovery food, wet food",
          
        },
        {
          "Conditions": "Salmon Poisoning Disease (Pacific NW)",
          "Potential Medicine Categories": "anti biotic, dewormers, gastro intestinal & digestive care",
          "Potential Supplement Categories": "intestinal & digestive supplements, immunity supplements",
          "Potential Supplies Categories": "cleaning product,  bowls and feeders",
          "Potential Food Categories": "premium food, recovery food, wet food, gastro food",
          
        },
        {
          "Conditions": "Giardiasis (Giardia)",
          "Potential Medicine Categories": "dewormers, gastro intestinal & digestive care",
          "Potential Supplement Categories": "intestinal & digestive supplements, immunity supplements",
          "Potential Supplies Categories": "cleaning product,  bowls and feeders",
          "Potential Food Categories": "premium food, recovery food, wet food, gastro food",
          
        },
        {
          "Conditions": "Coccidiosis (Cystoisospora)",
          "Potential Medicine Categories": "dewormers, gastro intestinal & digestive care",
          "Potential Supplement Categories": "intestinal & digestive supplements, multi vitamin",
          "Potential Supplies Categories": "cleaning product,  crates/carriers/penns",
          "Potential Food Categories": "premium food, recovery food, wet food, gastro food",
          
        },
        {
          "Conditions": "Heartworm Disease (Dirofilaria)",
          "Potential Medicine Categories": "dewormers, cardiac care, injectable, wound and pain relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "leash/collars & harnesses,  crates/carriers/penns",
          "Potential Food Categories": "premium food, recovery food, wet food, cardiac food",
          
        },
        {
          "Conditions": "Intestinal Worms \n (Rounds, Hooks, Whips, Tapes)",
          "Potential Medicine Categories": "dewormers, gastro intestinal & digestive care",
          "Potential Supplement Categories": "intestinal & digestive supplements, multi vitamin",
          "Potential Supplies Categories": "cleaning product,  bowls and feeders",
          "Potential Food Categories": "premium food, recovery food, wet food, gastro food",
          
        },
        {
          "Conditions": "Fleas, Ticks, Lice",
          "Potential Medicine Categories": "fleas and ticks, skin and coat care, wound and pain relief",
          "Potential Supplement Categories": "skin & coat supplements, immunity supplements",
          "Potential Supplies Categories": "grooming,  medicated shampoo, tick shampoo, flea tick supplies",
          "Potential Food Categories": "premium food, recovery food, wet food, gastro food",
          
        },
        {
          "Conditions": "Sarcoptic Mange \n (Sarcoptes scabiei)",
          "Potential Medicine Categories": "fleas and ticks, wound and pain relief, skin and coat care, ivermectin, selamectin",
          "Potential Supplement Categories": "skin & coat supplements, immunity supplements",
          "Potential Supplies Categories": "medicated shampoo,  cleaning product, skin infection shampoo, ketocanozole",
          "Potential Food Categories": "premium food, skin support food, hypo food",
          
        },
        {
          "Conditions": "Demodectic Mange \n (Demodex canis)",
          "Potential Medicine Categories": "skin and coat care, anti biotic, wound and pain relief, fleas and ticks, ivermectin, selamectin",
          "Potential Supplement Categories": "skin & coat supplements, immunity supplements",
          "Potential Supplies Categories": "medicated shampoo,  cleaning product, skin infection shampoo, ketocanozole",
          "Potential Food Categories": "premium food, recovery food, wet food, gastro food",
          
        },
        {
          "Conditions": "",
          "Potential Medicine Categories": "",
          "Potential Supplement Categories": "",
          "Potential Supplies Categories": "",
          "Potential Food Categories": "",
          
        },
        {
          "Conditions": "Ringworm \n (Dermatophytes – fungal infection)",
          "Potential Medicine Categories": "anti biotic, skin and coat care, wound and pain relief",
          "Potential Supplement Categories": "skin & coat supplements, immunity supplements",
          "Potential Supplies Categories": "medicated shampoo,  cleaning product, skin infection shampoo, ketocanozole",
          "Potential Food Categories": "premium food,  veterinary diet, skin support food, hypo food",
          
        },
        {
          "Conditions": "Lungworms \n (Oslerus osleri, etc.)",
          "Potential Medicine Categories": "dewormers, respiratory care",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "cleaning product,  crates/carriers/penns",
          "Potential Food Categories": "premium food,  wet food, skin support food, hypo food, veterinary diets",
          
        },
        {
          "Conditions": "infectious Disease",
          "Potential Medicine Categories": "vaccine, wound and pain relief, respiratory care, anti biotic, canglob d, liver care, gastro intestinal & digestive care, injectable, canglob p, urinary tract & renal care, fleas and ticks, anti biotic / antiprotozoal, post natal care / pre natal care, dewormers, cardiac care, skin and coat care, ivermectin, selamectin",
          "Potential Supplement Categories": "multi vitamin, immunity supplements, liver supplement, intestinal & digestive supplements, renal & urinary supplements, hip & joint supplements, skin & coat supplements",
          "Potential Supplies Categories": "Cleaning product, Crates/Carriers/Pens, Hygiene product, Bowls and Feeders, Leash/Collars & Harnesses, Grooming, Medicated Shampoo, Tick Shampoo, Flea Tick Supplies, Skin Infection Shampoo, Ketoconazole",
          "Potential Food Categories": "Recovery Food, Wet Food, Premium Food, Veterinary Diets, Hepatic Food, Gastro Food, Renal Food, Cardiac Food, Skin Support Food, Hypo Food",
          
        },
        {
          "Conditions": "Allergies \n (food, environmental, flea)",
          "Potential Medicine Categories": "allergy relief, fleas and ticks, skin and coat care, wound and pain relief, dewormers",
          "Potential Supplement Categories": "skin & coat supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "medicated shampoo, skin infection shampoo, ketocanozole",
          "Potential Food Categories": "premium food, skin support food, hypo food",
          "Potential Food Categories__1": "Skin Treat"
        },
        {
          "Conditions": "Hot Spots \n (acute moist dermatitis)",
          "Potential Medicine Categories": "wound and pain relief, anti biotic, skin and coat care",
          "Potential Supplement Categories": "skin & coat supplements, immunity supplements",
          "Potential Supplies Categories": "medicated shampoo, skin infection shampoo, ketocanozole",
          "Potential Food Categories": "premium food, skin support food, hypo food",
          "Potential Food Categories__1": "Skin Treat"
        },
        {
          "Conditions": "Yeast Infections \n (ears, paws, skin folds)",
          "Potential Medicine Categories": "eye and ear care, skin and coat care, anti biotic, wound and pain relief",
          "Potential Supplement Categories": "skin & coat supplements, immunity supplements",
          "Potential Supplies Categories": "medicated shampoo, skin infection shampoo, ketocanozole",
          "Potential Food Categories": "premium food, skin support food, hypo food",
          "Potential Food Categories__1": "Skin Treat"
        },
        {
          "Conditions": "Pyoderma \n (bacterial skin infections)",
          "Potential Medicine Categories": "anti biotic, skin and coat care, wound and pain relief",
          "Potential Supplement Categories": "skin & coat supplements, immunity supplements",
          "Potential Supplies Categories": "medicated shampoo, skin infection shampoo, ketocanozole",
          "Potential Food Categories": "premium food, skin support food, hypo food",
          "Potential Food Categories__1": "Skin Treat"
        },
        {
          "Conditions": "Seborrhea \n (oily or flaky skin- dandruff)",
          "Potential Medicine Categories": "skin and coat care, wound and pain relief, allergy relief",
          "Potential Supplement Categories": "skin & coat supplements, immunity supplements",
          "Potential Supplies Categories": "medicated shampoo, skin infection shampoo, ketocanozole, antidandruff shampoo",
          "Potential Food Categories": "premium food, skin support food, hypo food",
          "Potential Food Categories__1": "Skin Treat"
        },
        {
          "Conditions": "Skin Tumors \n (benign and malignant)",
          "Potential Medicine Categories": "cancer care, skin and coat care, wound and pain relief, anti biotic",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "medicated shampoo",
          "Potential Food Categories": "premium food, skin support food, hypo food",
          "Potential Food Categories__1": "Skin Treat"
        },
        {
          "Conditions": "Interdigital Cysts \n (between paw pads)",
          "Potential Medicine Categories": "wound and pain relief, anti biotic, skin and coat care",
          "Potential Supplement Categories": "skin & coat supplements, immunity supplements",
          "Potential Supplies Categories": "medicated shampoo or foot soak, pawcream",
          "Potential Food Categories": "premium food, skin support food, hypo food",
          "Potential Food Categories__1": "Skin Treat"
        },
        {
          "Conditions": "Alopecia \n (hair loss)",
          "Potential Medicine Categories": "skin and coat care, allergy relief, thyroid, wound and pain relief",
          "Potential Supplement Categories": "skin & coat supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "medicated shampoo, premium shampoo",
          "Potential Food Categories": "premium food, skin support food, hypo food",
          "Potential Food Categories__1": "Skin Treat"
        },
        {
          "Conditions": "Dermatitis \n (general skin inflammation)",
          "Potential Medicine Categories": "allergy relief, skin and coat care, wound and pain relief, fleas and ticks",
          "Potential Supplement Categories": "skin & coat supplements, immunity supplements",
          "Potential Supplies Categories": "medicated shampoo, skin infection shampoo, ketocanozole",
          "Potential Food Categories": "premium food, skin support food, hypo food",
          "Potential Food Categories__1": "Skin Treat"
        },
        {
          "Conditions": "Some Skin issues",
          "Potential Medicine Categories": "allergy relief, anti biotic, cancer care, dewormers, eye and ear care, fleas and ticks, skin and coat care, thyroid, wound and pain relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin, skin & coat supplements",
          "Potential Supplies Categories": "antidandruff shampoo, medicated shampoo, pawcream, premium shampoo, skin infection shampoo, support healthy regrowth, ketocanozole, medicated shampoo gentle postop, medicated shampoo or foot soak",
          "Potential Food Categories": "hypo food, premium food, skin support food",
          "Potential Food Categories__1": "Skin Treat"
        },
        {
          "Conditions": "Ear Infections \n (otitis externa, media, interna)",
          "Potential Medicine Categories": "eye and ear care, anti biotic, wound and pain relief, allergy relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "grooming,  hygiene product, salicylic acid, ear cleanser, eye/ear wipes",
          "Potential Food Categories": "premium food, skin support food, hypo food, gastro food",
          
        },
        {
          "Conditions": "Ear Mites \n (Otodectes cynotis)",
          "Potential Medicine Categories": "eye and ear care, fleas and ticks, wound and pain relief, selamectin",
          "Potential Supplement Categories": "immunity supplements",
          "Potential Supplies Categories": "grooming,  hygiene product, salicylic acid, ear cleanser, eye/ear wipes",
          "Potential Food Categories": "premium food, skin support food, hypo food, gastro food",
          
        },
        {
          "Conditions": "Ear Mites \n (Otodectes cynotis)",
          "Potential Medicine Categories": "eye and ear care, wound and pain relief, salicylic acid, selamectin",
          "Potential Supplement Categories": "skin & coat supplements, immunity supplements",
          "Potential Supplies Categories": "grooming,  cleaning product, ear cleanser, eye/ear wipes",
          "Potential Food Categories": "recovery food, wet food, gastro food, premium food",
          
        },
        {
          "Conditions": "Aural Hematoma \n (blood-filled swelling)",
          "Potential Medicine Categories": "wound and pain relief, eye and ear care, anti biotic",
          "Potential Supplement Categories": "immunity supplements",
          "Potential Supplies Categories": "grooming,  hygiene product, salicylic acid, ear cleanser, eye/ear wipes",
          "Potential Food Categories": "premium food, skin support food, hypo food, gastro food",
          
        },
        {
          "Conditions": "Deafness \n (congenital or acquired)",
          "Potential Medicine Categories": "eye and ear care, neural care",
          "Potential Supplement Categories": "multi vitamin, immunity supplements",
          "Potential Supplies Categories": "training and behaviour,  grooming, salicylic acid, ear cleanser, eye/ear wipes",
          "Potential Food Categories": "premium food, skin support food, hypo food, gastro food",
          
        },
        {
          "Conditions": "Vestibular Disease \n (balance disorders)",
          "Potential Medicine Categories": "eye and ear care, neural care, wound and pain relief",
          "Potential Supplement Categories": "multi vitamin, immunity supplements",
          "Potential Supplies Categories": "training and behaviour,  grooming, salicylic acid, ear cleanser, eye/ear wipes, cleaning product",
          "Potential Food Categories": "premium food, skin support food, hypo food, gastro food, senior food",
          
        },
        {
          "Conditions": "Conjunctivitis \n (pink eye)",
          "Potential Medicine Categories": "eye and ear care, anti biotic, allergy relief",
          "Potential Supplement Categories": "immunity supplements, mybeau eye",
          "Potential Supplies Categories": "training and behaviour,  grooming, salicylic acid, ear cleanser, eye/ear wipes, cleaning product",
          "Potential Food Categories": "premium food, skin support food, hypo food, gastro food",
          
        },
        {
          "Conditions": "Cataracts",
          "Potential Medicine Categories": "eye and ear care, diabetes, neural care",
          "Potential Supplement Categories": "immunity supplements, multi vitamin, mybeau eye",
          "Potential Supplies Categories": "training and behaviour,  grooming, salicylic acid, ear cleanser, eye/ear wipes, cleaning product",
          "Potential Food Categories": "premium food, skin support food, hypo food, gastro food",
          
        },
        {
          "Conditions": "Glaucoma",
          "Potential Medicine Categories": "eye and ear care, wound and pain relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin, mybeau eye",
          "Potential Supplies Categories": "training and behaviour,  grooming, salicylic acid, ear cleanser, eye/ear wipes, cleaning product",
          "Potential Food Categories": "premium food, skin support food, hypo food, gastro food",
          
        },
        {
          "Conditions": "Progressive Retinal Atrophy (PRA)",
          "Potential Medicine Categories": "eye and ear care, neural care",
          "Potential Supplement Categories": "immunity supplements, multi vitamin, mybeau eye",
          "Potential Supplies Categories": "training and behaviour,  grooming, salicylic acid, ear cleanser, eye/ear wipes, cleaning product",
          "Potential Food Categories": "premium food, skin support food, hypo food, gastro food, recovery food",
          
        },
        {
          "Conditions": "Cherry Eye \n (prolapsed third eyelid gland)",
          "Potential Medicine Categories": "eye and ear care, wound and pain relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin, mybeau eye",
          "Potential Supplies Categories": "training and behaviour,  grooming, salicylic acid, ear cleanser, eye/ear wipes, cleaning product",
          "Potential Food Categories": "premium food, skin support food, hypo food, gastro food",
          
        },
        {
          "Conditions": "Corneal Ulcers",
          "Potential Medicine Categories": "eye and ear care, wound and pain relief",
          "Potential Supplement Categories": "multi vitamin, immunity supplements, mybeau eye",
          "Potential Supplies Categories": "training and behaviour,  grooming, salicylic acid, ear cleanser, eye/ear wipes, cleaning product",
          "Potential Food Categories": "premium food, skin support food, hypo food, gastro food, recovery food",
          
        },
        {
          "Conditions": "Dry Eye \n (Keratoconjunctivitis Sicca)",
          "Potential Medicine Categories": "eye and ear care, allergy relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin, mybeau eye",
          "Potential Supplies Categories": "training and behaviour,  grooming, salicylic acid, ear cleanser, eye/ear wipes, cleaning product",
          "Potential Food Categories": "premium food, skin support food, hypo food, gastro food",
          
        },
        {
          "Conditions": "Entropion \n (inward rolling of eyelids)",
          "Potential Medicine Categories": "eye and ear care, wound and pain relief",
          "Potential Supplement Categories": "multi vitamin, immunity supplements, mybeau eye",
          "Potential Supplies Categories": "training and behaviour,  grooming, salicylic acid, ear cleanser, eye/ear wipes, cleaning product",
          "Potential Food Categories": "premium food, skin support food, hypo food, gastro food",
          
        },
        {
          "Conditions": "Ectropion \n (outward rolling of eyelids)",
          "Potential Medicine Categories": "eye and ear care, wound and pain relief",
          "Potential Supplement Categories": "multi vitamin, immunity supplements, mybeau eye",
          "Potential Supplies Categories": "training and behaviour,  grooming, salicylic acid, ear cleanser, eye/ear wipes, cleaning product",
          "Potential Food Categories": "premium food, skin support food, hypo food, gastro food",
          
        },
        {
          "Conditions": "Uveitis \n (inflammation inside the eye)",
          "Potential Medicine Categories": "eye and ear care, anti biotic or anti fungal",
          "Potential Supplement Categories": "immunity supplements, multi vitamin, mybeau eye",
          "Potential Supplies Categories": "training and behaviour,  grooming, salicylic acid, ear cleanser, eye/ear wipes, cleaning product",
          "Potential Food Categories": "premium food, skin support food, hypo food, gastro food",
          
        },
        {
          "Conditions": "Some Eye Issue",
          "Potential Medicine Categories": "",
          "Potential Supplement Categories": "",
          "Potential Supplies Categories": "",
          "Potential Food Categories": "",
          
        },
        {
          "Conditions": "Some Ear Issues",
          "Potential Medicine Categories": "allergy relief, anti biotic, eye and ear care, fleas and ticks, neural care, salicylic acid, selamectin, wound and pain relief",
          "Potential Supplement Categories": "",
          "Potential Supplies Categories": "",
          "Potential Food Categories": "",
          
        },
        {
          "Conditions": "Periodontal Disease (gum disease)",
          "Potential Medicine Categories": "anti biotic, wound and pain relief, skin & coat care",
          "Potential Supplement Categories": "dental care/mouth hygiene, immunity supplements",
          "Potential Supplies Categories": "hygiene product,  grooming, tooth brush, tooth paste",
          "Potential Food Categories": "premium food, gastro food, wet food",
          "Potential Food Categories__1": "Dental Treats"
        },
        {
          "Conditions": "Gingivitis",
          "Potential Medicine Categories": "anti biotic, wound and pain relief",
          "Potential Supplement Categories": "dental care/mouth hygiene, immunity supplements",
          "Potential Supplies Categories": "hygiene product,  grooming, tooth brush, tooth paste",
          "Potential Food Categories": "premium food, gastro food, wet food",
          "Potential Food Categories__1": "Dental Treats"
        },
        {
          "Conditions": "Dental Abscesses",
          "Potential Medicine Categories": "anti biotic, wound and pain relief, injectable",
          "Potential Supplement Categories": "dental care/mouth hygiene, immunity supplements",
          "Potential Supplies Categories": "hygiene product,  grooming, tooth brush, tooth paste",
          "Potential Food Categories": "premium food, gastro food, wet food",
          "Potential Food Categories__1": "Dental Treats"
        },
        {
          "Conditions": "Tooth Fractures",
          "Potential Medicine Categories": "wound and pain relief, anti biotic",
          "Potential Supplement Categories": "calcium supplement, dental care/mouth hygiene",
          "Potential Supplies Categories": "hygiene product,  grooming, tooth brush, tooth paste",
          "Potential Food Categories": "premium food, gastro food, wet food",
          "Potential Food Categories__1": "Dental Treats"
        },
        {
          "Conditions": "Malocclusions (misaligned teeth/jaw)",
          "Potential Medicine Categories": "wound and pain relief, anxiety care",
          "Potential Supplement Categories": "dental care/mouth hygiene",
          "Potential Supplies Categories": "hygiene product,  grooming, tooth brush, tooth paste",
          "Potential Food Categories": "premium food, gastro food, wet food",
          "Potential Food Categories__1": "Dental Treats"
        },
        {
          "Conditions": "Cleft Palate (congenital)",
          "Potential Medicine Categories": "anti biotic, wound and pain relief",
          "Potential Supplement Categories": "milk replacer",
          "Potential Supplies Categories": "hygiene product,  grooming, tooth brush, tooth paste",
          "Potential Food Categories": "premium food, gastro food, wet food, infant food",
          "Potential Food Categories__1": "Dental Treats"
        },
        {
          "Conditions": "Some Dental issue",
          "Potential Medicine Categories": "Antibiotic, Wound and Pain Relief, Skin & Coat Care, Injectable, Anxiety Care",
          "Potential Supplement Categories": "Dental Care/Mouth Hygiene, Immunity Supplements, Calcium Supplement, Milk Replacer",
          "Potential Supplies Categories": "Hygiene Product, Grooming, Toothbrush, Toothpaste",
          "Potential Food Categories": "Premium Food, Gastro Food, Wet Food, Infant Food",
          "Potential Food Categories__1": "Dental Treats"
        },
        {
          "Conditions": "Gastroenteritis \n (vomiting & diarrhea)",
          "Potential Medicine Categories": "gastro intestinal & digestive care, anti biotic, wound & pain relief, injectable",
          "Potential Supplement Categories": "intestinal & digestive supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "bowls and feeders,  cleaning product, pee pads, slowfeeder",
          "Potential Food Categories": "wet food,  veterinary diets,  infant food, gastro food, recovery food",
          
        },
        {
          "Conditions": "Hemorrhagic Gastroenteritis (HGE/AHDS)",
          "Potential Medicine Categories": "gastro intestinal & digestive care, anti biotic, wound & pain relief",
          "Potential Supplement Categories": "intestinal & digestive supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "cleaning product,  bowls and feeders, pee pads, slowfeeder",
          "Potential Food Categories": "wet food or bland diet,  veterinary diets, gastro food, recovery food",
          
        },
        {
          "Conditions": "Colitis \n (inflammation of the colon)",
          "Potential Medicine Categories": "gastro intestinal & digestive care, dewormers, anti biotic",
          "Potential Supplement Categories": "intestinal & digestive supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "cleaning product,  bowls and feeders, pee pads, slowfeeder",
          "Potential Food Categories": "veterinary diets,  premium food, gastro food, recovery food, wet food",
          
        },
        {
          "Conditions": "Pancreatitis",
          "Potential Medicine Categories": "gastro intestinal & digestive care, wound & pain relief, injectable",
          "Potential Supplement Categories": "intestinal & digestive supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "bowls and feeders,  cleaning product, pee pads, slowfeeder",
          "Potential Food Categories": "veterinary diets,  wet food, gastro food, recovery food, hepatic food",
          
        },
        {
          "Conditions": "Bloat / Gastric Dilatation-Volvulus (GDV)",
          "Potential Medicine Categories": "injectable, wound & pain relief, surgical accessory",
          "Potential Supplement Categories": "intestinal & digestive supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "bowls and feeders, crates/carriers/penns, pee pads, slowfeeder",
          "Potential Food Categories": "veterinary diets,  wet food, gastro food, recovery food, hepatic food",
          
        },
        {
          "Conditions": "Intestinal Parasites \n (worms)",
          "Potential Medicine Categories": "dewormers, gastro intestinal & digestive care",
          "Potential Supplement Categories": "intestinal & digestive supplements, immunity supplements",
          "Potential Supplies Categories": "cleaning product,  potty articles, pee pads",
          "Potential Food Categories": "veterinary diets,  premium food, gastro food, recovery food",
          
        },
        {
          "Conditions": "Liver Disease \n (hepatitis, cirrhosis)",
          "Potential Medicine Categories": "liver care, anti biotic, wound & pain relief",
          "Potential Supplement Categories": "liver supplement, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "bowls and feeders, pee pads, slowfeeder",
          "Potential Food Categories": "veterinary diets,  premium food, gastro food, recovery food, hepatic food",
          
        },
        {
          "Conditions": "Exocrine Pancreatic Insufficiency (EPI)",
          "Potential Medicine Categories": "gastro intestinal & digestive care",
          "Potential Supplement Categories": "intestinal & digestive supplements, multi vitamin",
          "Potential Supplies Categories": "bowls and feeders,  cleaning product, pee pads",
          "Potential Food Categories": "veterinary diets,  wet food",
          
        },
        {
          "Conditions": "Inflammatory Bowel Disease (IBD)",
          "Potential Medicine Categories": "gastro intestinal & digestive care, anti biotic",
          "Potential Supplement Categories": "intestinal & digestive supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "cleaning product,  bowls and feeders, pee pads, slowfeeder",
          "Potential Food Categories": "veterinary diets",
          
        },
        {
          "Conditions": "Gastroesophageal Reflux Disease (GERD)",
          "Potential Medicine Categories": "gastro intestinal & digestive care",
          "Potential Supplement Categories": "intestinal & digestive supplements, multi vitamin",
          "Potential Supplies Categories": "bowls and feeders,  cleaning product, pee pads, slowfeeder",
          "Potential Food Categories": "wet food,  veterinary diets",
          
        },
        {
          "Conditions": "Portosystemic Shunt \n (congenital or acquired)",
          "Potential Medicine Categories": "liver care, injectable",
          "Potential Supplement Categories": "liver supplement, immunity supplements",
          "Potential Supplies Categories": "surgical accessory,  bowls and feeders, pee pads, slowfeeder",
          "Potential Food Categories": "veterinary diets,  wet food",
          
        },
        {
          "Conditions": "Some Gastro (Stomach) Issues",
          "Potential Medicine Categories": "Gastrointestinal & Digestive Care, Antibiotic, Wound & Pain Relief, Injectable, Dewormers, Surgical Accessory, Liver Care",
          "Potential Supplement Categories": "Intestinal & Digestive Supplements, Immunity Supplements, Multi Vitamin, Liver Supplement.",
          "Potential Supplies Categories": "Bowls and Feeders, Cleaning Product, Pee Pads, Slow Feeder, Crates/Carriers/Pens, Potty Articles, Surgical Accessory.",
          "Potential Food Categories": "Wet Food, Veterinary Diets, Infant Food, Gastro Food, Recovery Food, Bland Diet, Premium Food, Hepatic Food",
          
        },
        {
          "Conditions": "Canine Influenza (Dog Flu)",
          "Potential Medicine Categories": "respiratory care, vaccine, wound and pain relief, anti biotic",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "cleaning product,  bowls and feeders, nebulizer,  hygiene product",
          "Potential Food Categories": "wet food, premium food, recovery food, gastro food",
          
        },
        {
          "Conditions": "Pneumonia \n (bacterial, viral, aspiration)",
          "Potential Medicine Categories": "respiratory care, anti biotic, wound and pain relief, injectable",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "cleaning product,  crates/carriers/penns, nebulizer,  hygiene product",
          "Potential Food Categories": "wet food, premium food, recovery food, gastro food",
          
        },
        {
          "Conditions": "Collapsing Trachea",
          "Potential Medicine Categories": "respiratory care, wound and pain relief, allergy relief",
          "Potential Supplement Categories": "immunity supplements, anxiety supplements, multi vitamin",
          "Potential Supplies Categories": "leash/collars & harnesses,  toys, nebulizer,  hygiene product",
          "Potential Food Categories": "wet food, premium food, recovery food, gastro food",
          
        },
        {
          "Conditions": "Brachycephalic Airway Syndrome \n (flat-faced breeds)",
          "Potential Medicine Categories": "respiratory care, wound and pain relief, allergy relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "leash/collars & harnesses,  cooling supplies, nebulizer,  hygiene product",
          "Potential Food Categories": "wet food, premium food, recovery food, gastro food",
          
        },
        {
          "Conditions": "Chronic Bronchitis",
          "Potential Medicine Categories": "respiratory care, wound and pain relief, allergy relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "cleaning product,  training and behaviour, nebulizer,  hygiene product",
          "Potential Food Categories": "wet food, premium food, recovery food, gastro food",
          
        },
        {
          "Conditions": "Asthma \n (rare in dogs, more common in cats)",
          "Potential Medicine Categories": "respiratory care, allergy relief, wound and pain relief",
          "Potential Supplement Categories": "immunity supplements, anxiety supplements, multi vitamin",
          "Potential Supplies Categories": "cleaning product,  toys, nebulizer,  hygiene product",
          "Potential Food Categories": "wet food, premium food, recovery food, gastro food",
          
        },
        {
          "Conditions": "Laryngeal Paralysis",
          "Potential Medicine Categories": "respiratory care, wound and pain relief, neural care",
          "Potential Supplement Categories": "immunity supplements, multi vitamin, multi vitamin",
          "Potential Supplies Categories": "leash/collars & harnesses,  crates/carriers/penns, nebulizer,  hygiene product",
          "Potential Food Categories": "wet food, premium food, recovery food, gastro food",
          
        },
        {
          "Conditions": "Kennel Cough",
          "Potential Medicine Categories": "respiratory care, anti biotic, wound and pain relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "cleaning product,  crates/carriers/penns, nebulizer,  hygiene product",
          "Potential Food Categories": "wet food, premium food, recovery food, gastro food",
          
        },
        {
          "Conditions": "Distemper",
          "Potential Medicine Categories": "canglob d, respiratory care, anti biotic, wound and pain relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "cleaning product,  hygiene product, nebulizer,  hygiene product",
          "Potential Food Categories": "wet food,  infant food, premium food, recovery food, gastro food",
          
        },
        {
          "Conditions": "Rhinitis \n (inflammation of nasal passages)",
          "Potential Medicine Categories": "respiratory care, allergy relief, anti biotic",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "cleaning product,  toys, nebulizer,  hygiene product",
          "Potential Food Categories": "wet food,  infant food, premium food, recovery food, gastro food",
          
        },
        {
          "Conditions": "Some Respiratory Issue",
          "Potential Medicine Categories": "Respiratory Care, Vaccine, Wound and Pain Relief, Antibiotic, Injectable, Allergy Relief, Neural Care, Canglob D",
          "Potential Supplement Categories": "Immunity Supplements, Multi Vitamin, Anxiety Supplements",
          "Potential Supplies Categories": "Cleaning Product, Bowls and Feeders, Nebulizer, Hygiene Product, Crates/Carriers/Pens, Leash/Collars & Harnesses, Toys, Cooling Supplies, Training and Behavior",
          "Potential Food Categories": "Wet Food, Premium Food, Recovery Food, Gastro Food, Infant Food",
          
        },
        {
          "Conditions": "Hip Dysplasia",
          "Potential Medicine Categories": "hip and joint care, wound and pain relief, neural care, wound and pain relief",
          "Potential Supplement Categories": "hip & joint supplements, calcium supplement, multi vitamin",
          "Potential Supplies Categories": "beds,  leash/collars & harnesses,  grooming,  surgical accessory, medical belts",
          "Potential Food Categories": "mobility food,  premium food, wet food",
          "Potential Food Categories__1": "Mobility Treats"
        },
        {
          "Conditions": "Elbow Dysplasia",
          "Potential Medicine Categories": "hip and joint care, wound and pain relief, injectable",
          "Potential Supplement Categories": "hip & joint supplements, immunity supplements",
          "Potential Supplies Categories": "beds,  leash/collars & harnesses,  training and behaviour, medical belts",
          "Potential Food Categories": "mobility food,  premium food, wet food",
          "Potential Food Categories__1": "Mobility Treats"
        },
        {
          "Conditions": "Arthritis (Osteoarthritis)",
          "Potential Medicine Categories": "hip and joint care, wound and pain relief, neural care",
          "Potential Supplement Categories": "hip & joint supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "beds,  grooming,  leash/collars & harnesses, medical belts",
          "Potential Food Categories": "mobility food,  premium food, wet food",
          "Potential Food Categories__1": "Mobility Treats"
        },
        {
          "Conditions": "Cruciate Ligament Injury \n (ACL/CCL tears)",
          "Potential Medicine Categories": "hip and joint care, wound and pain relief, injectable",
          "Potential Supplement Categories": "hip & joint supplements, calcium supplement, multi vitamin",
          "Potential Supplies Categories": "surgical accessory,  beds,  leash/collars & harnesses, medical belts",
          "Potential Food Categories": "mobility food,  premium food, wet food",
          "Potential Food Categories__1": "Mobility Treats"
        },
        {
          "Conditions": "Luxating Patella \n (slipping kneecap)",
          "Potential Medicine Categories": "hip and joint care, wound and pain relief, surgical accessory",
          "Potential Supplement Categories": "hip & joint supplements, calcium supplement, multi vitamin",
          "Potential Supplies Categories": "leash/collars & harnesses,  beds,  training and behaviour, medical belts",
          "Potential Food Categories": "mobility food,  premium food, wet food",
          "Potential Food Categories__1": "Mobility Treats"
        },
        {
          "Conditions": "Intervertebral Disc Disease (IVDD)",
          "Potential Medicine Categories": "wound and pain relief, neural care, injectable",
          "Potential Supplement Categories": "hip & joint supplements, immunity supplements, anxiety supplements",
          "Potential Supplies Categories": "crates/carriers/penns,  beds,  surgical accessory,  leash/collars & harnesses, medical belts",
          "Potential Food Categories": "mobility food,  premium food, wet food",
          "Potential Food Categories__1": "Mobility Treats"
        },
        {
          "Conditions": "Degenerative Myelopathy",
          "Potential Medicine Categories": "neural care, wound and pain relief, hip and joint care",
          "Potential Supplement Categories": "immunity supplements, hip & joint supplements, multi vitamin",
          "Potential Supplies Categories": "surgical accessory,  crates/carriers/penns,  beds, medical belts",
          "Potential Food Categories": "mobility food,  premium food, wet food",
          "Potential Food Categories__1": "Mobility Treats"
        },
        {
          "Conditions": "Osteosarcoma \n (bone cancer)",
          "Potential Medicine Categories": "cancer care, wound and pain relief, injectable",
          "Potential Supplement Categories": "immunity supplements, multi vitamin, hip & joint supplements",
          "Potential Supplies Categories": "surgical accessory,  beds,  leash/collars & harnesses, medical belts",
          "Potential Food Categories": "mobility food,  premium food, wet food",
          "Potential Food Categories__1": "Mobility Treats"
        },
        {
          "Conditions": "Muscle Strains & Sprains",
          "Potential Medicine Categories": "wound and pain relief, hip and joint care",
          "Potential Supplement Categories": "hip & joint supplements, multi vitamin",
          "Potential Supplies Categories": "beds,  leash/collars & harnesses,  training and behaviour, medical belts",
          "Potential Food Categories": "mobility food,  premium food, wet food",
          "Potential Food Categories__1": "Mobility Treats"
        },
        {
          "Conditions": "Myasthenia Gravis \n (neuromuscular disorder)",
          "Potential Medicine Categories": "neural care, wound and pain relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "bowls and feeders,  crates/carriers/penns, medical belts",
          "Potential Food Categories": "mobility food,  premium food, wet food",
          "Potential Food Categories__1": "Mobility Treats"
        },
        {
          "Conditions": "Legg-Calvé-Perthes Disease \n (femoral head necrosis)",
          "Potential Medicine Categories": "hip and joint care, wound and pain relief, injectable",
          "Potential Supplement Categories": "hip & joint supplements, calcium supplement, multi vitamin",
          "Potential Supplies Categories": "surgical accessory,  beds,  leash/collars & harnesses, medical belts",
          "Potential Food Categories": "mobility food,  premium food, wet food",
          "Potential Food Categories__1": "Mobility Treats"
        },
        {
          "Conditions": "Some Joint Issue",
          "Potential Medicine Categories": "Hip and Joint Care, Wound and Pain Relief, Neural Care, Injectable, Surgical Accessory, Cancer Care",
          "Potential Supplement Categories": "Hip & Joint Supplements, Calcium Supplement, Multi Vitamin, Immunity Supplements, Anxiety Supplements.",
          "Potential Supplies Categories": "Beds, Leash/Collars & Harnesses, Grooming, Surgical Accessory, Medical Belts, Training and Behavior, Crates/Carriers/Pens, Bowls and Feeders",
          "Potential Food Categories": "Mobility Food, Premium Food, Wet Food",
          "Potential Food Categories__1": "Mobility Treats"
        },
        {
          "Conditions": "Dilated Cardiomyopathy (DCM)",
          "Potential Medicine Categories": "cardiac care, wound and pain relief, injectable",
          "Potential Supplement Categories": "immunity supplements, multi vitamin, calcium supplement",
          "Potential Supplies Categories": "beds,  leash/collars & harnesses,  training and behaviour",
          "Potential Food Categories": "cardiac food,  wet food, gastro food",
          
        },
        {
          "Conditions": "Mitral Valve Disease \n (endocardiosis)",
          "Potential Medicine Categories": "cardiac care, wound and pain relief, injectable",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "beds,  leash/collars & harnesses",
          "Potential Food Categories": "cardiac food,  wet food, gastro food",
          
        },
        {
          "Conditions": "Pulmonary Hypertension",
          "Potential Medicine Categories": "cardiac care, respiratory care, wound and pain relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "cleaning product,  beds",
          "Potential Food Categories": "cardiac food,  wet food, gastro food",
          
        },
        {
          "Conditions": "Aortic Stenosis",
          "Potential Medicine Categories": "cardiac care, injectable, wound and pain relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "leash/collars & harnesses,  beds",
          "Potential Food Categories": "cardiac food,  wet food, gastro food",
          
        },
        {
          "Conditions": "Patent Ductus Arteriosus (PDA)",
          "Potential Medicine Categories": "cardiac care, wound and pain relief, surgical accessory",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "crates/carriers/penns,  beds,  leash/collars & harnesses",
          "Potential Food Categories": "cardiac food,  wet food, gastro food",
          
        },
        {
          "Conditions": "Arrhythmias \n (abnormal heart rhythms)",
          "Potential Medicine Categories": "cardiac care, wound and pain relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "training and behaviour,  beds",
          "Potential Food Categories": "cardiac food,  wet food, gastro food",
          
        },
        {
          "Conditions": "Pericardial Effusion \n (fluid around the heart)",
          "Potential Medicine Categories": "cardiac care, injectable, wound and pain relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "crates/carriers/penns,  beds",
          "Potential Food Categories": "cardiac food,  wet food, gastro food",
          
        },
        {
          "Conditions": "Heartworm Disease",
          "Potential Medicine Categories": "dewormers, cardiac care, wound and pain relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "leash/collars & harnesses,  crates/carriers/penns",
          "Potential Food Categories": "cardiac food,  wet food, gastro food",
          
        },
        {
          "Conditions": "Some Cardiac issue",
          "Potential Medicine Categories": "Cardiac Care, Wound and Pain Relief, Injectable, Respiratory Care, Surgical Accessory, Dewormers",
          "Potential Supplement Categories": "Immunity Supplements, Multi Vitamin, Calcium Supplement",
          "Potential Supplies Categories": "Beds, Leash/Collars & Harnesses, Training and Behavior, Cleaning Product, Crates/Carriers/Pens",
          "Potential Food Categories": "Cardiac Food, Wet Food, Gastro Food",
          
        },
        {
          "Conditions": "Urinary Tract Infections (UTIs)",
          "Potential Medicine Categories": "urinary tract & renal care, anti biotic, wound and pain relief",
          "Potential Supplement Categories": "renal & urinary supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "bowls and feeders,  cleaning product, natural litter",
          "Potential Food Categories": "urinary food,renal food,  wet food",
          
        },
        {
          "Conditions": "Bladder Stones (urolithiasis)",
          "Potential Medicine Categories": "urinary tract & renal care, anti biotic, wound and pain relief",
          "Potential Supplement Categories": "renal & urinary supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "bowls and feeders,  crates/carriers/penns, natural litter",
          "Potential Food Categories": "urinary food,renal food",
          
        },
        {
          "Conditions": "Kidney Disease \n (acute & chronic)",
          "Potential Medicine Categories": "urinary tract & renal care, wound and pain relief, injectable",
          "Potential Supplement Categories": "renal & urinary supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "bowls and feeders,  cleaning product, natural litter",
          "Potential Food Categories": "urinary food,renal food(kidneysupport diets,  wet food",
          
        },
        {
          "Conditions": "Renal Dysplasia",
          "Potential Medicine Categories": "urinary tract & renal care, wound and pain relief, anti biotic",
          "Potential Supplement Categories": "renal & urinary supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "bowls and feeders,  crates/carriers/penns, natural litter",
          "Potential Food Categories": "urinary food,renal food",
          
        },
        {
          "Conditions": "Cystitis \n (bladder inflammation)",
          "Potential Medicine Categories": "urinary tract & renal care, anti biotic, wound and pain relief",
          "Potential Supplement Categories": "renal & urinary supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "cleaning product,  bowls and feeders, natural litter",
          "Potential Food Categories": "urinary food,renal food",
          
        },
        {
          "Conditions": "Incontinence",
          "Potential Medicine Categories": "urinary tract & renal care, wound and pain relief",
          "Potential Supplement Categories": "renal & urinary supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "clothing,  cleaning product,  beds, natural litter",
          "Potential Food Categories": "no specific diet unless recommended by vet to address underlying cause.",
          
        },
        {
          "Conditions": "Prostate Disease \n (prostatitis, BPH)",
          "Potential Medicine Categories": "anti biotic, urinary tract & renal care, wound and pain relief",
          "Potential Supplement Categories": "renal & urinary supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "crates/carriers/penns,  cleaning product, natural litter",
          "Potential Food Categories": "urinary food,renal food",
          
        },
        {
          "Conditions": "Pyometra \n (uterine infection)",
          "Potential Medicine Categories": "anti biotic, wound and pain relief, surgical accessory",
          "Potential Supplement Categories": "renal & urinary supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "crates/carriers/penns,  beds, natural litter",
          "Potential Food Categories": "wet food or highquality food",
          
        },
        {
          "Conditions": "Mammary Tumors",
          "Potential Medicine Categories": "cancer care, wound and pain relief, anti biotic",
          "Potential Supplement Categories": "renal & urinary supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "surgical accessory,  beds,  crates/carriers/penns, natural litter",
          "Potential Food Categories": "urinary food,renal food,  wet food",
          
        },
        {
          "Conditions": "Cryptorchidism \n (undescended testicle(s))",
          "Potential Medicine Categories": "surgical accessory, wound and pain relief",
          "Potential Supplement Categories": "renal & urinary supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "crates/carriers/penns,  beds, natural litter",
          "Potential Food Categories": "no specific diet unless vet suggests otherwise",
          
        },
        {
          "Conditions": "Vaginitis",
          "Potential Medicine Categories": "anti biotic, wound and pain relief",
          "Potential Supplement Categories": "renal & urinary supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "cleaning product,  hygiene product, natural litter",
          "Potential Food Categories": "no specific diet unless recommended by vet",
          
        },
        {
          "Conditions": "Testicular Cancer",
          "Potential Medicine Categories": "cancer care, wound and pain relief, anti biotic",
          "Potential Supplement Categories": "renal & urinary supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "surgical accessory,  beds, natural litter",
          "Potential Food Categories": "urinary food,renal food",
          
        },
        {
          "Conditions": "Ovarian Cysts",
          "Potential Medicine Categories": "wound and pain relief, anti biotic, surgical accessory",
          "Potential Supplement Categories": "renal & urinary supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "crates/carriers/penns,  beds, natural litter",
          "Potential Food Categories": "wet food",
          
        },
        {
          "Conditions": "Mastitis \n (infection/inflammation of mammary gland)",
          "Potential Medicine Categories": "anti biotic, wound and pain relief, post natal care",
          "Potential Supplement Categories": "renal & urinary supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "surgical accessory,  beds,  cleaning product, natural litter",
          "Potential Food Categories": "highquality food, urinary food,renal food",
          
        },
        {
          "Conditions": "Some Kidney Issue",
          "Potential Medicine Categories": "Urinary Tract & Renal Care, Antibiotic, Wound and Pain Relief, Injectable, Surgical Accessory, Cancer Care, Post Natal Care",
          "Potential Supplement Categories": "Renal & Urinary Supplements, Immunity Supplements, Multi Vitamin",
          "Potential Supplies Categories": "Bowls and Feeders, Cleaning Product, Natural Litter, Crates/Carriers/Penns, Clothing, Beds, Surgical Accessory, Hygiene Product",
          "Potential Food Categories": "Urinary Food, Renal Food, Wet Food, High-Quality Food, Kidney Support Diets",
          
        },
        {
          "Conditions": "Hypothyroidism",
          "Potential Medicine Categories": "thyroid, wound and pain relief, skin & coat care",
          "Potential Supplement Categories": "skin & coat supplements, multi vitamin, immunity supplements",
          "Potential Supplies Categories": "medicated shampoo,  beds,  cleaning product",
          "Potential Food Categories": "premium food, gastro food",
          
        },
        {
          "Conditions": "Hyperthyroidism \n (rare in dogs)",
          "Potential Medicine Categories": "thyroid, wound and pain relief",
          "Potential Supplement Categories": "multi vitamin, immunity supplements",
          "Potential Supplies Categories": "leash/collars & harnesses,  beds",
          "Potential Food Categories": "premium food, gastro food",
          
        },
        {
          "Conditions": "Diabetes Mellitus \n (Type 1 common in dogs)",
          "Potential Medicine Categories": "diabetes, wound and pain relief, anti biotic",
          "Potential Supplement Categories": "multi vitamin, immunity supplements",
          "Potential Supplies Categories": "bowls and feeders,  cleaning product,  hygiene product",
          "Potential Food Categories": "wet food, diabetic food",
          
        },
        {
          "Conditions": "Cushing’s Disease \n (Hyperadrenocorticism)",
          "Potential Medicine Categories": "neural care or cancer care, wound and pain relief, anti biotic",
          "Potential Supplement Categories": "skin & coat supplements, immunity supplements, multi vitamin",
          "Potential Supplies Categories": "medicated shampoo,  cleaning product,  beds",
          "Potential Food Categories": "premium food, gastro food",
          
        },
        {
          "Conditions": "Addison’s Disease \n (Hypoadrenocorticism)",
          "Potential Medicine Categories": "wound and pain relief, injectable, neural care",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "crates/carriers/penns,  bowls and feeders",
          "Potential Food Categories": "premium food, gastro food",
          
        },
        {
          "Conditions": "Insulinoma \n (excess insulin tumor)",
          "Potential Medicine Categories": "diabetes, cancer care, wound and pain relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "surgical accessory,  beds",
          "Potential Food Categories": "premium food, gastro food",
          
        },
        {
          "Conditions": "Acromegaly \n (excess growth hormone)",
          "Potential Medicine Categories": "neural care or cancer care, wound and pain relief",
          "Potential Supplement Categories": "hip & joint supplements, immunity supplements",
          "Potential Supplies Categories": "beds,  leash/collars & harnesses",
          "Potential Food Categories": "premium food, gastro food",
          
        },
        {
          "Conditions": "Pituitary Dwarfism",
          "Potential Medicine Categories": "pre natal care / post natal care, thyroid, wound and pain relief",
          "Potential Supplement Categories": "multi vitamin, calcium supplement",
          "Potential Supplies Categories": "milk replacer,  crates/carriers/penns",
          "Potential Food Categories": "premium food, gastro food",
          
        },
        {
          "Conditions": "Hyperparathyroidism",
          "Potential Medicine Categories": "wound and pain relief, cancer care",
          "Potential Supplement Categories": "calcium supplement, immunity supplements",
          "Potential Supplies Categories": "surgical accessory,  beds",
          "Potential Food Categories": "premium food, gastro food",
          
        },
        {
          "Conditions": "Hypoparathyroidism",
          "Potential Medicine Categories": "wound and pain relief, injectable, neural care",
          "Potential Supplement Categories": "calcium supplement, multi vitamin",
          "Potential Supplies Categories": "crates/carriers/penns,  beds",
          "Potential Food Categories": "premium food, gastro food",
          
        },
        {
          "Conditions": "Thyroid or Gland Issues",
          "Potential Medicine Categories": "Thyroid, Wound and Pain Relief, Skin & Coat Care, Diabetes, Antibiotic, Neural Care or Cancer Care, Pre/Post Natal Care, Injectable",
          "Potential Supplement Categories": "Skin & Coat Supplements, Multi Vitamin, Immunity Supplements, Hip & Joint Supplements, Calcium Supplement",
          "Potential Supplies Categories": "Medicated Shampoo, Beds, Cleaning Product, Leash/Collars & Harnesses, Bowls and Feeders, Hygiene Product, Crates/Carriers/Penns, Surgical Accessory, Milk Replacer",
          "Potential Food Categories": "Premium Food, Gastro Food, Wet Food, Diabetic Food",
          
        },
        {
          "Conditions": "Anemia (various causes)",
          "Potential Medicine Categories": "wound and pain relief, anti biotic, cancer care, injectable",
          "Potential Supplement Categories": "multi vitamin, immunity supplements",
          "Potential Supplies Categories": "beds,  crates/carriers/penns,  cleaning product",
          "Potential Food Categories": "premium food, hepatic food",
          
        },
        {
          "Conditions": "Immune-Mediated Hemolytic Anemia (IMHA)",
          "Potential Medicine Categories": "cancer care or neural care, anti biotic, wound and pain relief",
          "Potential Supplement Categories": "multi vitamin, immunity supplements",
          "Potential Supplies Categories": "beds,  crates/carriers/penns,  cleaning product",
          "Potential Food Categories": "premium food, recovery food",
          
        },
        {
          "Conditions": "Lymphoma (cancer of lymphatic system)",
          "Potential Medicine Categories": "cancer care, anti biotic, injectable",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "crates/carriers/penns,  beds,  surgical accessory",
          "Potential Food Categories": "cancer food, recovery food",
          
        },
        {
          "Conditions": "Mast Cell Tumors",
          "Potential Medicine Categories": "cancer care, wound and pain relief, anti biotic",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "surgical accessory,  beds,  cleaning product",
          "Potential Food Categories": "premium food, cancer food, recovery food",
          
        },
        {
          "Conditions": "Hemangiosarcoma (blood vessel cancer)",
          "Potential Medicine Categories": "cancer care, wound and pain relief, injectable",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "surgical accessory,  crates/carriers/penns,  beds",
          "Potential Food Categories": "cancer food, recovery food",
          
        },
        {
          "Conditions": "Thrombocytopenia (low platelet count)",
          "Potential Medicine Categories": "anti biotic, wound and pain relief, cancer care",
          "Potential Supplement Categories": "multi vitamin, immunity supplements",
          "Potential Supplies Categories": "crates/carriers/penns,  beds",
          "Potential Food Categories": "premium food, recovery food",
          
        },
        {
          "Conditions": "Von Willebrand's Disease (clotting disorder)",
          "Potential Medicine Categories": "wound and pain relief, injectable, cancer care",
          "Potential Supplement Categories": "multi vitamin, calcium supplement",
          "Potential Supplies Categories": "cleaning product,  beds",
          "Potential Food Categories": "premium food",
          
        },
        {
          "Conditions": "Hemophilia (hereditary clotting factor deficiency)",
          "Potential Medicine Categories": "wound and pain relief, injectable, cancer care",
          "Potential Supplement Categories": "multi vitamin",
          "Potential Supplies Categories": "crates/carriers/penns,  beds",
          "Potential Food Categories": "premium food",
          
        },
        {
          "Conditions": "Autoimmune Disorders \n (e.g., lupus, pemphigus)",
          "Potential Medicine Categories": "allergy relief or cancer care, wound and pain relief",
          "Potential Supplement Categories": "immunity supplements, skin & coat supplements",
          "Potential Supplies Categories": "medicated shampoo,  beds,  cleaning product",
          "Potential Food Categories": "veterinary diets,  wet food, recovery food",
          
        },
        {
          "Conditions": "Some Blood Disorder",
          "Potential Medicine Categories": "Wound and Pain Relief, Antibiotic, Cancer Care, Injectable, Cancer Care or Neural Care, Wound and Pain Relief, Allergy Relief or Cancer Care.",
          "Potential Supplement Categories": "Multi Vitamin, Immunity Supplements, Calcium Supplement, Skin & Coat Supplements.",
          "Potential Supplies Categories": "Beds, Crates/Carriers/Penns, Cleaning Product, Surgical Accessory, Medicated Shampoo",
          "Potential Food Categories": "Premium Food, Hepatic Food, Recovery Food, Cancer Food, Veterinary Diets, Wet Food",
          
        },
        {
          "Conditions": "Lymphoma",
          "Potential Medicine Categories": "cancer care, wound and pain relief, anti biotic, injectable",
          "Potential Supplement Categories": "immunity supplements, multi vitamin, cancer supplement",
          "Potential Supplies Categories": "crates/carriers/penns,  beds,  cleaning product",
          "Potential Food Categories": "cancer food, recovery food,  wet food",
          
        },
        {
          "Conditions": "Mast Cell Tumors",
          "Potential Medicine Categories": "cancer care, wound and pain relief, anti biotic",
          "Potential Supplement Categories": "immunity supplements, multi vitamin, cancer supplement",
          "Potential Supplies Categories": "surgical accessory,  beds,  cleaning product",
          "Potential Food Categories": "wet food or premium food",
          
        },
        {
          "Conditions": "Osteosarcoma",
          "Potential Medicine Categories": "cancer care, wound and pain relief, injectable",
          "Potential Supplement Categories": "immunity supplements, calcium supplement, multi vitamin, cancer supplement",
          "Potential Supplies Categories": "surgical accessory,  leash/collars & harnesses,  beds",
          "Potential Food Categories": "cancer food, recovery food,  wet food",
          
        },
        {
          "Conditions": "Hemangiosarcoma",
          "Potential Medicine Categories": "cancer care, wound and pain relief, injectable",
          "Potential Supplement Categories": "immunity supplements, multi vitamin, cancer supplement",
          "Potential Supplies Categories": "crates/carriers/penns,  beds,  surgical accessory",
          "Potential Food Categories": "cancer food, recovery food,  wet food",
          
        },
        {
          "Conditions": "Melanoma",
          "Potential Medicine Categories": "cancer care, wound and pain relief, anti biotic",
          "Potential Supplement Categories": "immunity supplements, multi vitamin, cancer supplement",
          "Potential Supplies Categories": "surgical accessory,  beds,  cleaning product",
          "Potential Food Categories": "wet food,  cancer food, recovery food",
          
        },
        {
          "Conditions": "Squamous Cell Carcinoma",
          "Potential Medicine Categories": "cancer care, wound and pain relief, anti biotic",
          "Potential Supplement Categories": "skin & coat supplements, immunity supplements, cancer supplement",
          "Potential Supplies Categories": "medicated shampoo,  surgical accessory,  beds",
          "Potential Food Categories": "premium food or wet food, cancer food, recovery food",
          
        },
        {
          "Conditions": "Mammary Tumors",
          "Potential Medicine Categories": "cancer care, wound and pain relief, anti biotic",
          "Potential Supplement Categories": "immunity supplements, multi vitamin, cancer supplement",
          "Potential Supplies Categories": "surgical accessory,  beds,  cleaning product",
          "Potential Food Categories": "wet food,  cancer food, recovery food",
          
        },
        {
          "Conditions": "Testicular Cancer",
          "Potential Medicine Categories": "cancer care, wound and pain relief, anti biotic",
          "Potential Supplement Categories": "immunity supplements, multi vitamin, cancer supplement",
          "Potential Supplies Categories": "surgical accessory,  beds,  crates/carriers/penns",
          "Potential Food Categories": "premium food, cancer food, recovery food",
          
        },
        {
          "Conditions": "Transmissible Venereal Tumor (TVT)",
          "Potential Medicine Categories": "cancer care, anti biotic, wound and pain relief",
          "Potential Supplement Categories": "immunity supplements, multi vitamin, cancer supplement",
          "Potential Supplies Categories": "cleaning product,  surgical accessory",
          "Potential Food Categories": "wet food or premium food, cancer food, recovery food",
          
        },
        {
          "Conditions": "Other Tumors\n (fibrosarcoma, soft tissue sarcomas, etc.)",
          "Potential Medicine Categories": "cancer care, wound and pain relief, anti biotic",
          "Potential Supplement Categories": "immunity supplements, multi vitamin, cancer supplement",
          "Potential Supplies Categories": "surgical accessory,  beds,  crates/carriers/penns",
          "Potential Food Categories": "cancer food, recovery food,  wet food",
          
        },
        {
          "Conditions": "Some Type of Cancer",
          "Potential Medicine Categories": "Cancer Care, Wound and Pain Relief, Antibiotic, Injectable",
          "Potential Supplement Categories": "Immunity Supplements, Multi Vitamin, Cancer Supplement",
          "Potential Supplies Categories": "Crates/Carriers/Penns, Beds, Cleaning Product, Surgical Accessory, Leash/Collars & Harnesses, Medicated Shampoo",
          "Potential Food Categories": "Cancer Food, Recovery Food, Wet Food, Premium Food",
          
        },
        {
          "Conditions": "Poisoning \n (chocolate, xylitol, grapes/raisins, meds, rodenticides, etc.)",
          "Potential Medicine Categories": "gastro intestinal and digestive care, injectable, liver care, urinary tract and renal care, wound and pain relief, charcoal syrup",
          "Potential Supplement Categories": "liver supplement, renal & urinary supplements, immunity supplements",
          "Potential Supplies Categories": "crates/carriers/penns,  cleaning product,  bowls and feeders",
          "Potential Food Categories": "hepatic food or renal food,  wet food",
          
        },
        {
          "Conditions": "Heatstroke",
          "Potential Medicine Categories": "injectable, wound and pain relief, respiratory care",
          "Potential Supplement Categories": "multi vitamin, immunity supplements, electrolytes",
          "Potential Supplies Categories": "clothing,  cleaning product,  leash/collars & harnesses",
          "Potential Food Categories": "wet food,  premium food, recovery food",
          
        },
        {
          "Conditions": "Snakebites \n (envenomation)",
          "Potential Medicine Categories": "injectable, wound and pain relief, anti biotic",
          "Potential Supplement Categories": "immunity supplements, multi vitamin",
          "Potential Supplies Categories": "crates/carriers/penns,  beds,  cleaning product",
          "Potential Food Categories": "wet food,  premium food",
          
        },
        {
          "Conditions": "Obesity",
          "Potential Medicine Categories": "",
          "Potential Supplement Categories": "multi vitamin, hip & joint supplements, immunity supplements, obesity supplements",
          "Potential Supplies Categories": "leash/collars & harnesses,  bowls and feeders,  training and behaviour",
          "Potential Food Categories": "obesity food, mobility food",
          
        },
        {
          "Conditions": "Behavioral Disorders \n (anxiety, aggression etc)",
          "Potential Medicine Categories": "anxiety care, neural care, wound and pain relief",
          "Potential Supplement Categories": "anxiety supplements, immunity supplements",
          "Potential Supplies Categories": "training and behaviour,  toys,  crates/carriers/penns",
          "Potential Food Categories": "premium food",
          
        },
        {
          "Conditions": "Vaccine Reactions \n (rare but possible)",
          "Potential Medicine Categories": "allergy relief, wound and pain relief, injectable",
          "Potential Supplement Categories": "immunity supplements",
          "Potential Supplies Categories": "cleaning product,  crates/carriers/penns",
          "Potential Food Categories": "wet food",
          
        },
        {
          "Conditions": "",
          "Potential Medicine Categories": "",
          "Potential Supplement Categories": "",
          "Potential Supplies Categories": "",
          "Potential Food Categories": "",
          
        },
        {
          "Conditions": "Perfectly Healthy (Touch Wood)",
          "Potential Medicine Categories": "",
          "Potential Supplement Categories": "immunity supplements, multi vitamin, calcium supplement",
          "Potential Supplies Categories": "leash/collars & harnesses,  bowls and feeders,  training and behaviour,cleaning product,  crates/carriers/penns,toys",
          "Potential Food Categories": "wet food, premium food, premium wet food",
          
        }
      ])
}

function catMedicalConditionData(){
    return([
        {
          "Conditions": "Epilepsy (Seizures)",
          "Potential Medicine Categories": "NEURAL CARE,  ANXIETY CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "MULTI VITAMIN,  IMMUNITY SUPPLEMENTS,  ANXIETY SUPPLEMENTS,  Electrolytes",
          "Potential Supplies Categories": "CRATES/CARRIERS/PENNS,  BEDS,  CLEANING PRODUCT,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder,  COOLING SUPPLIES",
          "Potential Food Categories": "PREMIUM FOOD,  WET FOOD, Recovery food, Gastro Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Meningitis",
          "Potential Medicine Categories": "ANTI BIOTIC,  NEURAL CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  Electrolytes",
          "Potential Supplies Categories": "CRATES/CARRIERS/PENNS,  BEDS,  Nebulizer",
          "Potential Food Categories": "WET FOOD,  VETERINARY DIETS, Recovery food, Gastro Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Vestibular Syndrome",
          "Potential Medicine Categories": "NEURAL CARE,  EYE AND EAR CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "BEDS,  CLEANING PRODUCT,  Eye/Ear wipes,  COOLING SUPPLIES",
          "Potential Food Categories": "Premium Food,  WET FOOD, Recovery food, Gastro Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Hydrocephalus (fluid in the brain)",
          "Potential Medicine Categories": "NEURAL CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "CRATES/CARRIERS/PENNS,  BEDS,  COOLING SUPPLIES,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder or shallow dish to reduce spills",
          "Potential Food Categories": "PREMIUM WET FOOD, Recovery food, Gastro Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Wobbler Syndrome (rare in cats, cervical instability)",
          "Potential Medicine Categories": "HIP AND JOINT CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "HIP & JOINT SUPPLEMENTS,  MULTI VITAMIN, IMMUNITY SUPPLEMENTS",
          "Potential Supplies Categories": "LEASH/COLLARS & HARNESSES,  BEDS,  Surgical Accessory",
          "Potential Food Categories": "MOBILITY FOOD,  PREMIUM WET FOOD, Recovery food, Gastro Food, Premium Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Narcolepsy",
          "Potential Medicine Categories": "NEURAL CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "ANXIETY SUPPLEMENTS,  MULTI VITAMIN, IMMUNITY SUPPLEMENTS",
          "Potential Supplies Categories": "CRATES/CARRIERS/PENNS,  BEDS,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder,  COOLING SUPPLIES",
          "Potential Food Categories": "PREMIUM FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Stroke (cerebrovascular accident)",
          "Potential Medicine Categories": "NEURAL CARE,  CARDIAC CARE",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "CRATES/CARRIERS/PENNS,  BEDS,  COOLING SUPPLIES",
          "Potential Food Categories": "VETERINARY DIETS,  Mobility Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Degenerative Brain Diseases (Cognitive Dysfunction)",
          "Potential Medicine Categories": "NEURAL CARE,  ANXIETY CARE",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "TOYS,  BEDS,  TRAINING AND BEHAVIOUR,  Eye/Ear wipes,  COOLING SUPPLIES",
          "Potential Food Categories": "SENIOR Food,  WET FOODMOBILITY FOOD,  PREMIUM WET FOOD, Recovery food, Gastro Food, Premium Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Tetanus (bacterial infection, rare in cats)",
          "Potential Medicine Categories": "ANTI BIOTIC,  NEURAL CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  Electrolytes,  Charcoal syrup,  MULTI VITAMIN",
          "Potential Supplies Categories": "CLEANING PRODUCT,  CRATES/CARRIERS/PENNS",
          "Potential Food Categories": "WET FOOD,  PREMIUM WET FOOD, Recovery food, Gastro Food, Premium Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Spinal Cord Injuries (trauma, disc herniation)",
          "Potential Medicine Categories": "NEURAL CARE,  WOUND AND PAIN RELIEF,  INJECTABLE",
          "Potential Supplement Categories": "HIP & JOINT SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "SURGICAL ACCESSORY,  CRATES/CARRIERS/PENNS,  BEDS,  COOLING SUPPLIES if cat is less mobile and overheats,  Pee Pads",
          "Potential Food Categories": "MOBILITY FOOD,  PREMIUM WET FOOD, Recovery food, Gastro Food, Premium Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Encephalitis (inflammation of the brain)",
          "Potential Medicine Categories": "ANTI BIOTIC or ANTIVIRAL,  NEURAL CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "CRATES/CARRIERS/PENNS,  BEDS",
          "Potential Food Categories": "WET FOOD,  PREMIUM WET FOOD, Recovery food, Gastro Food, Premium Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Fibrocartilaginous Embolism (FCE) (spinal cord infarction)",
          "Potential Medicine Categories": "NEURAL CARE,  WOUND AND PAIN RELIEF,  HIP AND JOINT CARE",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "CRATES/CARRIERS/PENNS,  BEDS,  TRAINING AND BEHAVIOUR",
          "Potential Food Categories": "MOBILITY FOOD,  PREMIUM WET FOOD, Recovery food, Gastro Food, Premium Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Some Neurological Issue (unspecified)",
          "Potential Medicine Categories": "NEURAL CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "CRATES/CARRIERS/PENNS,  BEDS,  CLEANING PRODUCT",
          "Potential Food Categories": "WET FOOD,  PREMIUM WET FOOD, Recovery food, Gastro Food, Premium Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "",
          "Potential Medicine Categories": "",
          "Potential Supplement Categories": "",
          "Potential Supplies Categories": "",
          "Potential Food Categories": "",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Rabies",
          "Potential Medicine Categories": "VACCINE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "MULTI VITAMIN,  IMMUNITY SUPPLEMENTS, Charcoal syrup",
          "Potential Supplies Categories": "CRATES/CARRIERS/PENNS,  CLEANING PRODUCT,  COOLING SUPPLIES",
          "Potential Food Categories": "WET FOOD,  PREMIUM WET FOOD, Recovery food, Gastro Food, Premium Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Feline Leukemia Virus (FeLV)",
          "Potential Medicine Categories": "VACCINE,  ANTI BIOTIC,  IMMUNITY/ANTIVIRAL DRUGS",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  INTESTINAL & DIGESTIVE SUPPLEMENTS,  Electrolytes",
          "Potential Supplies Categories": "CRATES/CARRIERS/PENNS,  CLEANING PRODUCT,  BEDS,  COOLING SUPPLIES",
          "Potential Food Categories": "PREMIUM WET FOOD,  SENIOR FOOD, RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Feline Immunodeficiency Virus (FIV)",
          "Potential Medicine Categories": "VACCINE,  ANTI BIOTIC,  NEURAL CARE",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  ANXIETY SUPPLEMENTS,  Electrolytes",
          "Potential Supplies Categories": "CRATES/CARRIERS/PENNS,  CLEANING PRODUCT,  BEDS,  COOLING SUPPLIES",
          "Potential Food Categories": "PREMIUM FOOD or VETERINARY DIETS,  WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Feline Infectious Peritonitis (FIP)",
          "Potential Medicine Categories": "ANTI VIRAL,  NEURAL CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  Electrolytes,  Charcoal syrup",
          "Potential Supplies Categories": "CRATES/CARRIERS/PENNS,  BEDS,  COOLING SUPPLIES",
          "Potential Food Categories": "RECOVERY FOOD,  WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Toxoplasmosis",
          "Potential Medicine Categories": "ANTI BIOTIC,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "CLEANING PRODUCT,  BEDS,  Nebulizer,  COOLING SUPPLIES",
          "Potential Food Categories": "GASTRO FOOD,  WET FOOD,  RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Feline Panleukopenia \n(Feline Distemper)",
          "Potential Medicine Categories": "VACCINE,  ANTI BIOTIC,  WOUND AND PAIN RELIEF,  INJECTABLE",
          "Potential Supplement Categories": "INTESTINAL & DIGESTIVE SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  Electrolytes,  Charcoal syrup",
          "Potential Supplies Categories": "CRATES/CARRIERS/PENNS,  CLEANING PRODUCT,  BOWLS AND FEEDERS",
          "Potential Food Categories": "RECOVERY FOOD,  WET FOOD,  GASTRO FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Feline Herpesvirus (FHV)",
          "Potential Medicine Categories": "EYE AND EAR CARE,  RESPIRATORY CARE,  ANTI BIOTIC",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  Electrolytes",
          "Potential Supplies Categories": "NEBULIZER,  EYE/EAR WIPES,  CLEANING PRODUCT,  COOLING SUPPLIES if feverish,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder if cat gobbles food quickly when sense of smell returns",
          "Potential Food Categories": "RECOVERY FOOD,  WET FOOD,  GASTRO FOOD,  PREMIUM FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Feline Calicivirus (FCV)",
          "Potential Medicine Categories": "RESPIRATORY CARE,  ANTI BIOTIC,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  Electrolytes",
          "Potential Supplies Categories": "NEBULIZER,  EYE/EAR WIPES,  CLEANING PRODUCT,  COOLING SUPPLIES",
          "Potential Food Categories": "WET FOOD,  PREMIUM FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Bartonella \n(Cat Scratch Disease)",
          "Potential Medicine Categories": "ANTI BIOTIC,  FLEAS AND TICKS,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  Charcoal syrup",
          "Potential Supplies Categories": "FLEA TICK SUPPLIES,  CLEANING PRODUCT,  Pawcream if cat’s paws are irritated from scratching or fleas,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder if cat overeats due to stress",
          "Potential Food Categories": "PREMIUM FOOD, RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "",
          "Potential Medicine Categories": "",
          "Potential Supplement Categories": "",
          "Potential Supplies Categories": "",
          "Potential Food Categories": "",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Fleas, Ticks, Lice",
          "Potential Medicine Categories": "FLEAS AND TICKS,  SKIN AND COAT CARE,  WOUND AND PAIN RELIEF,  Selamectin,  Ear Cleanser",
          "Potential Supplement Categories": "SKIN & COAT SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "Tick Shampoo, flea tick supplies,  CLEANING PRODUCT,  MEDICATED SHAMPOO,  Pawcream,  COOLING SUPPLIES",
          "Potential Food Categories": "PREMIUM FOOD,  WET FOOD, RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Ear Mites (Otodectes cynotis)",
          "Potential Medicine Categories": "EYE AND EAR CARE,  WOUND AND PAIN RELIEF,  ANTI BIOTIC,  Selamectin",
          "Potential Supplement Categories": "SKIN & COAT SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "Ear Cleanser, Eye/Ear wipes,  CLEANING PRODUCT,  Pee Pads,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "PREMIUM FOOD,  WET FOOD, RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Ringworm (Dermatophytes)",
          "Potential Medicine Categories": "SKIN AND COAT CARE,  ANTI BIOTIC,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "SKIN & COAT SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "MEDICATED SHAMPOO,  CLEANING PRODUCT,  GROOMING,  Antidandruff shampoo,  Pawcream,  COOLING SUPPLIES",
          "Potential Food Categories": "PREMIUM FOOD,  WET FOOD, RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Toxoplasmosis",
          "Potential Medicine Categories": "ANTI BIOTIC,  WOUND AND PAIN RELIEF,  DEWORMERS",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  Electrolytes,  Charcoal syrup",
          "Potential Supplies Categories": "CLEANING PRODUCT,  CRATES/CARRIERS/PENNS",
          "Potential Food Categories": "GASTRO FOOD,  PREMIUM FOOD,  WET FOOD, RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Heartworms (in cats)",
          "Potential Medicine Categories": "DEWORMERS do not typically kill adult heartworms—preventive is key.,  RESPIRATORY CARE,  WOUND AND PAIN RELIEF,  Selamectin",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "CRATES/CARRIERS/PENNS,  CLEANING PRODUCT,  COOLING SUPPLIES,  Nebulizer",
          "Potential Food Categories": "GASTRO FOOD,  PREMIUM FOOD,  WET FOOD, RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Intestinal Worms \n(Rounds, Hooks, Whips, Tapes)",
          "Potential Medicine Categories": "DEWORMERS,  GASTRO INTESTINAL & DIGESTIVE CARE",
          "Potential Supplement Categories": "INTESTINAL & DIGESTIVE SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  Charcoal syrup",
          "Potential Supplies Categories": "CLEANING PRODUCT,  CRATES/CARRIERS/PENNS,  Pee Pads,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "GASTRO FOOD,  PREMIUM FOOD,  WET FOOD, RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "",
          "Potential Medicine Categories": "",
          "Potential Supplement Categories": "",
          "Potential Supplies Categories": "",
          "Potential Food Categories": "",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Hot Spots \n(acute moist dermatitis)",
          "Potential Medicine Categories": "SKIN & COAT CARE,  WOUND & PAIN RELIEF,  ANTI BIOTIC",
          "Potential Supplement Categories": "SKIN & COAT SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "MEDICATED SHAMPOO or Antidandruff shampoo,  Pawcream,  Pee Pads,  CLEANING PRODUCT, Skin Infection Shampoo,  COOLING SUPPLIES,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "Skin Support Food, Hypo Food,  WET FOOD,  PREMIUM FOOD,  GASTRO FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Yeast Infections \n(ears, paws, skin folds)",
          "Potential Medicine Categories": "EYE AND EAR CARE,  SKIN & COAT CARE,  ANTI BIOTIC,  Selamectin",
          "Potential Supplement Categories": "SKIN & COAT SUPPLEMENTS,  IMMUNITY SUPPLEMENTS",
          "Potential Supplies Categories": "Ear Cleanser,  MEDICATED SHAMPOO or Premium Shampoo,  EYE/EAR WIPES,  CLEANING PRODUCT, Skin Infection Shampoo,  COOLING SUPPLIES",
          "Potential Food Categories": "Skin Support Food, Hypo Food,  WET FOOD,  PREMIUM FOOD,  GASTRO FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Pyoderma \n(bacterial skin infections)",
          "Potential Medicine Categories": "ANTI BIOTIC,  WOUND & PAIN RELIEF,  SKIN & COAT CARE",
          "Potential Supplement Categories": "SKIN & COAT SUPPLEMENTS,  IMMUNITY SUPPLEMENTS",
          "Potential Supplies Categories": "MEDICATED SHAMPOO,  CLEANING PRODUCT,  GROOMING, Skin Infection Shampoo,  COOLING SUPPLIES,  Eye/Ear wipes",
          "Potential Food Categories": "Skin Support Food, Hypo Food,  WET FOOD,  PREMIUM FOOD,  GASTRO FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Seborrhea \n(oily or flaky skin — dandruff)",
          "Potential Medicine Categories": "SKIN & COAT CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "SKIN & COAT SUPPLEMENTS,  IMMUNITY SUPPLEMENTS",
          "Potential Supplies Categories": "Antidandruff shampoo,  MEDICATED SHAMPOO,  GROOMING,  CLEANING PRODUCT, Skin Infection Shampoo,  COOLING SUPPLIES if dryness is linked to low humidity,  Pawcream",
          "Potential Food Categories": "Skin Support Food, Hypo Food,  WET FOOD,  PREMIUM FOOD,  GASTRO FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Skin Tumors \n(benign & malignant)",
          "Potential Medicine Categories": "CANCER CARE,  WOUND AND PAIN RELIEF,  ANTI BIOTIC",
          "Potential Supplement Categories": "CANCER SUPPLEMENT,  IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  Electrolytes",
          "Potential Supplies Categories": "SURGICAL ACCESSORY,  CLEANING PRODUCT,  BEDS, Skin Infection Shampoo,  COOLING SUPPLIES",
          "Potential Food Categories": "Cancer Food, PREMIUM FOOD,  WET FOOD,  Skin Support Food, Hypo Food,  GASTRO FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Interdigital Cysts \n(between paw pads)",
          "Potential Medicine Categories": "WOUND AND PAIN RELIEF,  ANTI BIOTIC,  SKIN & COAT CARE",
          "Potential Supplement Categories": "SKIN & COAT SUPPLEMENTS,  IMMUNITY SUPPLEMENTS",
          "Potential Supplies Categories": "PAWCREAM,  CLEANING PRODUCT,  MEDICATED SHAMPOO, Skin Infection Shampoo,  COOLING SUPPLIES,  Pee Pads",
          "Potential Food Categories": "Cancer Food, PREMIUM FOOD,  WET FOOD,  Skin Support Food, Hypo Food,  GASTRO FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Alopecia \n(hair loss)",
          "Potential Medicine Categories": "ALLERGY RELIEF,  FLEAS AND TICKS,  WOUND AND PAIN RELIEF,  Selamectin",
          "Potential Supplement Categories": "SKIN & COAT SUPPLEMENTS,  IMMUNITY SUPPLEMENTS",
          "Potential Supplies Categories": "GROOMING tools,  MEDICATED SHAMPOO,  CLEANING PRODUCT, Skin Infection Shampoo, flea tick supplies",
          "Potential Food Categories": "Skin Support Food, Hypo Food,  WET FOOD,  PREMIUM FOOD,  GASTRO FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Dermatitis \n(general skin inflammation)",
          "Potential Medicine Categories": "ALLERGY RELIEF,  SKIN & COAT CARE,  ANTI BIOTIC",
          "Potential Supplement Categories": "SKIN & COAT SUPPLEMENTS,  IMMUNITY SUPPLEMENTS",
          "Potential Supplies Categories": "MEDICATED SHAMPOO or Premium Shampoo,  CLEANING PRODUCT,  EYE/EAR WIPES, Skin Infection Shampoo,  COOLING SUPPLIES,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "Skin Support Food, Hypo Food,  WET FOOD,  PREMIUM FOOD,  GASTRO FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Feline Acne \n(chin/face)",
          "Potential Medicine Categories": "SKIN & COAT CARE,  ANTI BIOTIC,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "SKIN & COAT SUPPLEMENTS,  IMMUNITY SUPPLEMENTS",
          "Potential Supplies Categories": "Salicylic Acid,  GROOMING,  CLEANING PRODUCT, Skin Infection Shampoo,  Eye/Ear wipes can be repurposed carefully for chin cleaning,  Pawcream",
          "Potential Food Categories": "Skin Support Food, Hypo Food,  WET FOOD,  PREMIUM FOOD,  GASTRO FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "",
          "Potential Medicine Categories": "",
          "Potential Supplement Categories": "",
          "Potential Supplies Categories": "",
          "Potential Food Categories": "",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Conjunctivitis \n(pink eye)",
          "Potential Medicine Categories": "EYE AND EAR CARE,  ANTI BIOTIC,  ALLERGY RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN, Mybeau Eye",
          "Potential Supplies Categories": "EYE/EAR WIPES,  CLEANING PRODUCT",
          "Potential Food Categories": "PREMIUM FOOD, WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Cataracts",
          "Potential Medicine Categories": "EYE AND EAR CARE,  WOUND AND PAIN RELIEF,  NEURAL CARE",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN, Mybeau Eye",
          "Potential Supplies Categories": "BEDS,  CRATES/CARRIERS/PENNS,  Eye/Ear wipes",
          "Potential Food Categories": "SENIOR FOOD,  PREMIUM FOOD, WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Glaucoma",
          "Potential Medicine Categories": "EYE AND EAR CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN, Mybeau Eye",
          "Potential Supplies Categories": "EYE/EAR WIPES,  CRATES/CARRIERS/PENNS",
          "Potential Food Categories": "PREMIUM FOOD or SENIOR FOOD if older cat,  WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Progressive Retinal Atrophy (PRA)",
          "Potential Medicine Categories": "NEURAL CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN, Mybeau Eye",
          "Potential Supplies Categories": "BEDS,  CRATES/CARRIERS/PENNS,  COOLING SUPPLIES,  TRAINING AND BEHAVIOUR adjustments",
          "Potential Food Categories": "SENIOR FOOD or PREMIUM FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Cherry Eye \n(prolapsed third eyelid gland)",
          "Potential Medicine Categories": "EYE AND EAR CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN, Mybeau Eye",
          "Potential Supplies Categories": "EYE/EAR WIPES,  SURGICAL ACCESSORY",
          "Potential Food Categories": "PREMIUM FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Corneal Ulcers",
          "Potential Medicine Categories": "EYE AND EAR CARE,  WOUND AND PAIN RELIEF,  ANTI BIOTIC",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN, Mybeau Eye",
          "Potential Supplies Categories": "EYE/EAR WIPES,  CLEANING PRODUCT,  Nebulizer",
          "Potential Food Categories": "WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Dry Eye \n(Keratoconjunctivitis Sicca)",
          "Potential Medicine Categories": "EYE AND EAR CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN, Mybeau Eye",
          "Potential Supplies Categories": "EYE/EAR WIPES,  CLEANING PRODUCT",
          "Potential Food Categories": "PREMIUM FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Entropion \n(inward rolling of eyelids)",
          "Potential Medicine Categories": "EYE AND EAR CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN, Mybeau Eye",
          "Potential Supplies Categories": "SURGICAL ACCESSORY,  EYE/EAR WIPES,  BEDS",
          "Potential Food Categories": "PREMIUM FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Ectropion \n(outward rolling of eyelids)",
          "Potential Medicine Categories": "EYE AND EAR CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN, Mybeau Eye",
          "Potential Supplies Categories": "EYE/EAR WIPES,  SURGICAL ACCESSORY",
          "Potential Food Categories": "PREMIUM FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Uveitis \n(inflammation inside the eye)",
          "Potential Medicine Categories": "ANTI BIOTIC or ANTIVIRAL,  EYE AND EAR CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN, Mybeau Eye",
          "Potential Supplies Categories": "EYE/EAR WIPES,  BEDS,  CLEANING PRODUCT,  Nebulizer",
          "Potential Food Categories": "WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "",
          "Potential Medicine Categories": "",
          "Potential Supplement Categories": "",
          "Potential Supplies Categories": "",
          "Potential Food Categories": "",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Ear Infections \n(otitis externa, media, interna)",
          "Potential Medicine Categories": "EYE AND EAR CARE,  ANTI BIOTIC,  WOUND AND PAIN RELIEF,  Selamectin",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  SKIN & COAT SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "Ear Cleanser,  Eye/Ear wipes,  CLEANING PRODUCT,  CRATES/CARRIERS/PENNS",
          "Potential Food Categories": "PREMIUM FOOD,  WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Ear Mites (Otodectes cynotis)",
          "Potential Medicine Categories": "EYE AND EAR CARE,  ANTI BIOTIC,  WOUND AND PAIN RELIEF,  Selamectin",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  SKIN & COAT SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "Ear Cleanser,  Eye/Ear wipes,  flea tick supplies,  CLEANING PRODUCT,  Pee Pads",
          "Potential Food Categories": "PREMIUM FOOD,  WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Aural Hematoma \n(blood-filled swelling in ear flap)",
          "Potential Medicine Categories": "WOUND AND PAIN RELIEF,  EYE AND EAR CARE,  ANTI BIOTIC",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "SURGICAL ACCESSORY,  Ear Cleanser,  CLEANING PRODUCT",
          "Potential Food Categories": "PREMIUM FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Deafness \n(congenital or acquired)",
          "Potential Medicine Categories": ",  EYE AND EAR CARE",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "TRAINING AND BEHAVIOUR,  BEDS",
          "Potential Food Categories": "PREMIUM FOOD or WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Vestibular Disease \n(balance disorders)",
          "Potential Medicine Categories": "NEURAL CARE,  EYE AND EAR CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "CRATES/CARRIERS/PENNS,  BEDS,  CLEANING PRODUCT,  Nebulizer,  Eye/Ear wipes if discharge from ear infection coexists",
          "Potential Food Categories": "WET FOOD,  PREMIUM FOOD",
          "Potential Treat Categories": "\\"
        },
        {
          "Conditions": "",
          "Potential Medicine Categories": "",
          "Potential Supplement Categories": "",
          "Potential Supplies Categories": "",
          "Potential Food Categories": "",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Periodontal Disease \n(gum disease)",
          "Potential Medicine Categories": "ANTI BIOTIC,  WOUND AND PAIN RELIEF,  SKIN & COAT CARE",
          "Potential Supplement Categories": "DENTAL CARE/MOUTH HYGIENE,  IMMUNITY SUPPLEMENTS,  Electrolytes,  MULTI VITAMIN",
          "Potential Supplies Categories": "GROOMING,  CLEANING PRODUCT,  BOWLS AND FEEDERS,FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "WET FOOD,  PREMIUM FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Gingivitis",
          "Potential Medicine Categories": "ANTI BIOTIC,  WOUND AND PAIN RELIEF,  ALLERGY RELIEF",
          "Potential Supplement Categories": "DENTAL CARE/MOUTH HYGIENE,  MULTI VITAMIN",
          "Potential Supplies Categories": "HYGIENE PRODUCT,  CRATES/CARRIERS/PENNS,  Pee Pads",
          "Potential Food Categories": "WET FOOD,  PREMIUM FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Dental Abscesses",
          "Potential Medicine Categories": "ANTI BIOTIC,  WOUND AND PAIN RELIEF,  INJECTABLE",
          "Potential Supplement Categories": "DENTAL CARE/MOUTH HYGIENE,  IMMUNITY SUPPLEMENTS,  Electrolytes,  Charcoal syrup,  MULTI VITAMIN",
          "Potential Supplies Categories": "SURGICAL ACCESSORY,  CLEANING PRODUCT,  BOWLS AND FEEDERS",
          "Potential Food Categories": "WET FOOD or RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Tooth Fractures",
          "Potential Medicine Categories": "WOUND AND PAIN RELIEF,  ANTI BIOTIC,  CANCER CARE",
          "Potential Supplement Categories": "DENTAL CARE/MOUTH HYGIENE,  CALCIUM SUPPLEMENT,  Pee Pads,  MULTI VITAMIN",
          "Potential Supplies Categories": "SURGICAL ACCESSORY,  CRATES/CARRIERS/PENNS",
          "Potential Food Categories": "WET FOOD,  RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Malocclusions \n(misaligned teeth/jaw)",
          "Potential Medicine Categories": "WOUND AND PAIN RELIEF,  ANXIETY CARE",
          "Potential Supplement Categories": "DENTAL CARE/MOUTH HYGIENE,  MULTI VITAMIN,  IMMUNITY SUPPLEMENTS",
          "Potential Supplies Categories": "FEEDERS AND BOWLS,  CLEANING PRODUCT",
          "Potential Food Categories": "WET FOOD,  PREMIUM FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Cleft Palate \n(congenital)",
          "Potential Medicine Categories": "WOUND AND PAIN RELIEF,  ANTI BIOTIC",
          "Potential Supplement Categories": "MILK REPLACER,  MULTI VITAMIN,  Electrolytes,  IMMUNITY SUPPLEMENTS",
          "Potential Supplies Categories": "SURGICAL ACCESSORY,  Pee Pads,  CRATES/CARRIERS/PENNS",
          "Potential Food Categories": "INFANT FOOD or WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Tooth Resorption \n(FORL, feline odontoclastic resorption)",
          "Potential Medicine Categories": "WOUND AND PAIN RELIEF,  ANTI BIOTIC,  INJECTABLE",
          "Potential Supplement Categories": "DENTAL CARE/MOUTH HYGIENE,  IMMUNITY SUPPLEMENTS,  Electrolytes,  MULTI VITAMIN",
          "Potential Supplies Categories": "SURGICAL ACCESSORY,  CLEANING PRODUCT",
          "Potential Food Categories": "WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "",
          "Potential Medicine Categories": "",
          "Potential Supplement Categories": "",
          "Potential Supplies Categories": "",
          "Potential Food Categories": "",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Gastroenteritis \n(vomiting & diarrhea)",
          "Potential Medicine Categories": "GASTRO INTESTINAL & DIGESTIVE CARE,  ANTI BIOTIC,  INJECTABLE",
          "Potential Supplement Categories": "INTESTINAL & DIGESTIVE SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  Electrolytes,  Charcoal syrup",
          "Potential Supplies Categories": "Pee Pads,  CLEANING PRODUCT,  CRATES/CARRIERS/PENNS",
          "Potential Food Categories": "WET FOOD,  GASTRO FOOD, Premium Food,  RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Hemorrhagic Gastroenteritis \n(HGE/AHDS)**",
          "Potential Medicine Categories": "GASTRO INTESTINAL & DIGESTIVE CARE,  ANTI BIOTIC,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "INTESTINAL & DIGESTIVE SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  Electrolytes",
          "Potential Supplies Categories": "Pee Pads,  CLEANING PRODUCT,  CRATES/CARRIERS/PENNS,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "RECOVERY FOOD,  WET FOOD, Premium Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Colitis \n(inflammation of the colon)",
          "Potential Medicine Categories": "GASTRO INTESTINAL & DIGESTIVE CARE,  DEWORMERS,  ANTI BIOTIC",
          "Potential Supplement Categories": "INTESTINAL & DIGESTIVE SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  Electrolytes",
          "Potential Supplies Categories": "Pee Pads,  CLEANING PRODUCT,  CRATES/CARRIERS/PENNS,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "GASTRO FOOD,  WET FOOD, Premium Food,  RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Pancreatitis",
          "Potential Medicine Categories": "GASTRO INTESTINAL & DIGESTIVE CARE,  WOUND AND PAIN RELIEF,  INJECTABLE",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  INT. & DIGESTIVE SUPPLEMENTS,  Electrolytes",
          "Potential Supplies Categories": "CLEANING PRODUCT,  BOWLS AND FEEDERS,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "WET FOOD,  GASTRO FOOD, Premium Food,  RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Bloat \n(Gastric Dilatation-Volvulus, rare in cats)",
          "Potential Medicine Categories": "INJECTABLE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "No specific supplement typically; ask vet if recovery protocol is needed.,  Electrolytes",
          "Potential Supplies Categories": "SURGICAL ACCESSORY,  CRATES/CARRIERS/PENNS,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "WET FOOD,  GASTRO FOOD, Premium Food,  RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Intestinal Parasites \n(worms)",
          "Potential Medicine Categories": "DEWORMERS,  GASTRO INTESTINAL & DIGESTIVE CARE",
          "Potential Supplement Categories": "INTESTINAL & DIGESTIVE SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  Charcoal syrup",
          "Potential Supplies Categories": "CLEANING PRODUCT,  CRATES/CARRIERS/PENNS,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "PREMIUM FOOD,  WET FOOD, Premium Food,  RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Liver Disease \n(hepatitis, cirrhosis)",
          "Potential Medicine Categories": "LIVER CARE,  ANTI BIOTIC,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "LIVER SUPPLEMENT,  IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  Electrolytes,  Charcoal syrup",
          "Potential Supplies Categories": "CLEANING PRODUCT,  CRATES/CARRIERS/PENNS",
          "Potential Food Categories": "HEPATIC FOOD,  WET FOOD, Premium Food,  RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Exocrine Pancreatic Insufficiency (EPI)",
          "Potential Medicine Categories": "GASTRO INTESTINAL & DIGESTIVE CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "INTESTINAL & DIGESTIVE SUPPLEMENTS,  MULTI VITAMIN,  Electrolytes",
          "Potential Supplies Categories": "BOWLS AND FEEDERS,  CLEANING PRODUCT,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "GASTRO FOOD,  WET FOOD, Premium Food,  RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Inflammatory Bowel Disease (IBD)",
          "Potential Medicine Categories": "GASTRO INTESTINAL & DIGESTIVE CARE,  ANTI BIOTIC",
          "Potential Supplement Categories": "INTESTINAL & DIGESTIVE SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  Electrolytes",
          "Potential Supplies Categories": "Pee Pads,  CLEANING PRODUCT,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "GASTRO FOOD or Hypo Food,  WET FOOD, Premium Food,  RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Gastroesophageal Reflux Disease (GERD)",
          "Potential Medicine Categories": "GASTRO INTESTINAL & DIGESTIVE CARE",
          "Potential Supplement Categories": "INTESTINAL & DIGESTIVE SUPPLEMENTS,  MULTI VITAMIN,  Electrolytes",
          "Potential Supplies Categories": "BOWLS AND FEEDERS,  CLEANING PRODUCT,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "WET FOOD,  GASTRO FOOD, Premium Food,  RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Portosystemic Shunt \n(congenital or acquired)",
          "Potential Medicine Categories": "LIVER CARE,  INJECTABLE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "LIVER SUPPLEMENT,  IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  Charcoal syrup .,  Electrolytes",
          "Potential Supplies Categories": "SURGICAL ACCESSORY,  CRATES/CARRIERS/PENNS,  BEDS",
          "Potential Food Categories": "HEPATIC FOOD,  WET FOOD, Premium Food,  RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "",
          "Potential Medicine Categories": "",
          "Potential Supplement Categories": "",
          "Potential Supplies Categories": "",
          "Potential Food Categories": "",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Feline Asthma",
          "Potential Medicine Categories": "RESPIRATORY CARE,  ALLERGY RELIEF,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  Charcoal syrup",
          "Potential Supplies Categories": "NEBULIZER,  CLEANING PRODUCT,  CRATES/CARRIERS/PENNS,  COOLING SUPPLIES,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "PREMIUM FOOD,  WET FOOD,  RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Chronic Bronchitis",
          "Potential Medicine Categories": "RESPIRATORY CARE,  ALLERGY RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "NEBULIZER,  CLEANING PRODUCT,  BEDS,  COOLING SUPPLIES,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "PREMIUM FOOD,  WET FOOD,  RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Pneumonia \n(bacterial, viral, aspiration)",
          "Potential Medicine Categories": "RESPIRATORY CARE,  ANTI BIOTIC,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  Electrolytes",
          "Potential Supplies Categories": "NEBULIZER,  CRATES/CARRIERS/PENNS,  BEDS,  COOLING SUPPLIES",
          "Potential Food Categories": "PREMIUM FOOD,  WET FOOD,  RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Collapsing Trachea \n(rare in cats, but possible)",
          "Potential Medicine Categories": "RESPIRATORY CARE,  ALLERGY RELIEF,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "LEASH/COLLARS & HARNESSES,  BEDS,  COOLING SUPPLIES,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "PREMIUM FOOD,  WET FOOD,  RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Brachycephalic Airway Syndrome \n(flat-faced cats)",
          "Potential Medicine Categories": "RESPIRATORY CARE,  ALLERGY RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS (help if chronic respiratory stress,  MULTI VITAMIN if cat tires easily or has trouble eating)",
          "Potential Supplies Categories": "CLEANING PRODUCT,  BEDS,  CRATES/CARRIERS/PENNS,  COOLING SUPPLIES,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "PREMIUM FOOD,  WET FOOD,  RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Rhinitis \n(inflammation of nasal passages)",
          "Potential Medicine Categories": "RESPIRATORY CARE,  ANTI BIOTIC,  ALLERGY RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  Electrolytes",
          "Potential Supplies Categories": "NEBULIZER,  EYE/EAR WIPES,  CLEANING PRODUCT,  COOLING SUPPLIES",
          "Potential Food Categories": "PREMIUM FOOD,  WET FOOD,  RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "",
          "Potential Medicine Categories": "",
          "Potential Supplement Categories": "",
          "Potential Supplies Categories": "",
          "Potential Food Categories": "",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Hip Dysplasia",
          "Potential Medicine Categories": "HIP AND JOINT CARE,  WOUND AND PAIN RELIEF,  NEURAL CARE",
          "Potential Supplement Categories": "HIP & JOINT SUPPLEMENTS,  CALCIUM SUPPLEMENT,  IMMUNITY SUPPLEMENTS",
          "Potential Supplies Categories": "LEASH/COLLARS & HARNESSES,  BEDS,  CRATES/CARRIERS/PENNS,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder,  COOLING SUPPLIES",
          "Potential Food Categories": "SENIOR FOOD or MOBILITY FOOD,  WET FOOD,  RECOVERY FOOD, Gastro Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Elbow Dysplasia",
          "Potential Medicine Categories": "HIP AND JOINT CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "HIP & JOINT SUPPLEMENTS,  IMMUNITY SUPPLEMENTS",
          "Potential Supplies Categories": "BEDS,  GROOMING,  CRATES/CARRIERS/PENNS,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder,  Pawcream",
          "Potential Food Categories": "PREMIUM FOOD, MOBILITY FOOD,  RECOVERY FOOD, Gastro Food,  WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Arthritis (Osteoarthritis)",
          "Potential Medicine Categories": "HIP AND JOINT CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "HIP & JOINT SUPPLEMENTS,  MULTI VITAMIN,  Obesity Supplement",
          "Potential Supplies Categories": "BEDS,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "PREMIUM FOOD, MOBILITY FOOD,  RECOVERY FOOD, Gastro Food,  WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Cruciate Ligament Injury \n(ACL/CCL tears)",
          "Potential Medicine Categories": "HIP AND JOINT CARE,  WOUND AND PAIN RELIEF,  INJECTABLE",
          "Potential Supplement Categories": "HIP & JOINT SUPPLEMENTS,  IMMUNITY SUPPLEMENTS",
          "Potential Supplies Categories": "SURGICAL ACCESSORY,  CRATES/CARRIERS/PENNS,  BEDS,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder,  COOLING SUPPLIES",
          "Potential Food Categories": "PREMIUM FOOD, MOBILITY FOOD,  RECOVERY FOOD, Gastro Food,  WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Luxating Patella \n(slipping kneecap)",
          "Potential Medicine Categories": "HIP AND JOINT CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "HIP & JOINT SUPPLEMENTS,  IMMUNITY SUPPLEMENTS",
          "Potential Supplies Categories": "BEDS,  CRATES/CARRIERS/PENNS,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder,  Pawcream",
          "Potential Food Categories": "PREMIUM FOOD, MOBILITY FOOD,  RECOVERY FOOD, Gastro Food,  WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Intervertebral Disc Disease (IVDD)",
          "Potential Medicine Categories": "NEURAL CARE,  WOUND AND PAIN RELIEF,  INJECTABLE",
          "Potential Supplement Categories": "HIP & JOINT SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  Electrolytes .",
          "Potential Supplies Categories": "CRATES/CARRIERS/PENNS,  BEDS,  SURGICAL ACCESSORY,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "PREMIUM FOOD, MOBILITY FOOD,  RECOVERY FOOD, Gastro Food,  WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Degenerative Myelopathy",
          "Potential Medicine Categories": "NEURAL CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  HIP & JOINT SUPPLEMENTS",
          "Potential Supplies Categories": "CRATES/CARRIERS/PENNS,  BEDS,  SURGICAL ACCESSORY,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder,  COOLING SUPPLIES",
          "Potential Food Categories": "PREMIUM FOOD, MOBILITY FOOD,  RECOVERY FOOD, Gastro Food,  WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Osteosarcoma \n(bone cancer)",
          "Potential Medicine Categories": "CANCER CARE,  WOUND AND PAIN RELIEF,  ANTI BIOTIC",
          "Potential Supplement Categories": "CANCER SUPPLEMENT,  IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  Electrolytes",
          "Potential Supplies Categories": "SURGICAL ACCESSORY,  BEDS,  CRATES/CARRIERS/PENNS,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "CANCER FOOD,  PREMIUM FOOD, MOBILITY FOOD,  RECOVERY FOOD, Gastro Food,  WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Muscle Strains & Sprains",
          "Potential Medicine Categories": "WOUND AND PAIN RELIEF,  HIP AND JOINT CARE",
          "Potential Supplement Categories": "HIP & JOINT SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "BEDS,  CRATES/CARRIERS/PENNS,  LEASH/COLLARS & HARNESSES,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder,  Pawcream",
          "Potential Food Categories": "PREMIUM FOOD, MOBILITY FOOD,  RECOVERY FOOD, Gastro Food,  WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Myasthenia Gravis \n(neuromuscular disorder)",
          "Potential Medicine Categories": "NEURAL CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "MULTI VITAMIN,  IMMUNITY SUPPLEMENTS,  Electrolytes",
          "Potential Supplies Categories": "BOWLS AND FEEDERS,  CRATES/CARRIERS/PENNS,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "PREMIUM FOOD, MOBILITY FOOD,  RECOVERY FOOD, Gastro Food,  WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Legg-Calvé-Perthes Disease \n(femoral head necrosis)",
          "Potential Medicine Categories": "HIP AND JOINT CARE,  WOUND AND PAIN RELIEF,  INJECTABLE",
          "Potential Supplement Categories": "HIP & JOINT SUPPLEMENTS,  CALCIUM SUPPLEMENT",
          "Potential Supplies Categories": "SURGICAL ACCESSORY,  CRATES/CARRIERS/PENNS,  BEDS,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder,  COOLING SUPPLIES",
          "Potential Food Categories": "PREMIUM FOOD, MOBILITY FOOD,  RECOVERY FOOD, Gastro Food,  WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "",
          "Potential Medicine Categories": "",
          "Potential Supplement Categories": "",
          "Potential Supplies Categories": "",
          "Potential Food Categories": "",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Dilated Cardiomyopathy (DCM)",
          "Potential Medicine Categories": "CARDIAC CARE,  WOUND AND PAIN RELIEF,  INJECTABLE",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  Taurine supplementation,  Electrolytes",
          "Potential Supplies Categories": "BEDS,  CLEANING PRODUCT,  CRATES/CARRIERS/PENNS,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "PREMIUM FOOD, WET FOOD,  CARDIAC FOOD,  RECOVERY FOOD, Gastro Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Mitral Valve Disease \n(endocardiosis)",
          "Potential Medicine Categories": "CARDIAC CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  Electrolytes",
          "Potential Supplies Categories": "BEDS,  CRATES/CARRIERS/PENNS,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "CARDIAC FOOD,  WET FOOD,  PREMIUM FOOD,  RECOVERY FOOD, Gastro Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Pulmonary Hypertension",
          "Potential Medicine Categories": "CARDIAC CARE,  RESPIRATORY CARE",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  Electrolytes",
          "Potential Supplies Categories": "NEBULIZER,  CRATES/CARRIERS/PENNS,  COOLING SUPPLIES",
          "Potential Food Categories": "CARDIAC FOOD,  WET FOOD,  PREMIUM FOOD,  RECOVERY FOOD, Gastro Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Aortic Stenosis",
          "Potential Medicine Categories": "CARDIAC CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "LEASH/COLLARS & HARNESSES,  BEDS,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder,  COOLING SUPPLIES",
          "Potential Food Categories": "CARDIAC FOOD,  WET FOOD,  PREMIUM FOOD,  RECOVERY FOOD, Gastro Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Patent Ductus Arteriosus (PDA)",
          "Potential Medicine Categories": "CARDIAC CARE,  INJECTABLE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  Electrolytes",
          "Potential Supplies Categories": "SURGICAL ACCESSORY,  CRATES/CARRIERS/PENNS,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "CARDIAC FOOD,  WET FOOD,  PREMIUM FOOD,  RECOVERY FOOD, Gastro Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Arrhythmias \n(abnormal heart rhythms)",
          "Potential Medicine Categories": "CARDIAC CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  Electrolytes",
          "Potential Supplies Categories": "CRATES/CARRIERS/PENNS,  BEDS,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "CARDIAC FOOD,  WET FOOD,  PREMIUM FOOD,  RECOVERY FOOD, Gastro Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Pericardial Effusion \n(fluid around the heart)",
          "Potential Medicine Categories": "CARDIAC CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  Electrolytes",
          "Potential Supplies Categories": "CRATES/CARRIERS/PENNS,  BEDS,  COOLING SUPPLIES",
          "Potential Food Categories": "CARDIAC FOOD,  WET FOOD,  PREMIUM FOOD,  RECOVERY FOOD, Gastro Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "",
          "Potential Medicine Categories": "",
          "Potential Supplement Categories": "",
          "Potential Supplies Categories": "",
          "Potential Food Categories": "",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Urinary Tract Infections (UTIs)",
          "Potential Medicine Categories": "URINARY TRACT & RENAL CARE,  ANTI BIOTIC,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "RENAL & URINARY SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  Electrolytes",
          "Potential Supplies Categories": "BOWLS AND FEEDERS,  CLEANING PRODUCT,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "URINARY FOOD,  WET FOOD,  PREMIUM FOOD,  RECOVERY FOOD, Gastro Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Bladder Stones (urolithiasis)",
          "Potential Medicine Categories": "URINARY TRACT & RENAL CARE,  ANTI BIOTIC,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "RENAL & URINARY SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  Electrolytes",
          "Potential Supplies Categories": "CRATES/CARRIERS/PENNS,  CLEANING PRODUCT,  BEDS,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "URINARY FOOD,  WET FOOD,  PREMIUM FOOD,  RECOVERY FOOD, Gastro Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Kidney Disease \n(acute & chronic)",
          "Potential Medicine Categories": "URINARY TRACT & RENAL CARE,  WOUND AND PAIN RELIEF,  INJECTABLE",
          "Potential Supplement Categories": "RENAL & URINARY SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  Electrolytes",
          "Potential Supplies Categories": "CRATES/CARRIERS/PENNS,  CLEANING PRODUCT,  BEDS,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "RENAL FOOD,  WET FOOD,  PREMIUM FOOD,  RECOVERY FOOD, Gastro Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Renal Dysplasia",
          "Potential Medicine Categories": "URINARY TRACT & RENAL CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "RENAL & URINARY SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  Electrolytes",
          "Potential Supplies Categories": "BEDS,  CRATES/CARRIERS/PENNS,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "RENAL FOOD,  WET FOOD,  PREMIUM FOOD,  RECOVERY FOOD, Gastro Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Cystitis \n(bladder inflammation)",
          "Potential Medicine Categories": "URINARY TRACT & RENAL CARE,  ANTI BIOTIC,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "RENAL & URINARY SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  Electrolytes .",
          "Potential Supplies Categories": "CLEANING PRODUCT,  BEDS,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "URINARY FOOD,  PREMIUM FOOD,  RECOVERY FOOD, Gastro Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Incontinence",
          "Potential Medicine Categories": "URINARY TRACT & RENAL CARE,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "RENAL & URINARY SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  Electrolytes .",
          "Potential Supplies Categories": "CLOTHING,  CLEANING PRODUCT,  BEDS,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder,  Pee Pads",
          "Potential Food Categories": "URINARY FOOD,  PREMIUM FOOD,  RECOVERY FOOD, Gastro Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Prostate Disease \n(prostatitis, BPH)",
          "Potential Medicine Categories": "(Note,  ANTI BIOTIC,  WOUND AND PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  Electrolytes",
          "Potential Supplies Categories": "CRATES/CARRIERS/PENNS,  CLEANING PRODUCT,  BOWLS AND FEEDERS, FEEDERS AND BOWLS, BOWLS AND FEEDERS, FEEDERS AND BOWLS, SlowFeeder",
          "Potential Food Categories": "PREMIUM FOOD,  WET FOOD,  PREMIUM FOOD,  RECOVERY FOOD, Gastro Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "",
          "Potential Medicine Categories": "",
          "Potential Supplement Categories": "",
          "Potential Supplies Categories": "",
          "Potential Food Categories": "",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Hypothyroidism\n(Rare in cats)",
          "Potential Medicine Categories": "THYROID CARE,  CARDIAC CARE,  SKIN & COAT CARE,  NEURAL CARE",
          "Potential Supplement Categories": "MULTI VITAMIN,  SKIN & COAT SUPPLEMENTS,  IMMUNITY SUPPLEMENTS",
          "Potential Supplies Categories": "BEDS,  GROOMING tools,  BOWLS AND FEEDERS,  Antidandruff Shampoo, Pawcream, or Skin Support Food,  SlowFeeder",
          "Potential Food Categories": "PREMIUM FOOD or VETERINARY DIETS,  SENIOR FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Hyperthyroidism\n(Common in cats)",
          "Potential Medicine Categories": "THYROID,  CARDIAC CARE,  SKIN & COAT CARE,  URINARY TRACT & RENAL CARE",
          "Potential Supplement Categories": "RENAL & URINARY SUPPLEMENTS,  LIVER SUPPLEMENT,  CALCIUM SUPPLEMENT",
          "Potential Supplies Categories": "SLOWFEEDER,  MEDICATED SHAMPOO,  GROOMING tools,  Nebulizer",
          "Potential Food Categories": "VETERINARY DIETS formulated for hyperthyroidism,  CARDIAC FOOD or RENAL FOOD,  Premium Wet Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Diabetes Mellitus",
          "Potential Medicine Categories": "DIABETES category,  WOUND & PAIN RELIEF if neuropathy or wounds occur,  URINARY TRACT & RENAL CARE",
          "Potential Supplement Categories": "MULTI VITAMIN,  IMMUNITY SUPPLEMENTS,  HIP & JOINT SUPPLEMENTS",
          "Potential Supplies Categories": "BOWLS AND FEEDERS,  POTTY ARTICLES,  BEDDING,  Pee Pads",
          "Potential Food Categories": "DIABETIC FOOD,  VETERINARY DIETS specialized for glycemic control,  OBESITY FOOD,  Recovery Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Cushing’s Disease\n(Hyperadrenocorticism)",
          "Potential Medicine Categories": "CANCER CARE if an adrenal tumor is present,  CARDIAC CARE,  WOUND & PAIN RELIEF,  DIABETES",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  SKIN & COAT SUPPLEMENTS,  Electrolytes",
          "Potential Supplies Categories": "MEDICATED SHAMPOO,  GROOMING,  BEDS,  Pawcream",
          "Potential Food Categories": "VETERINARY DIETS,  DIABETIC FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Addison’s Disease\n(Hypoadrenocorticism)",
          "Potential Medicine Categories": "NEURAL CARE,  CARDIAC CARE,  WOUND & PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  CALCIUM SUPPLEMENT,  MULTI VITAMIN,  Electrolytes",
          "Potential Supplies Categories": "HYGIENE PRODUCT,  BEDS,  TOYS,  Pee Pads",
          "Potential Food Categories": "VETERINARY DIETS that are balanced in sodium/potassium,  RECOVERY FOOD if the cat is debilitated or has poor appetite",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Insulinoma\n(Excess insulin tumor)",
          "Potential Medicine Categories": "DIABETES category,  CANCER CARE,  WOUND & PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  HIP & JOINT SUPPLEMENTS if needed for overall health,  Charcoal Syrup,  Electrolytes",
          "Potential Supplies Categories": "CRATES/CARRIERS,  BOWLS AND FEEDERS,  BEDDING",
          "Potential Food Categories": "HIGH‑PROTEIN FOOD,  RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Acromegaly\n(Excess growth hormone)",
          "Potential Medicine Categories": "DIABETES,  CARDIAC CARE,  NEURAL CARE,  WOUND & PAIN RELIEF",
          "Potential Supplement Categories": "HIP & JOINT SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "BEDS,  GROOMING,  LEASH/COLLAR/HARNESS,  SlowFeeder,  Nebulizer",
          "Potential Food Categories": "DIABETIC FOOD,  OBESITY FOOD,  VETERINARY DIETS",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Pituitary Dwarfism",
          "Potential Medicine Categories": "NEURAL CARE,  THYROID,  DIABETES",
          "Potential Supplement Categories": "MULTI VITAMIN,  IMMUNITY SUPPLEMENTS,  CALCIUM SUPPLEMENT",
          "Potential Supplies Categories": "MILK REPLACER,  BEDS,  GROOMING tools,  Pawcream",
          "Potential Food Categories": "INFANT FOOD or HIGHCALORIE WET FOOD,  VETERINARY DIETS for balanced nutrition,  Recovery Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Hyperparathyroidism",
          "Potential Medicine Categories": "CARDIAC CARE,  NEURAL CARE,  WOUND & PAIN RELIEF",
          "Potential Supplement Categories": "CALCIUM SUPPLEMENT or PHOSPHORUS BINDERS,  IMMUNITY SUPPLEMENTS,  Electrolytes",
          "Potential Supplies Categories": "BOWLS AND FEEDERS,  GROOMING for overall comfort,  Pee Pads, Cleaning Product",
          "Potential Food Categories": "RENAL FOOD,  VETERINARY DIETS",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Hypoparathyroidism",
          "Potential Medicine Categories": "NEURAL CARE,  WOUND & PAIN RELIEF,  CARDIAC CARE",
          "Potential Supplement Categories": "CALCIUM SUPPLEMENT,  VITAMIN D SUPPLEMENTS,  Electrolytes",
          "Potential Supplies Categories": "CRATES/CARRIERS,  BEDS,  Pawcream if dryness or paw issues occur",
          "Potential Food Categories": "VETERINARY DIETS,  SENIOR FOOD or PREMIUM FOOD if overall nutrition needs to be carefully managed",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "",
          "Potential Medicine Categories": "",
          "Potential Supplement Categories": "",
          "Potential Supplies Categories": "",
          "Potential Food Categories": "",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Lymphoma\n(can affect lymph nodes, GI tract, etc.)",
          "Potential Medicine Categories": "CANCER CARE,  GASTRO INTESTINAL AND DIGESTIVE CARE,  WOUND & PAIN RELIEF,  ANTI BIOTIC,  RESPIRATORY CARE",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  INTESTINAL & DIGESTIVE SUPPLEMENTS",
          "Potential Supplies Categories": "CRATES/CARRIERS,  BEDS,  GROOMING,Pawcream,Medicated Shampoo",
          "Potential Food Categories": "CANCER FOOD,  RECOVERY FOOD or PREMIUM WET FOOD,  VETERINARY DIETS",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Mast Cell Tumors\n(skin or visceral forms)",
          "Potential Medicine Categories": "CANCER CARE,  SKIN & COAT CARE,  WOUND & PAIN RELIEF,  ALLERGY RELIEF",
          "Potential Supplement Categories": "SKIN & COAT SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,Ear Cleanser",
          "Potential Supplies Categories": "MEDICATED SHAMPOO, ANTIDANDRUFF SHAMPOO,  TOYS,  BEDS,Eye/Ear Wipes,Pawcream,  Nebulizer",
          "Potential Food Categories": "CANCER FOOD or PREMIUM FOOD,  Skin Support Food",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Osteosarcoma\n(bone cancer)",
          "Potential Medicine Categories": "CANCER CARE,  WOUND & PAIN RELIEF,  NEURAL CARE,  ANTI BIOTIC",
          "Potential Supplement Categories": "HIP & JOINT SUPPLEMENTS,  CALCIUM SUPPLEMENT",
          "Potential Supplies Categories": "SURGICAL ACCESSORY,  BEDS,  LEASH/COLLARS & HARNESSES,Medical Belts,",
          "Potential Food Categories": "CANCER FOOD,  Mobility Food,  RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Hemangiosarcoma\n(affects blood vessels, spleen, etc.)",
          "Potential Medicine Categories": "CANCER CARE,  WOUND & PAIN RELIEF,  CARDIAC CARE,  ANTI BIOTIC",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  LIVER SUPPLEMENT,Electrolytes",
          "Potential Supplies Categories": "CRATES/CARRIERS,  BEDDING,  CLEANING PRODUCT,Pee Pads,  Nebulizer",
          "Potential Food Categories": "CANCER FOOD,  RECOVERY FOOD,  PREMIUM WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Melanoma\n(can affect skin, eyes, oral cavity)",
          "Potential Medicine Categories": "CANCER CARE,  WOUND & PAIN RELIEF,  EYE AND EAR CARE",
          "Potential Supplement Categories": "SKIN & COAT SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,Mybeau Eye",
          "Potential Supplies Categories": "EYE/EAR WIPES,  MEDICATED SHAMPOO,  BOWLS AND FEEDERS",
          "Potential Food Categories": "CANCER FOOD,  WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Squamous Cell Carcinoma\n(often affects skin, mouth)",
          "Potential Medicine Categories": "CANCER CARE,  WOUND & PAIN RELIEF,  ANTI BIOTIC,  SKIN & COAT CARE,Ear Cleanser",
          "Potential Supplement Categories": "SKIN & COAT SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "MEDICATED SHAMPOO,  GROOMING,  BOWLS AND FEEDERS,Pawcream,Nebulizer",
          "Potential Food Categories": "CANCER FOOD or Gastro Food,  WET FOOD,  RECOVERY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Mammary Tumors\n(breast cancer in female cats)",
          "Potential Medicine Categories": "CANCER CARE,  WOUND & PAIN RELIEF,  ANTI BIOTIC",
          "Potential Supplement Categories": "MULTI VITAMIN,  IMMUNITY SUPPLEMENTS",
          "Potential Supplies Categories": "SURGICAL ACCESSORY,  BEDS,  POTTY ARTICLES",
          "Potential Food Categories": "CANCER FOOD,  PREMIUM FOOD,  SENIOR FOOD if cat is older",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Testicular Cancer\n(rare in cats, often neutered early)",
          "Potential Medicine Categories": "CANCER CARE,  WOUND & PAIN RELIEF,  ANTI BIOTIC",
          "Potential Supplement Categories": "MULTI VITAMIN,  IMMUNITY SUPPLEMENTS",
          "Potential Supplies Categories": "SURGICAL ACCESSORY,  BEDS,  CRATES/CARRIERS",
          "Potential Food Categories": "PREMIUM FOOD,  WET FOOD or DRY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Transmissible Venereal Tumor (TVT)\n(very rare in cats)",
          "Potential Medicine Categories": "CANCER CARE,  WOUND & PAIN RELIEF,  ANTI BIOTIC",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  SKIN & COAT SUPPLEMENTS if external lesions need healing",
          "Potential Supplies Categories": "CRATES/CARRIERS,  BEDDING,Cleaning Product",
          "Potential Food Categories": "CANCER FOOD,  RECOVERY FOOD,  PREMIUM WET FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Other Tumors\n(Fibrosarcoma, soft tissue sarcomas, etc.)",
          "Potential Medicine Categories": "CANCER CARE,  WOUND & PAIN RELIEF,  INJECTABLE,  ANTI BIOTIC",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  HIP & JOINT SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "SURGICAL ACCESSORY,  BEDS,  TOYS",
          "Potential Food Categories": "CANCER FOOD,  RECOVERY FOOD,  PREMIUM FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "",
          "Potential Medicine Categories": "",
          "Potential Supplement Categories": "",
          "Potential Supplies Categories": "",
          "Potential Food Categories": "",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Poisoning\n(Chocolate, Xylitol, Grape/Raisin, Rodenticide, Other Toxins)",
          "Potential Medicine Categories": "GASTRO INTESTINAL AND DIGESTIVE CARE,  INJECTABLE,  CARDIAC CARE,  NEURAL CARE,  URINARY TRACT AND RENAL CARE,  LIVER CARE,  WOUND & PAIN RELIEF",
          "Potential Supplement Categories": "LIVER SUPPLEMENT,  RENAL & URINARY SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,  INTESTINAL & DIGESTIVE SUPPLEMENTS,Charcoal Syrup,  Electrolytes,",
          "Potential Supplies Categories": "CRATES/CARRIERS,  BEDS,  POTTY ARTICLES,  CLEANING PRODUCT, Pee Pads,  SlowFeeder",
          "Potential Food Categories": "RECOVERY FOOD,  PREMIUM WET FOOD,  GASTRO FOOD,  RENAL FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Heatstroke\n(hyperthermia, dehydration risk)",
          "Potential Medicine Categories": "RESPIRATORY CARE,  CARDIAC CARE,  INJECTABLE,  WOUND & PAIN RELIEF",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN, Electrolytes,",
          "Potential Supplies Categories": "BOWLS AND FEEDERS,  CRATES/CARRIERS,  BEDDING,  CLEANING PRODUCT",
          "Potential Food Categories": "RECOVERY FOOD,  PREMIUM WET FOOD,  GASTRO FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Obesity\n(excess weight, joint, and metabolic risk)",
          "Potential Medicine Categories": "DIABETES,  CARDIAC CARE,  HIP AND JOINT CARE,  WOUND & PAIN RELIEF",
          "Potential Supplement Categories": "OBESITY SUPPLEMENT,  HIP & JOINT SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "SLOWFEEDER,  TOYS,  TRAINING AND BEHAVIOUR,  BOWLS AND FEEDERS, Medical Belts",
          "Potential Food Categories": "OBESITY FOOD,  WET FOOD,  PREMIUM FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Behavioral Disorders\n(anxiety, aggression, OCD)",
          "Potential Medicine Categories": "ANXIETY CARE,  NEURAL CARE,  WOUND & PAIN RELIEF",
          "Potential Supplement Categories": "ANXIETY SUPPLEMENTS,  IMMUNITY SUPPLEMENTS,  MULTI VITAMIN",
          "Potential Supplies Categories": "TRAINING AND BEHAVIOUR,  TOYS,  CRATES/CARRIERS,  BEDDING, GROOMING",
          "Potential Food Categories": "PREMIUM FOOD,  WET FOOD or DRY FOOD",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Vaccine Reactions\n(rare but possible side effects)",
          "Potential Medicine Categories": "ALLERGY RELIEF,  WOUND & PAIN RELIEF,  ANTI BIOTIC,  RESPIRATORY CARE,  NEURAL CARE",
          "Potential Supplement Categories": "IMMUNITY SUPPLEMENTS,  MULTI VITAMIN,Electrolytes",
          "Potential Supplies Categories": "CRATES/CARRIERS,  BEDDING,  CLEANING PRODUCT,Pawcream,",
          "Potential Food Categories": "PREMIUM FOOD,  WET FOOD",
          "Potential Treat Categories": "Electrolytes,  Pawcream,  Observation Tools"
        },
        {
          "Conditions": "",
          "Potential Medicine Categories": "",
          "Potential Supplement Categories": "",
          "Potential Supplies Categories": "",
          "Potential Food Categories": "",
          "Potential Treat Categories": ""
        },
        {
          "Conditions": "Perfectly Healthy (Touch Wood)",
          "Potential Medicine Categories": "",
          "Potential Supplement Categories": "immunity supplements, multi vitamin, calcium supplement",
          "Potential Supplies Categories": "leash/collars & harnesses,  bowls and feeders,  training and behaviour,cleaning product,  crates/carriers/penns,toys",
          "Potential Food Categories": "wet food, premium food, premium wet food",
          "Potential Treat Categories": ""
        }
      ])
}

function getFlavors(){
  return([
    {
      "Flavours": "Chicken"
    },
    {
      "Flavours": "Lamb"
    },
    {
      "Flavours": "Fish (any Fish Flavour)"
    },
    {
      "Flavours": "Meat"
    },
    {
      "Flavours": "Turkey"
    },
    {
      "Flavours": "Duck"
    },
    {
      "Flavours": "Salmon"
    },
    {
      "Flavours": "Sardine"
    },
    {
      "Flavours": "Egg"
    },
    {
      "Flavours": "Quail"
    },
    {
      "Flavours": "Tuna"
    },
    {
      "Flavours": "Milk"
    },
    {
      "Flavours": "Cheese"
    },
    {
      "Flavours": "Whitefish"
    },
    {
      "Flavours": "Mackerel"
    },
    {
      "Flavours": "Sardine"
    },
    {
      "Flavours": "Ocean Fish"
    },
    {
      "Flavours": "Prawn/Shrimp"
    },
    {
      "Flavours": "Crab"
    },
    {
      "Flavours": "Herring"
    }
  ])
}

function getAllergies(){
  return([
    {
      "Allergies": "Beef"
    },
    {
      "Allergies": "Chicken"
    },
    {
      "Allergies": "Dairy products"
    },
    {
      "Allergies": "Eggs"
    },
    {
      "Allergies": "Fish"
    },
    {
      "Allergies": "Lamb"
    },
    {
      "Allergies": "Soy"
    },
    {
      "Allergies": "Wheat and gluten"
    },
    {
      "Allergies": "Pollen"
    },
    {
      "Allergies": "Dust mites"
    },
    {
      "Allergies": "Mold spores"
    },
    {
      "Allergies": "Household cleaners and chemicals"
    },
    {
      "Allergies": "Cigarette smoke"
    },
    {
      "Allergies": "Perfumes and air fresheners"
    },
    {
      "Allergies": "Flea saliva"
    },
    {
      "Allergies": "Fabrics"
    },
    {
      "Allergies": "Plastic"
    }
  ])
}

function getDogToys() {
  return([
    { "pet_toy": "Chew Toys" },
    { "pet_toy": "Interactive & Puzzle Toys" },
    { "pet_toy": "Fetch & Retrieval Toys" },
    { "pet_toy": "Tug Toys" },
    { "pet_toy": "Squeaky & Sound Toys" },
    { "pet_toy": "Balls & Rolling Toys" },
    { "pet_toy": "Training & Behavioral Toys" },
    { "pet_toy": "Soft Toys" }
  ]);
}


function getCatToys(){
  return([
    { "pet_toy": "Interactive Toys" },
    { "pet_toy": "Feather & Wand Toys" },
    { "pet_toy": "Catnip & Herbal Toys" },
    { "pet_toy": "Ball & Rolling Toys" },
    { "pet_toy": "Climbing & Scratching Toys" },
    { "pet_toy": "Teething & Chew Toys" },
    { "pet_toy": "Sound & Motion Toys" },
    { "pet_toy": "Soft Toys" },
    { "pet_toy": "Tunnels & Hideaways" }
  ]
  )
}
function getFarmAnimalToys() {
  return([
    { "pet_toy": "Rubber Chew Toys" },       // For goats and pigs (chewing behavior)
    { "pet_toy": "Treat Balls" },            // For pigs and goats (enrichment through food rewards)
    { "pet_toy": "Tug Toys" },               // For horses and goats (encouraging tugging and play)
    { "pet_toy": "Scratchers" },             // For pigs and goats (scratching behavior)
    { "pet_toy": "Hanging Hay Nets" },       // For horses (encouraging foraging)
    { "pet_toy": "Foam Balls" },             // For horses and pigs (fetch games)
    { "pet_toy": "Horse Balls" },            // For horses (encouraging play and interaction)
    { "pet_toy": "Jolly Balls" }             // For horses, goats, pigs (large interactive balls)
  ]);
}

function getFishReptileToys() {
  return([
    { "pet_toy": "Aquarium Decorations" },   // For fish (decorative and hiding spots)
    { "pet_toy": "Floating Logs" },          // For turtles and aquatic reptiles (basking)
    { "pet_toy": "Climbing Rocks" },         // For reptiles (geckos, snakes)
    { "pet_toy": "Suction Cup Toys" },       // For fish (interactive objects they can push around)
    { "pet_toy": "Basking Platforms" },      // For turtles and aquatic reptiles (resting)
    { "pet_toy": "Tunnels & Hides" },        // For reptiles (hiding spots for security)
    { "pet_toy": "Foraging Mats" },          // For reptiles (encouraging foraging behavior)
    { "pet_toy": "Reptile Climbing Branches" } // For reptiles (climbing enrichment)
  ]);
}

function getBirdToys() {
  return([
    { "pet_toy": "Chew Toys" },             // For all birds (especially parrots and cockatoos)
    { "pet_toy": "Foraging Toys" },         // For parrots and other intelligent birds (mental stimulation)
    { "pet_toy": "Swing Toys" },            // For small to medium-sized birds (budgies, cockatiels)
    { "pet_toy": "Bell Toys" },             // For parrots and cockatiels (sound enrichment)
    { "pet_toy": "Foot Toys" },             // For smaller birds like finches and budgies
    { "pet_toy": "Shredding Toys" },        // For parrots and cockatoos (chewing and shredding)
    { "pet_toy": "Mirror Toys" },           // For some birds (especially parrots)
    { "pet_toy": "Climbing Ladders" },      // For parrots and other large birds
    { "pet_toy": "Wobble Toys" }            // For small birds (mental and physical exercise)
  ]);
}


// function vetDataInformation(){

//   return([
//     {
//       "Vet Name": "Dr. Aarakh Sharad P.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Abadian Meher",
//       "Clinic Name": "Pawsitive Veterinary Speciality"
//     },
//     {
//       "Vet Name": "Dr. Abdi Shagufta",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Acharya Akhila",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Agarkar Yogesh",
//       "Clinic Name": "Innovet Lab"
//     },
//     {
//       "Vet Name": "Dr. Agivale Satyawan",
//       "Clinic Name": "Univet Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Ajjampur Anirudh",
//       "Clinic Name": "Rmv Multi-Speciality Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Akerkar Disha Aditya",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Alim S",
//       "Clinic Name": "Bombay Veterinary College"
//     },
//     {
//       "Vet Name": "Dr. Amarnath Muthukrishnan",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Apte Nupura P.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Ambre Vaibhav K",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Aswani Kush",
//       "Clinic Name": "Ripper’S Yard Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Anand Gautam",
//       "Clinic Name": "Dr. Anand’S Pets Clinic"
//     },
//     {
//       "Vet Name": "Dr. Atole Ganesh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Avari Percy",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Anoop Kumar",
//       "Clinic Name": "Dr. Anoop’S Pet Clinic & Care Centre"
//     },
//     {
//       "Vet Name": "Dr. Antia Nazneen Perviz",
//       "Clinic Name": "R. N. Gamadia Polyclinic"
//     },
//     {
//       "Vet Name": "Dr. Awale Madhavi",
//       "Clinic Name": "Pet Wellness Clinic"
//     },
//     {
//       "Vet Name": "Dr. Ayana Rajeev",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Badekar - Narale Savita",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Badgujar Chandravadan L.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Badgujar Ishwari C.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Bagul P.D.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Bait Kaustubh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Bakshi Shruti",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Balbhadra Sristi",
//       "Clinic Name": "Dr. Sristi Pet Well Clinic And Hospital Llp"
//     },
//     {
//       "Vet Name": "Dr. Balgi Sunad Ganpati",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Bandivadekar Shvesh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Bane Kshitij",
//       "Clinic Name": "Dr. Bane'S Pet Clinicc"
//     },
//     {
//       "Vet Name": "Dr. Bait Kaustubh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Banerji Indrakshi",
//       "Clinic Name": "The Violet Vets"
//     },
//     {
//       "Vet Name": "Dr. Banka Pushkar",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Bapat Archana Dhananjay",
//       "Clinic Name": "Dr. Bapat’S Exotic Pet Clinic , Dr. Bapat’S Pet Animal Hospital"
//     },
//     {
//       "Vet Name": "Dr. Bapat Chandrashekhar G.",
//       "Clinic Name": "Dr. Bapat’S Pet Animal Hospital / My Lovely Pet Shop"
//     },
//     {
//       "Vet Name": "Dr. Bapat Dhananjay",
//       "Clinic Name": "Dr. Bapat’S Pet Animal Hospital"
//     },
//     {
//       "Vet Name": "Dr. Bapat Girish",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Bapat Janhavi G.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Barve Nivedita",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Bate Aziz D.",
//       "Clinic Name": "Zinnia Pet Care"
//     },
//     {
//       "Vet Name": "Dr. Batwe Kishor D.",
//       "Clinic Name": "Pet Animal Clinic"
//     },
//     {
//       "Vet Name": "Dr. Baviskar Snehalata",
//       "Clinic Name": "Animal Care Clinic"
//     },
//     {
//       "Vet Name": "Dr. Belsare Manjiri",
//       "Clinic Name": "Blossom Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Bendale Kiran R.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Bhabani Kumar Sarma",
//       "Clinic Name": "Dr. Sarma’S Animal Care Home"
//     },
//     {
//       "Vet Name": "Dr. Bhadane Rahul",
//       "Clinic Name": "Phoenix Petcare"
//     },
//     {
//       "Vet Name": "Dr. Bhadsavle Kasturi",
//       "Clinic Name": "The Eye Vet"
//     },
//     {
//       "Vet Name": "Dr. Bhagwat Avinash",
//       "Clinic Name": "Samartha Pet Clinic & Diagnostic Center"
//     },
//     {
//       "Vet Name": "Dr. Bhalerao Dipti",
//       "Clinic Name": "Veterinary Medical & Surgical Centre"
//     },
//     {
//       "Vet Name": "Dr. Bharucha Simin",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Bhatia Ami",
//       "Clinic Name": "Pet Care Clinic"
//     },
//     {
//       "Vet Name": "Dr. Bhattacharya Subir",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Bhere Sanjay K",
//       "Clinic Name": "Shrikrupa Pet Care Centre"
//     },
//     {
//       "Vet Name": "Dr. Bhide Sucheta",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Bhoir Mahesh Shyamkant",
//       "Clinic Name": "Sai Samarth Vet Clinic & Pet Shop"
//     },
//     {
//       "Vet Name": "Dr. Bhoir Sharad T",
//       "Clinic Name": "Shree Pet Shop & Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Bhoir Subhash",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Bhosale Devendra D.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Bhosale Nitin",
//       "Clinic Name": "Shivani Pet Shop/Clinic & Poultry Consultancy Ctr."
//     },
//     {
//       "Vet Name": "Dr. Bhosale Sacheen P.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Bhujbal Jagannath N.",
//       "Clinic Name": "Viraj Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Bhutiakarmadorjee",
//       "Clinic Name": "Birds Beasts & Relatives Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Bichkar Ashwini",
//       "Clinic Name": "Precious Pets’ World Cat & Dog Clinic"
//     },
//     {
//       "Vet Name": "Dr. Bijapur Adarsh",
//       "Clinic Name": "Urban Paws Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Bijarniya Devindra",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Birajdar Prashant",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Bishnoi Shravani",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Borkar Neha",
//       "Clinic Name": "Vedant Pet Dispensary"
//     },
//     {
//       "Vet Name": "Dr. Carvalho Gloraine",
//       "Clinic Name": "Active Vets Veterinary Speciality Clinic"
//     },
//     {
//       "Vet Name": "Dr. Chakraborty Aparajita",
//       "Clinic Name": "Apc Pets Speciality Clinic & Referral Care"
//     },
//     {
//       "Vet Name": "Dr. Chapane Anil",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Charde Prajakta",
//       "Clinic Name": "Urban Pet Centre"
//     },
//     {
//       "Vet Name": "Dr. Chariar Jaya Veerraghavan",
//       "Clinic Name": "Dr Chariar Pets Specialty Clinic"
//     },
//     {
//       "Vet Name": "Dr. Chaudhari Bhushan",
//       "Clinic Name": "Shiro’S Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Chaudhari Devendra P.",
//       "Clinic Name": "Unique Biodiagnostics Enterprises (Vet Pathology Laboratory"
//     },
//     {
//       "Vet Name": "Dr. Chaudhari Dilip B.",
//       "Clinic Name": "Sai Samarth Vet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Chaudhari Kamalakar",
//       "Clinic Name": "Versatile Vets Pet Clinic & Surgical Centre"
//     },
//     {
//       "Vet Name": "Dr. Chaudhari Pradip",
//       "Clinic Name": "(Actrec, Tata Memorial Centre Animal Oncology Group / Comparative Oncology Prog."
//     },
//     {
//       "Vet Name": "Dr. Chaudhari Ravindra J.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Chaudhary Anil",
//       "Clinic Name": "Pets Care Hospital / Bell Avenue / Lambodar Avenue"
//     },
//     {
//       "Vet Name": "Dr. Chauhan Aarti",
//       "Clinic Name": "Pretty Paws Pet Clinic N Petshop"
//     },
//     {
//       "Vet Name": "Dr. Chauhan Bhavin",
//       "Clinic Name": "Fur N Paws Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Chavan Khagol",
//       "Clinic Name": "Vets For Pets Clinic (Multiple Branches"
//     },
//     {
//       "Vet Name": "Dr. Chavan Makarand S.",
//       "Clinic Name": "Dogs & Cats Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Chavan Panjab G.",
//       "Clinic Name": "Four Paws Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Chavan Sharad Ratnakar",
//       "Clinic Name": "Small & Exotic Animal Hospital"
//     },
//     {
//       "Vet Name": "Dr. Chavan Vinod R.",
//       "Clinic Name": "Eagel 9 Pet Shop And Clinic"
//     },
//     {
//       "Vet Name": "Dr. Chinoy Zenobia",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Chitnis Aditi",
//       "Clinic Name": "Purple Paws Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Chitnis Sayali S",
//       "Clinic Name": "Petbliss Animal Clinic"
//     },
//     {
//       "Vet Name": "Dr. Choudhury Aparajita",
//       "Clinic Name": "Petclinic"
//     },
//     {
//       "Vet Name": "Dr. Chougale Pushpanath Balaso",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Chousalkar Makarand",
//       "Clinic Name": "Top Dog Pets Clinic"
//     },
//     {
//       "Vet Name": "Dr. Chousalkar Sushruta",
//       "Clinic Name": "Top Dog Pets Clinic"
//     },
//     {
//       "Vet Name": "Dr. Cooper Jamshyd",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Cooper Sharlene",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Dadke Anand Rajshekhar",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Dadke Rajshekhar S.",
//       "Clinic Name": "Dog Care Point Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Dagli Nilesh R.",
//       "Clinic Name": "Dr. Dagli Pet Animal Clinic"
//     },
//     {
//       "Vet Name": "Dr. Dakhane Prajyot",
//       "Clinic Name": "Pet Well Soon Clinic & Surgical Center"
//     },
//     {
//       "Vet Name": "Dr. Dalal Leena",
//       "Clinic Name": "Maxpetz Hospitals"
//     },
//     {
//       "Vet Name": "Dr. Dalvi Darshan",
//       "Clinic Name": "Shree Pets Clinic"
//     },
//     {
//       "Vet Name": "Dr. Dalvi Santosh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Dalvi Swapnil",
//       "Clinic Name": "Dogs & Cats Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Dandge Shariva",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Darji Premal",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Dash Biswajit R.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Datir Anil A",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Dave Ankit R.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Dave Ashlesha",
//       "Clinic Name": "Blue7Vets"
//     },
//     {
//       "Vet Name": "Dr. Dave Chirag",
//       "Clinic Name": "Dr. Chirag Dave’S Pets’ Clinic"
//     },
//     {
//       "Vet Name": "Dr. Dave Vikram",
//       "Clinic Name": "Blue7Vets"
//     },
//     {
//       "Vet Name": "Dr. Dawane Sumedh Chandrakant",
//       "Clinic Name": "Pet Aangan"
//     },
//     {
//       "Vet Name": "Dr. Deore Milind",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Desai Abhay",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. De Munmun",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Deb Amrita Manchanda",
//       "Clinic Name": "Wildvets Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Deekshit Smita",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Desai Alisha",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Desai Noopur",
//       "Clinic Name": "The Cancer Vet"
//     },
//     {
//       "Vet Name": "Dr. Deshkar Swagat",
//       "Clinic Name": "Animal Profile Pet Clinic & Diagnostics"
//     },
//     {
//       "Vet Name": "Dr. Deshmukh Prathmesh",
//       "Clinic Name": "Acumed Veterinary Specialty"
//     },
//     {
//       "Vet Name": "Dr. Deshmukh Rahul",
//       "Clinic Name": "Chromoxpert Research And Diagnostics Pvt. Ltd."
//     },
//     {
//       "Vet Name": "Dr. Deshpande Deepti",
//       "Clinic Name": "Don’T Skip A Beat"
//     },
//     {
//       "Vet Name": "Dr. Deshpande Mandar",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Deshpande Rutuja",
//       "Clinic Name": "Shiro’S Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Deshpande Shirish R.",
//       "Clinic Name": "Dr Deshpande’S Petcare Centre"
//     },
//     {
//       "Vet Name": "Dr. Dev Rina",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Devlekar Kunal Manohar",
//       "Clinic Name": "Dr. Kunal M Devlekar Veterinary Service"
//     },
//     {
//       "Vet Name": "Dr. Dhamankar Sanjeet B.",
//       "Clinic Name": "Taluka Veterinary Clinic Shahada"
//     },
//     {
//       "Vet Name": "Dr. Dhawale Sonali Swaminath",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Dhawale Swaminath",
//       "Clinic Name": "Pets Home Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Dhokale Ankush",
//       "Clinic Name": "My Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Dhokrikar Pradnya",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Dhopatkar Aditya",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Dhotre Ravikiran",
//       "Clinic Name": "Kanthak & Sanath Pet Clinic & Shop"
//     },
//     {
//       "Vet Name": "Dr. Dhule Roshni",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. (Col Dhumal R V",
//       "Clinic Name": "Paw Care Clinic"
//     },
//     {
//       "Vet Name": "Dr. Dhuri Ashika",
//       "Clinic Name": "Small & Exotic Animal Hospital"
//     },
//     {
//       "Vet Name": "Dr. Diwadkar Dinkargurunath",
//       "Clinic Name": "Pet’S Partner.In"
//     },
//     {
//       "Vet Name": "Dr. D’Silva Karen",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. D’Souza Nadia Mildred",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Dubash Danish",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Dubey Piyush",
//       "Clinic Name": "Petmedics – Small Animal Veterinary Centre"
//     },
//     {
//       "Vet Name": "Dr. Dudhatra Ghanshyam",
//       "Clinic Name": "Pet Wellness Clinic"
//     },
//     {
//       "Vet Name": "Dr. Dwivedi Rajendra",
//       "Clinic Name": "Hi-Tech Veterinary Polyclinic"
//     },
//     {
//       "Vet Name": "Dr. Estibeiro Marilyn",
//       "Clinic Name": "Estibeiro Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Fernandes Laila",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Gadge S. M.",
//       "Clinic Name": "Prolife Speciality Vet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Gaikwad Rajiv V.",
//       "Clinic Name": "Pets Clinic"
//     },
//     {
//       "Vet Name": "Dr. Gaikwad Rohit Eknath",
//       "Clinic Name": "Pet’S Health Corner Office"
//     },
//     {
//       "Vet Name": "Dr. Gaikwad Shahir",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Gail Perpetua Martin",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Gangawane Shivali V.",
//       "Clinic Name": "Shree Pet Care"
//     },
//     {
//       "Vet Name": "Dr. Ganjwala Henna",
//       "Clinic Name": "Crittercare Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Garud Kaustubh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Gate Mukulesh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Gaurat Ravindrakumar",
//       "Clinic Name": "Shree Maauli Pet Care"
//     },
//     {
//       "Vet Name": "Dr. Gavkar Mandar",
//       "Clinic Name": "Dr Mandar’S Vet Clinic (Belavali Branch"
//     },
//     {
//       "Vet Name": "Dr. Ghadigaonkar Mangesh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Ghadigaonkar Sushma",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Ghag Rupali Sunil",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Ghangale Anita G.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Ghangale Ganesh",
//       "Clinic Name": "Rowdy Pet (Clinic & Pet Shop"
//     },
//     {
//       "Vet Name": "Dr. Ghanvat H.G.",
//       "Clinic Name": "Pets Care Clinic"
//     },
//     {
//       "Vet Name": "Dr. Ghiara Percis A.",
//       "Clinic Name": "R.N. Gamadia Polyclinic"
//     },
//     {
//       "Vet Name": "Dr. Ghiara Rhea A.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Ghosale Shraddha",
//       "Clinic Name": "Petbond Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Ghosh Krishanu",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Giri Tina",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Gite Varsha",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Gokarn Nishit",
//       "Clinic Name": "The Progressive Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Gore Ajit",
//       "Clinic Name": "Pet-Care Clinic"
//     },
//     {
//       "Vet Name": "Dr. Gore Ganesh H.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Gorhe Vinay",
//       "Clinic Name": "Vetlab"
//     },
//     {
//       "Vet Name": "Dr. Goutam Mukherjee",
//       "Clinic Name": "Gatewell Pet Center"
//     },
//     {
//       "Vet Name": "Dr. Gudewar Jagdish",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Gulavane Sarita",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Gunjate Aditya Babasaheb",
//       "Clinic Name": "Aditya Veterinary Clinic & Diagnostic Center"
//     },
//     {
//       "Vet Name": "Dr. Gunjate B B",
//       "Clinic Name": "Aditya Veterinary Clinic & Diagnostic Center"
//     },
//     {
//       "Vet Name": "Dr. Gupta Madhurita",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Gupta Mahima Kaur",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Gupta Maneesh Kumar",
//       "Clinic Name": "Vetlab"
//     },
//     {
//       "Vet Name": "Dr. Gupte Aditi",
//       "Clinic Name": "Top Dog Pets Clinic"
//     },
//     {
//       "Vet Name": "Dr. Gupte Karishma",
//       "Clinic Name": "Vetbiotics Pet Clinic And Supplies"
//     },
//     {
//       "Vet Name": "Dr. Hande Salil",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Hase Pankaj Bhanudas",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Hatekar M. S.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Hatzade Ravindrakumar I.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Hingonekar Namrata R.",
//       "Clinic Name": "Dr. Namrata’S Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Ingle Chinmay",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Ingole Krishna Hariba",
//       "Clinic Name": "Royal Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Ingole Shailesh",
//       "Clinic Name": "Pets Care Centre"
//     },
//     {
//       "Vet Name": "Dr. Inkar Baliram K.",
//       "Clinic Name": "Nalanda Pet Animal Clinic"
//     },
//     {
//       "Vet Name": "Dr. Jadhav Abhishek B.",
//       "Clinic Name": "Aj’S Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Jadhav Bhaskarrao A.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Jadhav Devendra S.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Jadhav Janhavi Shirishkumar",
//       "Clinic Name": "Kimaya Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Jadhav Nilesh",
//       "Clinic Name": "Nirmala Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Jadhav Sandip Ramchanora",
//       "Clinic Name": "Doctor Pets Health Care Center"
//     },
//     {
//       "Vet Name": "Dr. Jadhav Shashikant Shivaji",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Jadhav Sheela Nilesh",
//       "Clinic Name": "Nirmala Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Jadhav Vishwanath",
//       "Clinic Name": "Sparsh Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Jagadale Suresh Dattatray",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Jaikar Kapil",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Jain Anshul",
//       "Clinic Name": "Lexi Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Jain Padam",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Jain Rajkumar",
//       "Clinic Name": "Interpet The Pets Clinic"
//     },
//     {
//       "Vet Name": "Dr. Jamma Vaibhav",
//       "Clinic Name": "Vaibhav’S Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Javeri Freya",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Javia Chirag",
//       "Clinic Name": "Pets & Paws Veterinary Hospital"
//     },
//     {
//       "Vet Name": "Dr. Jayakar Nihar",
//       "Clinic Name": "Pawprints Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Jayarajan Ashwin",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Jayarao Bhushan",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Jena Deepika",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Jeyabharath Uma Sankari",
//       "Clinic Name": "5Th Sense Animal Health Care"
//     },
//     {
//       "Vet Name": "Dr. Joge Sandip Y.",
//       "Clinic Name": "Dog Clinic And Care Center"
//     },
//     {
//       "Vet Name": "Dr. Joglekar Achina",
//       "Clinic Name": "Petland Vet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Joglekar Gautam",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Joshi Malhar",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Joshi Yash J.",
//       "Clinic Name": "D.R Chirag Dave'S Pets’ Clinic"
//     },
//     {
//       "Vet Name": "Dr. Kadam Sham Naraynrao",
//       "Clinic Name": "Seva Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Kaginkar Yuvraj R",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kalambi Shantanu",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kale Popat",
//       "Clinic Name": "Nashik Pet Hospital"
//     },
//     {
//       "Vet Name": "Dr. Kalekar Nitin Balkrishna",
//       "Clinic Name": "Barks And Mews"
//     },
//     {
//       "Vet Name": "Dr. Kalhapure Babasaheb J.",
//       "Clinic Name": "Pets Friends Clinic / Dr Pet (Multiple Branches"
//     },
//     {
//       "Vet Name": "Dr. Kalsy Barry",
//       "Clinic Name": "Too Dog Health Care Pvt. Ltd"
//     },
//     {
//       "Vet Name": "Dr. Kamble Dattatraya A.",
//       "Clinic Name": "Dr. Kamble’S Pet Clinic & Diagnostics"
//     },
//     {
//       "Vet Name": "Dr. Kamble Rajesh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kamble Sarojini",
//       "Clinic Name": "Planet Animal Hospital"
//     },
//     {
//       "Vet Name": "Dr. Kamble Shashank",
//       "Clinic Name": "The Dermat Vet"
//     },
//     {
//       "Vet Name": "Dr. Kamble Sparsh",
//       "Clinic Name": "Planet Animal Hospital"
//     },
//     {
//       "Vet Name": "Dr. Kantak Pradnya",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kapratwar Mangesh",
//       "Clinic Name": "Karunya Pets Clinic & Doggy Articles"
//     },
//     {
//       "Vet Name": "Dr. Karandikar Hrushikesh",
//       "Clinic Name": "Ark Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Karkare Hrishikesh",
//       "Clinic Name": "Happy Tails Veterinary Speciality"
//     },
//     {
//       "Vet Name": "Dr. Karkare Umesh",
//       "Clinic Name": "Happy Tails Veterinary Speciality / Happy Tails World Llp"
//     },
//     {
//       "Vet Name": "Dr. Karkhanis Sandeep",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Karn (Surve Manisha",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Karve Sanjana",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kasar Sanjay Santu",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kashid Kiran P.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kasundra Jayesh",
//       "Clinic Name": "Om Veterinary Hospital"
//     },
//     {
//       "Vet Name": "Dr. Katyal Deepa",
//       "Clinic Name": "Animal Wellness & Rehab Centre"
//     },
//     {
//       "Vet Name": "Dr. Kaur Jasleen",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kavale Rajesh",
//       "Clinic Name": "My Pet Shop & Clinic"
//     },
//     {
//       "Vet Name": "Dr. Kavechiya Vipul Kumar",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kayande Devayani",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kelkar Pallavi",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Keni Komal",
//       "Clinic Name": "Pet Ozone Clinic"
//     },
//     {
//       "Vet Name": "Dr. Kesharkar Jeevan A.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Khade Shailesh",
//       "Clinic Name": "Vet4Pet Animal Care Clinic"
//     },
//     {
//       "Vet Name": "Dr. Khajuria Rupali",
//       "Clinic Name": "Ss Lifeline Veterinary Care"
//     },
//     {
//       "Vet Name": "Dr. Khambatta Phiroz",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Khan Akhiyar",
//       "Clinic Name": "Max Vets Animal Health Care"
//     },
//     {
//       "Vet Name": "Dr. Khanam Reshma W",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Khanchandani Vijaya",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Khandekar G. S.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Khandekar Gaurav",
//       "Clinic Name": "Suyash Pets Clinic & Surgical Centre"
//     },
//     {
//       "Vet Name": "Dr. Khatariya Mithun",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Khillare Kavita P.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Khot Dipak",
//       "Clinic Name": "Dog Lodging & Boarding"
//     },
//     {
//       "Vet Name": "Dr. Kokane Raju",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kolpe Sachin",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Korade Nakul B.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Korgaonkar Ishan Anil",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Krishna Abhignya",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kudalkar Salil Devendra",
//       "Clinic Name": "Top Dog Clinic"
//     },
//     {
//       "Vet Name": "Dr. Kulkarni Aishwarya",
//       "Clinic Name": "Top Dog Clinic"
//     },
//     {
//       "Vet Name": "Dr. Kulkarni Girish Eknath",
//       "Clinic Name": "Kanfe Globuz Pet Polyclinics"
//     },
//     {
//       "Vet Name": "Dr. Kulkarni Vinita",
//       "Clinic Name": "Mahim Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Kumar Om Prakash",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kuppaswamy Uma Sankari",
//       "Clinic Name": "5Th Sense Animal Health Care"
//     },
//     {
//       "Vet Name": "Dr. Lt Col Kuruvilla Jerin",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Lahane Smita Anil",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Lakhpati Aboli",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Lalwani Shaurat",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Lattoo Sarang H",
//       "Clinic Name": "Animal Health Care"
//     },
//     {
//       "Vet Name": "Dr. Lavate Nitin",
//       "Clinic Name": "Furry Tales Health Care / Myra Plus Pet Health Care"
//     },
//     {
//       "Vet Name": "Dr. Lele Chaitanya",
//       "Clinic Name": "Kalina Animal Clinic / Malad Animal Clinic"
//     },
//     {
//       "Vet Name": "Dr. Lokhande Dinesh U.",
//       "Clinic Name": "Dr. Lokhande’S Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Londhe Pradeep Bhagwan",
//       "Clinic Name": "Pranjal Pets Clinic"
//     },
//     {
//       "Vet Name": "Dr. Mahadik Guruprasad S.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Mahadik Vinod D.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Mahajan Narendra",
//       "Clinic Name": "Pet Home"
//     },
//     {
//       "Vet Name": "Dr. Mahale A. R.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Mahind Kishor",
//       "Clinic Name": "Vets4Pets Inside Pets At Home"
//     },
//     {
//       "Vet Name": "Dr. Makde Asha",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Mali Ajit Bayaji",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Malik Nikhil Sagar",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Mane Roshni",
//       "Clinic Name": "Furry Cuddle"
//     },
//     {
//       "Vet Name": "Dr. Manjure Ninad",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Mankad Manan",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Manthana Amin",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Marchande Mukesh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Margaj Rajendra Kumar",
//       "Clinic Name": "Dr. Margaj Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Markandeya N.M.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Marwaha Pooja",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Mate Rahul Yashwant",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Mathur Sanjay",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Mehta Nikita",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Mehta Sahil",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Mer Pradipkumar",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Meshram Milind D",
//       "Clinic Name": "Anant Enclave"
//     },
//     {
//       "Vet Name": "Dr. Mestry Gaurav R.",
//       "Clinic Name": "Exotic Pet Hospital"
//     },
//     {
//       "Vet Name": "Dr. Mhatre Milind",
//       "Clinic Name": "Complete Pet Care Clinic"
//     },
//     {
//       "Vet Name": "Dr. Mhatre Nilesh Baliram",
//       "Clinic Name": "Unspoken Care"
//     },
//     {
//       "Vet Name": "Dr. Mhatre Sandeepu",
//       "Clinic Name": "Ashtavinayak Pet Care Clinic"
//     },
//     {
//       "Vet Name": "Dr. Migri Subi",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Minz Shilpy Anupama",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Mirza Vaseem",
//       "Clinic Name": "Sanctuary Exotic Pet Referral & Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Missal Tejashree",
//       "Clinic Name": "Pet Health Clinic"
//     },
//     {
//       "Vet Name": "Dr. Mistry Kurush",
//       "Clinic Name": "Veterinary Medical & Surgical Centre"
//     },
//     {
//       "Vet Name": "Dr. Modi Vandan",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Mokal Ankur",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. More Shalaka",
//       "Clinic Name": "Vet4Amazing Pets"
//     },
//     {
//       "Vet Name": "Dr. More Shubhada Avinash",
//       "Clinic Name": "Urban Paws Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Moru Nisha Harishchandra",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Mudur Priya",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Mulla Fernaz",
//       "Clinic Name": "Dr. Fernaz’S Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Mullick Monika",
//       "Clinic Name": "Kimaya Vet Clinics"
//     },
//     {
//       "Vet Name": "Dr. Nadkarni Nameeta",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Nagarajan B.",
//       "Clinic Name": "Ballo Multi-Speciality Clinic"
//     },
//     {
//       "Vet Name": "Dr. Nagare Sachin",
//       "Clinic Name": "Dr. Nagares Animal Care Clinic"
//     },
//     {
//       "Vet Name": "Dr. Nagare Snehlata",
//       "Clinic Name": "Animal Care Clinic"
//     },
//     {
//       "Vet Name": "Dr. Naik Brijesh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Naik Purvi",
//       "Clinic Name": "Dr. Tulpule’S Pet Care Clinic"
//     },
//     {
//       "Vet Name": "Dr. Nair Ginesh C.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Nandedkar Vivek Mahesh",
//       "Clinic Name": "Dr. Vivek’S Pets Clinic"
//     },
//     {
//       "Vet Name": "Dr. Narad Ankur",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Naravi Yashaswi",
//       "Clinic Name": "Little Paws Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Nikale Nikita",
//       "Clinic Name": "Petclinic"
//     },
//     {
//       "Vet Name": "Dr. Niratle Vikram Madhukar",
//       "Clinic Name": "Dr. Vikrams Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Padmawar Rushikesh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Pai Shivangi",
//       "Clinic Name": "The Vet Yard (Work"
//     },
//     {
//       "Vet Name": "Dr. Pai Tanaya",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Palampalle Hirachand Y.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Panchal Sangameshwar D.",
//       "Clinic Name": "Creditable Pet Clinic & Shopee"
//     },
//     {
//       "Vet Name": "Dr. Panchala Kulkarni Sheetal",
//       "Clinic Name": "Pets N Vets"
//     },
//     {
//       "Vet Name": "Dr. Pandey Aradhana",
//       "Clinic Name": "Doggy World"
//     },
//     {
//       "Vet Name": "Dr. Pandey Vijay Kumar",
//       "Clinic Name": "Uday Pet Clinic N Care"
//     },
//     {
//       "Vet Name": "Dr. Pandit Dhananjay",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Panicker Sneha Surendra",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Pansare Santosh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Pansare Vinaykumar P.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Parab Babaji",
//       "Clinic Name": "Dr. Parab’S Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Parab Geeta",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Parab Vaibhav Pradeep",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Paranjpe Nilima",
//       "Clinic Name": "Dr. Nilima’S Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Pardhi Seema M",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Pardeshi Ameet Subhash",
//       "Clinic Name": "Dr. Ameet’S Animal Clinic"
//     },
//     {
//       "Vet Name": "Dr. Parekh Dwiti",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Parihar Ankush",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Parpani Jayneel",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Parulkar Amruta",
//       "Clinic Name": "Happy Tails Veterinary Specialty"
//     },
//     {
//       "Vet Name": "Dr. Patel Ashish",
//       "Clinic Name": "Dr. A.P.S’S Pet Clinic & Shop"
//     },
//     {
//       "Vet Name": "Dr. Patel Janki",
//       "Clinic Name": "The Companion Clinic 5"
//     },
//     {
//       "Vet Name": "Dr. Patel Nilesh Manilal",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Patel Ritesh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Patel Shailesh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Patel Sunita K.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Pathak Ankita",
//       "Clinic Name": "Amtm India Hospital"
//     },
//     {
//       "Vet Name": "Dr. Patil Amit",
//       "Clinic Name": "Relicare Vets"
//     },
//     {
//       "Vet Name": "Dr. Patil Anil",
//       "Clinic Name": "Dog Clinic"
//     },
//     {
//       "Vet Name": "Dr. Patil Atul Vishwas",
//       "Clinic Name": "Dynamic Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Patil Avinash",
//       "Clinic Name": "Pet Animal Clinic"
//     },
//     {
//       "Vet Name": "Dr. Patil D.K.",
//       "Clinic Name": "Vashi Dispensary: Navi Mumbai Animal Clinic And Pet Shop , Chembur Dispensary: Pet Cure Center And Pet Shop"
//     },
//     {
//       "Vet Name": "Dr. Patil Drona",
//       "Clinic Name": "Animal Health Care Centre"
//     },
//     {
//       "Vet Name": "Dr. Patil Jagadish H.",
//       "Clinic Name": "Animal Care Clinic"
//     },
//     {
//       "Vet Name": "Dr. Patil Kamalakar M.",
//       "Clinic Name": "Lotus Pet World: Clinic N Pet Shop 9"
//     },
//     {
//       "Vet Name": "Dr. Patil Manik",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Patil Manjusha G.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Patil Nilesh Ramesh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Patil Pradeep",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Patil Prashant J.",
//       "Clinic Name": "Datta Krupa Pet Shop & Clinic"
//     },
//     {
//       "Vet Name": "Dr. Patil Rahul B.",
//       "Clinic Name": "Dr. Patil’S Pet Shoppy & Dog Clinic"
//     },
//     {
//       "Vet Name": "Dr. Patil Rahul Jaywantrao",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Patil Sarang",
//       "Clinic Name": "Jijai Animal Clinic & Surgical Center"
//     },
//     {
//       "Vet Name": "Dr. Patil Satish L.",
//       "Clinic Name": "Central Vets Small Animal Clinic"
//     },
//     {
//       "Vet Name": "Dr. Patil Ujwala R.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Patil Vinayak Naresh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Patkar Rupali",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. (Prof. Paturkar Ashish",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Pawalkar Dhananjay A.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Pawar Hitesh N.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Pawar Laxman D.",
//       "Clinic Name": "Shreerut Pets Clinic"
//     },
//     {
//       "Vet Name": "Dr. Pawar Nitin G.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Pawar Parag J.",
//       "Clinic Name": "Dogs & Cats Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Pawar Vaibhav",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Pawaskar Onkar",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Pendkar Jagdish",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Pereira Pamela Jane",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Pethe Pradnya",
//       "Clinic Name": "Canids Veterinary Centre"
//     },
//     {
//       "Vet Name": "Dr. Pethe Shailesh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Pingle Manish S.",
//       "Clinic Name": "Pet'S Clinic"
//     },
//     {
//       "Vet Name": "Dr. Pinto Charmaine",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Pitroda Manisha",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Piyush Prashant",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Powar Komal",
//       "Clinic Name": "Dogs & Cats Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Prabhugaonkar Nikhil",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Prashar Niraj",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Pujari Nikita",
//       "Clinic Name": "Superpets-A Veterinary Multi-Speciality!"
//     },
//     {
//       "Vet Name": "Dr. Pundkar Snehal",
//       "Clinic Name": "God'S Grace Animal Clinic"
//     },
//     {
//       "Vet Name": "Dr. Raghuram Vibha",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Raibhan Madhuri Sunil",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Raibole Dharmraj P.",
//       "Clinic Name": "Pet Cure And Care Surgical Center"
//     },
//     {
//       "Vet Name": "Dr. Raibole Siddhi D.",
//       "Clinic Name": "Pet Cure And Care Surgical Centre"
//     },
//     {
//       "Vet Name": "Dr. Raina Shivangi",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Raj Prashaanti",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Rajadhyaksha Rajnigandha",
//       "Clinic Name": "Small Animal Clinic & Surgical Centre"
//     },
//     {
//       "Vet Name": "Dr. Rajadhyaksha Sanjeev",
//       "Clinic Name": "Small Animal Clinic & Surgical Centre"
//     },
//     {
//       "Vet Name": "Dr. Rajhans Madhura",
//       "Clinic Name": "Shivaji Park Animal Clinic"
//     },
//     {
//       "Vet Name": "Dr. Rajmane Prakash Gajanan",
//       "Clinic Name": "Shree Multi-Speciality Veterinary"
//     },
//     {
//       "Vet Name": "Dr. Raman Sahil",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Ramani Jairam",
//       "Clinic Name": "Pluto Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Ramanna Lakshmi Srinivasan",
//       "Clinic Name": "The Animal Care Clinic"
//     },
//     {
//       "Vet Name": "Dr. Rane Gaurav Uday",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Rane Suhas P.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Rathod Keyursinh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Raul Vivek",
//       "Clinic Name": "Mahim Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Raut Avinash Hanmant",
//       "Clinic Name": "Vets For Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Raut Milind T.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Ravikumar S.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Reddy Hemlata",
//       "Clinic Name": "Dr. Reddy'S Pet'S Clinic"
//     },
//     {
//       "Vet Name": "Dr. Reddy Shailendra",
//       "Clinic Name": "Dr. Reddy'S Pet'S Clinic"
//     },
//     {
//       "Vet Name": "Dr. Rohi Rajesh",
//       "Clinic Name": "Consultant, Indira Pet'S Clinic & Care Center"
//     },
//     {
//       "Vet Name": "Dr. S. Jeya Bharath",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Sabale Siddharth",
//       "Clinic Name": "Primex Specialized Veterinary Clinical Pathology"
//     },
//     {
//       "Vet Name": "Dr. Sable Uddhav",
//       "Clinic Name": "Purple Paws Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Sadekar Gautami Vinayak",
//       "Clinic Name": "Petrix, Dr Gautami'S Small Animal Clinic"
//     },
//     {
//       "Vet Name": "Dr. Sahare Rajesh L",
//       "Clinic Name": "Pet'S Corner Shop And Clinic"
//     },
//     {
//       "Vet Name": "Dr. Salvi Shardul S.",
//       "Clinic Name": "Sunlife Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Sanghavi Ami",
//       "Clinic Name": "Pets Paradise"
//     },
//     {
//       "Vet Name": "Dr. Sankhe Rahul",
//       "Clinic Name": "Pet World Dispensary"
//     },
//     {
//       "Vet Name": "Dr. Sansare Sandeep C.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Sarkar Radhika",
//       "Clinic Name": "Mighty Paws Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Sarkar Suranjan",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Sarode Amol",
//       "Clinic Name": "Newlife Pet Care Centre"
//     },
//     {
//       "Vet Name": "Dr. Sastry Varun",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Saudagar Snehal P.",
//       "Clinic Name": "Dogs'N' Pups Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Savla Yash",
//       "Clinic Name": "Superpets-A Veterinary Multi-Speciality!"
//     },
//     {
//       "Vet Name": "Dr. Sawant Vijay Tukaram",
//       "Clinic Name": "Dr.Sawant'S Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Sayed Mohammad Ali",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Shah Akshay J.",
//       "Clinic Name": "Acuvet Veterinary Speciality Clinic"
//     },
//     {
//       "Vet Name": "Dr. Shah Jinesh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Shah Shefali",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Shah Vengsarkar Sangeeta",
//       "Clinic Name": "Pawsitive Wellness Centre; Urban Pet; Alibaug Urban Pet Centre"
//     },
//     {
//       "Vet Name": "Dr. Shahid Vaseem S A",
//       "Clinic Name": "Cupa Animal Care Hospital"
//     },
//     {
//       "Vet Name": "Dr. Shanbhag Sachi Madhav",
//       "Clinic Name": "Animaux Clinique"
//     },
//     {
//       "Vet Name": "Dr. Shanmugam Jeya Bharath",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Sharma Bhanu Dev",
//       "Clinic Name": "Max Vets Animal Health Care"
//     },
//     {
//       "Vet Name": "Dr. Sharma Kunal Dev",
//       "Clinic Name": "Max Vets Animal Health Care"
//     },
//     {
//       "Vet Name": "Dr. Sharma R. T.",
//       "Clinic Name": "Pet Hospital & Boarding Shelter"
//     },
//     {
//       "Vet Name": "Dr. Sharma Shyam Z.",
//       "Clinic Name": "Vet Clinic For Pets"
//     },
//     {
//       "Vet Name": "Dr. Sharma Suneet",
//       "Clinic Name": "Ss Lifeline Veterinary Care"
//     },
//     {
//       "Vet Name": "Dr. Sharma Vikash Kumar",
//       "Clinic Name": "Animo Pet Care & Research Center"
//     },
//     {
//       "Vet Name": "Dr. Sharma Vishal",
//       "Clinic Name": "Pet'S Planet India"
//     },
//     {
//       "Vet Name": "Dr. Shelar Kiran R.",
//       "Clinic Name": "Central Vets Small Animal Clinic"
//     },
//     {
//       "Vet Name": "Dr. Shilvant Mayur",
//       "Clinic Name": "Pet Panorama Pets Clinic And Pet Shop"
//     },
//     {
//       "Vet Name": "Dr. Shinde Nilesh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Shinde Umesh",
//       "Clinic Name": "Top Vets Veterinary Speciality Clinic"
//     },
//     {
//       "Vet Name": "Dr. Shirsath Dhananjay H.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Shivprakash N B",
//       "Clinic Name": "Westend Speciality Petcare & Nursing Center"
//     },
//     {
//       "Vet Name": "Dr. Shringarpure Tanya",
//       "Clinic Name": "The Violet Vets"
//     },
//     {
//       "Vet Name": "Dr. Shukla Himanshu B.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Shukla Shubham",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Singh Avtar",
//       "Clinic Name": "Hatchi & Whisker Pet Care Clinic"
//     },
//     {
//       "Vet Name": "Dr. Singh Harmanddeep",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Singh Neelam D.",
//       "Clinic Name": "Dogs & Cats Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Singh Rajesh Kumar",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Singh Shrawan",
//       "Clinic Name": "Companion Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Singh Vikas",
//       "Clinic Name": "Dr. B B Singh Memorial Vikas Pet Care"
//     },
//     {
//       "Vet Name": "Dr. Singh Vivek",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Sneha Thakare Malpani",
//       "Clinic Name": "Happy Pets Vet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Sood Ajay",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Srikanth B. V.",
//       "Clinic Name": "Prakruthi Veterinary Hospital"
//     },
//     {
//       "Vet Name": "Dr. Subhedar Mohini S.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Suryawanshi Jadhav Sushma",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Swali Hitesh",
//       "Clinic Name": "Bloom Vet, Animal Care Center"
//     },
//     {
//       "Vet Name": "Dr. Swali Mili Kamlesh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Swali Parul Parpani",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Taiju Micha",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Talekar Shivaji",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Tambe Kundan",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Tamhankar Smita",
//       "Clinic Name": "Pet Bliss Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Tandel Shiwani D.",
//       "Clinic Name": "Phonix Veterinary Speciality"
//     },
//     {
//       "Vet Name": "Dr. Tasgaonkar Sanyal Ashok",
//       "Clinic Name": "Livestock Development Officer"
//     },
//     {
//       "Vet Name": "Dr. Tatelu Sneha Ramesh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Tayyab Attar",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Thade Gauri",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Thakkar Ekta",
//       "Clinic Name": "Pet Clinic, Kidney, Care And Dialysis Centre"
//     },
//     {
//       "Vet Name": "Dr. Thakur B. R.",
//       "Clinic Name": "Dr. Thakur’S Pet Hospital"
//     },
//     {
//       "Vet Name": "Dr. Thoke Sadashiv Shantaram",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Tiwari Ranjitha",
//       "Clinic Name": "Hope Animal Clinic"
//     },
//     {
//       "Vet Name": "Dr. Transadiya Kishor",
//       "Clinic Name": "Petplus Hospital"
//     },
//     {
//       "Vet Name": "Dr. Trindade Davina",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Tripathi Santoshmani",
//       "Clinic Name": "Happy Pets Clinic And Pet Care Centre"
//     },
//     {
//       "Vet Name": "Dr. Tulpule Deepak S.",
//       "Clinic Name": "Tulpule’S Pet Care Clinic"
//     },
//     {
//       "Vet Name": "Dr. Tyagi Rajnish",
//       "Clinic Name": "Tyagi Dog Hospital"
//     },
//     {
//       "Vet Name": "Dr. Ubhare Gauri Shivram",
//       "Clinic Name": "Hometown Veterinary Hospital"
//     },
//     {
//       "Vet Name": "Dr. Ukale Prabhakar Shivaji",
//       "Clinic Name": "Ukale Veterinary Pet Care Clinic"
//     },
//     {
//       "Vet Name": "Dr. Ukani Jenishkumar",
//       "Clinic Name": "Om Veterinary Hospital"
//     },
//     {
//       "Vet Name": "Dr. Ulemale Anil H.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Umale Nikhilashok",
//       "Clinic Name": "Petaid Dog And Cat Clinic"
//     },
//     {
//       "Vet Name": "Dr. Vade Anil",
//       "Clinic Name": "Vedant Pet Dispensary"
//     },
//     {
//       "Vet Name": "Dr. Vadnere Narendra B.",
//       "Clinic Name": "Shriyash Petcare Centre"
//     },
//     {
//       "Vet Name": "Dr. Vaishnav Devanshi",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Vaswani Prerna",
//       "Clinic Name": "The Pet Vet"
//     },
//     {
//       "Vet Name": "Dr. Vedpathak Chandrakant P.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Vedpathak Hareshwar",
//       "Clinic Name": "K-9 Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Velisetty Ashok Kumar",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Vende Sachin S.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Venkatachalam Aruna",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Venkatraman Kadambari",
//       "Clinic Name": "Olive'S Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Verlekar Tushar",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Vidhate Pritesh Shivaji",
//       "Clinic Name": "Shivraj Pet Clinic & Lab"
//     },
//     {
//       "Vet Name": "Dr. Vidhate Shivaji Bhimaji",
//       "Clinic Name": "Shivraj Pet Clinic & Lab"
//     },
//     {
//       "Vet Name": "Dr. Viegas Aneesh",
//       "Clinic Name": "Viegas Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Viegas Jenny",
//       "Clinic Name": "Viegas Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Vinherkar Dinesh Janardan",
//       "Clinic Name": "Dr. Vinherkar’S Pet Health Clinic"
//     },
//     {
//       "Vet Name": "Dr. Virkar Shankar",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Vishwasrao Madhura",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Vishwasrao Shriniwas",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Wadke Sunetra Shreeniwas",
//       "Clinic Name": "Dr. Sunetra'S Petvet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Waghmale Shailendra G.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Wakankar C. C.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Wakankar Neha",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Wakle Sagar Shashikant",
//       "Clinic Name": "Newlife Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Walavalkar Sailee",
//       "Clinic Name": "Pet Matters"
//     },
//     {
//       "Vet Name": "Dr. Wangikar Vinay",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Wavhal Shrikrishna",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Yadav Girish Udhavrao",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Yadav Krishna Kumar R.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Yadav Santosh V.",
//       "Clinic Name": "Vedant Medical"
//     },
//     {
//       "Vet Name": "Dr. Yadav Satish Ramchandra",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Yagnik Ninad",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Yamgar Amol",
//       "Clinic Name": "Dr. Amol'S Small Animal Surgery & Health Care"
//     },
//     {
//       "Vet Name": "Dr. Adsul Abhishek P.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Aher Arun",
//       "Clinic Name": "Dr. Aher'S Pet Care Centre"
//     },
//     {
//       "Vet Name": "Dr. Ahire Sanjay Bansilal",
//       "Clinic Name": "Pet Life Care Clinic"
//     },
//     {
//       "Vet Name": "Dr. Ahire Sumit S.",
//       "Clinic Name": "Pet Life Care Clinic"
//     },
//     {
//       "Vet Name": "Dr. Akbar Siddiq E",
//       "Clinic Name": "The Blue Ridge Pet Speciality"
//     },
//     {
//       "Vet Name": "Dr. Akole M. T.",
//       "Clinic Name": "Pets Land"
//     },
//     {
//       "Vet Name": "Dr. Anam Aprajita",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Anand R. K.",
//       "Clinic Name": "Dr. Anand'S Pets Clinic"
//     },
//     {
//       "Vet Name": "Dr. Anturkar Kaustubh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Arunachalam T. M.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Athale Rasika",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Ausarikar Shruti",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Aware Nilam",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Bagul Abhishek",
//       "Clinic Name": "Pro Life Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Banerji Indrakshi",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Baney Lochana",
//       "Clinic Name": "Gordon-Jut Fur Dogs"
//     },
//     {
//       "Vet Name": "Dr. Barros Gail",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Bhadane C. P.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Bhambhani Mitali",
//       "Clinic Name": "Urban Pet Centre"
//     },
//     {
//       "Vet Name": "Dr. Bharucha Rustam K.",
//       "Clinic Name": "The Homestead"
//     },
//     {
//       "Vet Name": "Dr. Bhattacharjya Rishov",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Bhoir Pritam Subhash",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Bhokare Suhas",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Bhosle Pradip Prakashrao",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Prof. Birade Hemant",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Buduk Shreya",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Camara Adrian",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Carol Anne Misquitta",
//       "Clinic Name": "Petz Life Care Center"
//     },
//     {
//       "Vet Name": "Dr. Chaliha Chandika",
//       "Clinic Name": "Pawparazzy Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Chandramohan T.G.",
//       "Clinic Name": "Scientific Remedies Pvt Ltd"
//     },
//     {
//       "Vet Name": "Dr. Channey Prashant P.",
//       "Clinic Name": "Petozone Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Chatterjee Chandan",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Chawan Soniya Sameer",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Chawla Ghazal",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Couto Natasha",
//       "Clinic Name": "Dr. Natasha’S Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Dabar Abhishek",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Dalvi Kunal Vasant",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Dalvi Subhash",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Dalvie Arundhati",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Dangar Mayur",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Dangle Vishal",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Das Debajani",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Dave Anjali",
//       "Clinic Name": "Petcetera Small Animal Clinic"
//     },
//     {
//       "Vet Name": "Dr. De Dipak Kumar",
//       "Clinic Name": "Calcutta Canine Clinic 21A"
//     },
//     {
//       "Vet Name": "Dr. Deori Gitanjali",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Dhar Priya",
//       "Clinic Name": "Dr. Hitesh Swali’S Animal Care"
//     },
//     {
//       "Vet Name": "Dr. Dixit Makarand",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Dodke Rupesh",
//       "Clinic Name": "Dr. Dodke’S Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Doiphode Ujwala",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Domb Ketaki",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Dorwani Amrish",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Dubey Dinesh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Dumbrey Rajesh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Dusane Jayesh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Gaikwad Sandeep",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Gaikwad Sanjay",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Gaikwad Santosh",
//       "Clinic Name": "Dog And Cat Clinic \"Vithai"
//     },
//     {
//       "Vet Name": "Dr. Gaikwad Sneha Sunil",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Gatne Madhumanjiri",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Gawand Riya",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Ghaisas Anushree S.",
//       "Clinic Name": "The Pet Vet"
//     },
//     {
//       "Vet Name": "Dr. Gharat Rohit",
//       "Clinic Name": "Anicare Clinic"
//     },
//     {
//       "Vet Name": "Dr. Ghodeswar Nidhi Anil",
//       "Clinic Name": "Dr. Nidhi’S Ark Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Ghorui Ankan",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Gokhale Rashmi Shriram",
//       "Clinic Name": "Centre For Animal Population Studies (Caps"
//     },
//     {
//       "Vet Name": "Dr. Golatkar Vivek A",
//       "Clinic Name": "Caring Hands Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Gulati Mahima",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Gulvady Akshata",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Gupta Falguni",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Gurav Aishwarya",
//       "Clinic Name": "Sunlife Veterinary Care"
//     },
//     {
//       "Vet Name": "Dr. Gaurav Gurav",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Hajare Sonal Raju",
//       "Clinic Name": "Vedant Pet Dispensary"
//     },
//     {
//       "Vet Name": "Dr. Haveri Gowri",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Ingale Supriya",
//       "Clinic Name": "Pet Aid Clinic"
//     },
//     {
//       "Vet Name": "Dr. Jadhav Pradeep",
//       "Clinic Name": "Surabhi Pet’S Clinic"
//     },
//     {
//       "Vet Name": "Dr. Jadhav Subhash",
//       "Clinic Name": "Cure & Care Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Jadhav Vrushalialjit",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Jagannathan Lakshmikripa",
//       "Clinic Name": "Paws And Claws Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Jamir Akum",
//       "Clinic Name": "Vets Care Polyclinic"
//     },
//     {
//       "Vet Name": "Dr. Jhaveri Vani",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Josan Jasjeet",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Joseph Tista",
//       "Clinic Name": "Petcetera Small Animal Clinic"
//     },
//     {
//       "Vet Name": "Dr. Joshi Preeti",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kadam D. P.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kadu Pooja V.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kaprekar Atharva",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kasundra Rahul C.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kelawala Divyesh N.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kenjale Lalit",
//       "Clinic Name": "Revive Veterinary Specialty & Neko Cat Clinic"
//     },
//     {
//       "Vet Name": "Dr. Keshavprasad Pal Rahul",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Khade Jagtap Asmita S.",
//       "Clinic Name": "Shakehands Vet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Khajuria Amit",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Khajuria Bhanu Kirti",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Khangal Prakash",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kharat Ashishkumar S.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Khavnekar Nidhi A.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Khuje Neerad V.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kodange Omkar",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kshirsagar Arun D.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kubde Mukta Giridhar",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kulashrestha Indresh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Kumar Kaushlendra",
//       "Clinic Name": "Shrinathji Pets Clinic"
//     },
//     {
//       "Vet Name": "Dr. Lal Smriti",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Lobo Andrea R.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Lohith",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Lokare Divyaratn Suresh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Madane Shailesh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Madireddi Anoohya",
//       "Clinic Name": "Canfel Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Mahajan Ashish",
//       "Clinic Name": "Pet Wellness Clinic"
//     },
//     {
//       "Vet Name": "Dr. Mahajan Pramod Sitaram",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Mahajan Smita",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Mali Kiran Hari",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Malkar Shri Vilas",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Mandhare Shivam",
//       "Clinic Name": "Vetprodx Veterinary Diagnostics"
//     },
//     {
//       "Vet Name": "Dr. Mandhwani Ritika",
//       "Clinic Name": "The Eye Vet"
//     },
//     {
//       "Vet Name": "Dr. Mandovera Vijaykumar",
//       "Clinic Name": "Sri Sai Pets Speciality Clinic"
//     },
//     {
//       "Vet Name": "Dr. Mane Ashish",
//       "Clinic Name": "Alva - Animal Care Clinic"
//     },
//     {
//       "Vet Name": "Dr. Mane Sneha",
//       "Clinic Name": "The Welfare Of Stray Dogs (Wsd"
//     },
//     {
//       "Vet Name": "Dr. Manish Saurabh",
//       "Clinic Name": "Shri Mahesh Animal Care & Dog Surgery"
//     },
//     {
//       "Vet Name": "Dr. Markandeywar Kasturi",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Marwah Kailash",
//       "Clinic Name": "Small Animal Clinic 1, Small Animal Clinic 2"
//     },
//     {
//       "Vet Name": "Dr. Maske Rohit",
//       "Clinic Name": "Little Paws Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Mastakar Nikita",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Mehta Nikhil",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Mendes Tanisha",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Meshram Rahul",
//       "Clinic Name": "Dr. Rahul'S Pet Health Clinic"
//     },
//     {
//       "Vet Name": "Dr. Muley Vijay",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Mulluk Shashikant",
//       "Clinic Name": "Happy Paws Nx Pet Clinic, Happy Paws Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Mumbarkar Neha",
//       "Clinic Name": "Wildvets Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Mundekar Akash",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Nabarka Chanda",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Nadkarni Pranjal",
//       "Clinic Name": "Pet Physio Pro"
//     },
//     {
//       "Vet Name": "Dr. Nandedkar Vivek",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Nehete Janhavi Milan",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Pachisia Mamta",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Padave Sudarshan",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Paghdhar Dhara",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Pandey Nitin",
//       "Clinic Name": "Nextdoor Vets"
//     },
//     {
//       "Vet Name": "Dr. Pandey Vimal",
//       "Clinic Name": "Supreme Pet Clinic And Care Centre"
//     },
//     {
//       "Vet Name": "Dr. Parab Latika",
//       "Clinic Name": "Prime Paws Pet Clinic And Grooming Centre"
//     },
//     {
//       "Vet Name": "Dr. Pardeshi Narendra R.",
//       "Clinic Name": "Small Animal Clinic"
//     },
//     {
//       "Vet Name": "Dr. Parmar Chetan",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Parulekar Esha",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Patel Bhavik D",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Patel Nisha",
//       "Clinic Name": "Pet Mantra Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Patel Yash",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Patil Bhavna B.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Patil Girish",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Patil Harshwardhan",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Patil Jagdish Narayan",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Patil Nikita Nitin",
//       "Clinic Name": "Nik’S Vet Care"
//     },
//     {
//       "Vet Name": "Dr. Patil Nilesh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Patil Vijay",
//       "Clinic Name": "Vasai Multispeciality Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Paul Purabi G.",
//       "Clinic Name": "Good Health Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Pawar Ashish",
//       "Clinic Name": "Suyash Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Pawar P. T.",
//       "Clinic Name": "Modern Dog, Cat Hospital And Article'S"
//     },
//     {
//       "Vet Name": "Dr. Pawar Pratik",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Pawara Ashwini",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Pendharkar Gandhar",
//       "Clinic Name": "Pet Aid Clinic"
//     },
//     {
//       "Vet Name": "Dr. Pinto Vanessa",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Pitale Chetana",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Pore Ajay",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Poyrekar Ankita",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Prasenna K.",
//       "Clinic Name": "Petvets"
//     },
//     {
//       "Vet Name": "Dr. Prateek Ravipati Sai",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. R. Aishwarya",
//       "Clinic Name": "Revive Veterinary Speciality & Neko Cat Clinic"
//     },
//     {
//       "Vet Name": "Dr. Raikar Priyanka Manjunath",
//       "Clinic Name": "Top Dog Pets Clinic"
//     },
//     {
//       "Vet Name": "Dr. Rai Deoyani",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Rajmane Shubhangi",
//       "Clinic Name": "My Pet’S World Pets Clinic"
//     },
//     {
//       "Vet Name": "Dr. Ramteke Rina R.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Ramya",
//       "Clinic Name": "V Care Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Rangnekar Mahesh N.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Rao Rashmi",
//       "Clinic Name": "Tailwaggerz"
//     },
//     {
//       "Vet Name": "Dr. Raote Richa",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Raut Satish Gajanan",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Raval Janak",
//       "Clinic Name": "Dr. Janak Raval'S Pet Clinic & Spa"
//     },
//     {
//       "Vet Name": "Dr. Raval Neela Janakkumar",
//       "Clinic Name": "Dr. Janak Raval’S Pet Clinic & Spa"
//     },
//     {
//       "Vet Name": "Dr. Rego Nicole",
//       "Clinic Name": "Happy Tails"
//     },
//     {
//       "Vet Name": "Dr. Rustomjee Tina",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Sable Swapnali",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Sabnis Shambhavi A.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Salins Supriya",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Salvi Santosh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Sardana Gaurav",
//       "Clinic Name": "Sunlife Veterinary Care"
//     },
//     {
//       "Vet Name": "Dr. Sardar Omkar M.",
//       "Clinic Name": "Veterinary Healthcare Center"
//     },
//     {
//       "Vet Name": "Dr. Sathe Priti",
//       "Clinic Name": "Himi’S Bark Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Sawant Gauri",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Sawant Mahesh K.",
//       "Clinic Name": "Madhura Pet Zone"
//     },
//     {
//       "Vet Name": "Dr. Sawant Niharika",
//       "Clinic Name": "Crownvet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Sawant Prachi S.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Seshadri Sujit",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Shah Khushbu",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Shah Neha",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Shah Nirali",
//       "Clinic Name": "Top Dog Pets Clinic"
//     },
//     {
//       "Vet Name": "Dr. Sharma Abhishek",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Sharma Hridayesh",
//       "Clinic Name": "Dr Bapats Pet Animal Hospital"
//     },
//     {
//       "Vet Name": "Dr. Shejal Nilesh",
//       "Clinic Name": "Petbond Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Shete Nakul",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Shihabudheen P. K.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Shingateri Nidhi",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Shirsat Mohini",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Shringi Archana",
//       "Clinic Name": "Sri Sai Pets Speciality Clinic"
//     },
//     {
//       "Vet Name": "Dr. Simoes Michelle",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Singh Rakesh",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Singh Riddhi Omnarayan",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Singh Shilpi",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Singhal Sanjay",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Sonune Dilip",
//       "Clinic Name": "Animedics Health India Pvt Ltd"
//     },
//     {
//       "Vet Name": "Dr. Soorej",
//       "Clinic Name": "The Cochin Pet Hospital"
//     },
//     {
//       "Vet Name": "Dr. Sopte Yogita Vila",
//       "Clinic Name": "Dogs And Cats Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Supriya",
//       "Clinic Name": "Jeeva Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Sureshkumar Ashwini",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Surve Vishal",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Surwase Uttareshwar N",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Suryawanshi Deepak S.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Swadi Krutika",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Swami Advait Milind",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Tambe Kajal",
//       "Clinic Name": "Onkar Pawaskar’S Pet Clinic & Hospital"
//     },
//     {
//       "Vet Name": "Dr. Tari Chubita",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Thakur Dhruv",
//       "Clinic Name": "Superpets Small Animal Clinic"
//     },
//     {
//       "Vet Name": "Dr. Thakur Pooja",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Thamayanthi S.",
//       "Clinic Name": "Paws And Claws Pet Clinic"
//     },
//     {
//       "Vet Name": "Dr. Thange Hemant Pradip",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Thomas Eunice",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Thorat Ganesh C",
//       "Clinic Name": "Pet Well Soon Clinic & Surgical Center"
//     },
//     {
//       "Vet Name": "Dr. Tiwari Anisha",
//       "Clinic Name": "Suvidha Derma Centre, The Hill City Cat Clinic, Suvidha Vet Care And Research Centre Multispeciality"
//     },
//     {
//       "Vet Name": "Dr. Todkar Shrikant",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Tripathi Sanjay",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Tulpule Pooja",
//       "Clinic Name": "Tulpule’S Pet Care Clinic"
//     },
//     {
//       "Vet Name": "Dr. Ubale Akshata",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Vaishnav Hariom",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Vanjari Chetan",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Varun V.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Vasudeo Deep",
//       "Clinic Name": "Petzone"
//     },
//     {
//       "Vet Name": "Dr. Vedpathak Aakash",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Vijayan Gokul",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Vishwanath K",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Wadke Prashant",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Walters Avril",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Ware Pranav R",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Yamgar Aakash H",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Yamgar Vikas H.",
//       "Clinic Name": "Dogs And Cats Veterinary Clinic"
//     },
//     {
//       "Vet Name": "Dr. Karabasappa Gurannavar",
//       "Clinic Name": "Lucky Paws Veterinary Hospital"
//     },
//     {
//       "Vet Name": "Dr. Komatwar Sandeep J.",
//       "Clinic Name": ""
//     },
//     {
//       "Vet Name": "Dr. Patel Nil",
//       "Clinic Name": "Happy Tails Pets And Exotics Clinic"
//     }
//   ])



// }